var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
function bind(fn, thisArg) {
  return function wrap() {
    return fn.apply(thisArg, arguments);
  };
}
const { toString } = Object.prototype;
const { getPrototypeOf } = Object;
const kindOf = /* @__PURE__ */ ((cache) => (thing) => {
  const str = toString.call(thing);
  return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null));
const kindOfTest = (type) => {
  type = type.toLowerCase();
  return (thing) => kindOf(thing) === type;
};
const typeOfTest = (type) => (thing) => typeof thing === type;
const { isArray } = Array;
const isUndefined = typeOfTest("undefined");
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
const isArrayBuffer = kindOfTest("ArrayBuffer");
function isArrayBufferView(val) {
  let result;
  if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && isArrayBuffer(val.buffer);
  }
  return result;
}
const isString = typeOfTest("string");
const isFunction = typeOfTest("function");
const isNumber = typeOfTest("number");
const isObject = (thing) => thing !== null && typeof thing === "object";
const isBoolean = (thing) => thing === true || thing === false;
const isPlainObject = (val) => {
  if (kindOf(val) !== "object") {
    return false;
  }
  const prototype2 = getPrototypeOf(val);
  return (prototype2 === null || prototype2 === Object.prototype || Object.getPrototypeOf(prototype2) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
const isDate = kindOfTest("Date");
const isFile = kindOfTest("File");
const isBlob = kindOfTest("Blob");
const isFileList = kindOfTest("FileList");
const isStream = (val) => isObject(val) && isFunction(val.pipe);
const isFormData = (thing) => {
  let kind;
  return thing && (typeof FormData === "function" && thing instanceof FormData || isFunction(thing.append) && ((kind = kindOf(thing)) === "formdata" || // detect form-data instance
  kind === "object" && isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
const isURLSearchParams = kindOfTest("URLSearchParams");
const trim = (str) => str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function forEach(obj, fn, { allOwnKeys = false } = {}) {
  if (obj === null || typeof obj === "undefined") {
    return;
  }
  let i;
  let l;
  if (typeof obj !== "object") {
    obj = [obj];
  }
  if (isArray(obj)) {
    for (i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
    const len = keys.length;
    let key;
    for (i = 0; i < len; i++) {
      key = keys[i];
      fn.call(null, obj[key], key, obj);
    }
  }
}
function findKey(obj, key) {
  key = key.toLowerCase();
  const keys = Object.keys(obj);
  let i = keys.length;
  let _key;
  while (i-- > 0) {
    _key = keys[i];
    if (key === _key.toLowerCase()) {
      return _key;
    }
  }
  return null;
}
const _global = (() => {
  if (typeof globalThis !== "undefined")
    return globalThis;
  return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : global;
})();
const isContextDefined = (context) => !isUndefined(context) && context !== _global;
function merge() {
  const { caseless } = isContextDefined(this) && this || {};
  const result = {};
  const assignValue = (val, key) => {
    const targetKey = caseless && findKey(result, key) || key;
    if (isPlainObject(result[targetKey]) && isPlainObject(val)) {
      result[targetKey] = merge(result[targetKey], val);
    } else if (isPlainObject(val)) {
      result[targetKey] = merge({}, val);
    } else if (isArray(val)) {
      result[targetKey] = val.slice();
    } else {
      result[targetKey] = val;
    }
  };
  for (let i = 0, l = arguments.length; i < l; i++) {
    arguments[i] && forEach(arguments[i], assignValue);
  }
  return result;
}
const extend = (a, b, thisArg, { allOwnKeys } = {}) => {
  forEach(b, (val, key) => {
    if (thisArg && isFunction(val)) {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  }, { allOwnKeys });
  return a;
};
const stripBOM = (content) => {
  if (content.charCodeAt(0) === 65279) {
    content = content.slice(1);
  }
  return content;
};
const inherits = (constructor, superConstructor, props, descriptors2) => {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors2);
  constructor.prototype.constructor = constructor;
  Object.defineProperty(constructor, "super", {
    value: superConstructor.prototype
  });
  props && Object.assign(constructor.prototype, props);
};
const toFlatObject = (sourceObj, destObj, filter2, propFilter) => {
  let props;
  let i;
  let prop;
  const merged = {};
  destObj = destObj || {};
  if (sourceObj == null)
    return destObj;
  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = filter2 !== false && getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter2 || filter2(sourceObj, destObj)) && sourceObj !== Object.prototype);
  return destObj;
};
const endsWith = (str, searchString, position) => {
  str = String(str);
  if (position === void 0 || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  const lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
};
const toArray = (thing) => {
  if (!thing)
    return null;
  if (isArray(thing))
    return thing;
  let i = thing.length;
  if (!isNumber(i))
    return null;
  const arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
};
const isTypedArray = /* @__PURE__ */ ((TypedArray) => {
  return (thing) => {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== "undefined" && getPrototypeOf(Uint8Array));
const forEachEntry = (obj, fn) => {
  const generator = obj && obj[Symbol.iterator];
  const iterator = generator.call(obj);
  let result;
  while ((result = iterator.next()) && !result.done) {
    const pair = result.value;
    fn.call(obj, pair[0], pair[1]);
  }
};
const matchAll = (regExp, str) => {
  let matches;
  const arr = [];
  while ((matches = regExp.exec(str)) !== null) {
    arr.push(matches);
  }
  return arr;
};
const isHTMLForm = kindOfTest("HTMLFormElement");
const toCamelCase = (str) => {
  return str.toLowerCase().replace(
    /[-_\s]([a-z\d])(\w*)/g,
    function replacer(m, p1, p2) {
      return p1.toUpperCase() + p2;
    }
  );
};
const hasOwnProperty = (({ hasOwnProperty: hasOwnProperty2 }) => (obj, prop) => hasOwnProperty2.call(obj, prop))(Object.prototype);
const isRegExp = kindOfTest("RegExp");
const reduceDescriptors = (obj, reducer) => {
  const descriptors2 = Object.getOwnPropertyDescriptors(obj);
  const reducedDescriptors = {};
  forEach(descriptors2, (descriptor, name) => {
    let ret;
    if ((ret = reducer(descriptor, name, obj)) !== false) {
      reducedDescriptors[name] = ret || descriptor;
    }
  });
  Object.defineProperties(obj, reducedDescriptors);
};
const freezeMethods = (obj) => {
  reduceDescriptors(obj, (descriptor, name) => {
    if (isFunction(obj) && ["arguments", "caller", "callee"].indexOf(name) !== -1) {
      return false;
    }
    const value = obj[name];
    if (!isFunction(value))
      return;
    descriptor.enumerable = false;
    if ("writable" in descriptor) {
      descriptor.writable = false;
      return;
    }
    if (!descriptor.set) {
      descriptor.set = () => {
        throw Error("Can not rewrite read-only method '" + name + "'");
      };
    }
  });
};
const toObjectSet = (arrayOrString, delimiter) => {
  const obj = {};
  const define = (arr) => {
    arr.forEach((value) => {
      obj[value] = true;
    });
  };
  isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
  return obj;
};
const noop = () => {
};
const toFiniteNumber = (value, defaultValue) => {
  value = +value;
  return Number.isFinite(value) ? value : defaultValue;
};
const ALPHA = "abcdefghijklmnopqrstuvwxyz";
const DIGIT = "0123456789";
const ALPHABET = {
  DIGIT,
  ALPHA,
  ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
};
const generateString = (size = 16, alphabet = ALPHABET.ALPHA_DIGIT) => {
  let str = "";
  const { length } = alphabet;
  while (size--) {
    str += alphabet[Math.random() * length | 0];
  }
  return str;
};
function isSpecCompliantForm(thing) {
  return !!(thing && isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const toJSONObject = (obj) => {
  const stack = new Array(10);
  const visit = (source, i) => {
    if (isObject(source)) {
      if (stack.indexOf(source) >= 0) {
        return;
      }
      if (!("toJSON" in source)) {
        stack[i] = source;
        const target = isArray(source) ? [] : {};
        forEach(source, (value, key) => {
          const reducedValue = visit(value, i + 1);
          !isUndefined(reducedValue) && (target[key] = reducedValue);
        });
        stack[i] = void 0;
        return target;
      }
    }
    return source;
  };
  return visit(obj, 0);
};
const isAsyncFn = kindOfTest("AsyncFunction");
const isThenable = (thing) => thing && (isObject(thing) || isFunction(thing)) && isFunction(thing.then) && isFunction(thing.catch);
const utils$1 = {
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isBoolean,
  isObject,
  isPlainObject,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isRegExp,
  isFunction,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach,
  merge,
  extend,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty,
  hasOwnProp: hasOwnProperty,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  ALPHABET,
  generateString,
  isSpecCompliantForm,
  toJSONObject,
  isAsyncFn,
  isThenable
};
function AxiosError(message, code, config, request, response) {
  Error.call(this);
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  } else {
    this.stack = new Error().stack;
  }
  this.message = message;
  this.name = "AxiosError";
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}
utils$1.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: utils$1.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const prototype$1 = AxiosError.prototype;
const descriptors = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((code) => {
  descriptors[code] = { value: code };
});
Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype$1, "isAxiosError", { value: true });
AxiosError.from = (error, code, config, request, response, customProps) => {
  const axiosError = Object.create(prototype$1);
  utils$1.toFlatObject(error, axiosError, function filter2(obj) {
    return obj !== Error.prototype;
  }, (prop) => {
    return prop !== "isAxiosError";
  });
  AxiosError.call(axiosError, error.message, code, config, request, response);
  axiosError.cause = error;
  axiosError.name = error.name;
  customProps && Object.assign(axiosError, customProps);
  return axiosError;
};
const httpAdapter = null;
function isVisitable(thing) {
  return utils$1.isPlainObject(thing) || utils$1.isArray(thing);
}
function removeBrackets(key) {
  return utils$1.endsWith(key, "[]") ? key.slice(0, -2) : key;
}
function renderKey(path, key, dots) {
  if (!path)
    return key;
  return path.concat(key).map(function each(token, i) {
    token = removeBrackets(token);
    return !dots && i ? "[" + token + "]" : token;
  }).join(dots ? "." : "");
}
function isFlatArray(arr) {
  return utils$1.isArray(arr) && !arr.some(isVisitable);
}
const predicates = utils$1.toFlatObject(utils$1, {}, null, function filter(prop) {
  return /^is[A-Z]/.test(prop);
});
function toFormData(obj, formData, options) {
  if (!utils$1.isObject(obj)) {
    throw new TypeError("target must be an object");
  }
  formData = formData || new FormData();
  options = utils$1.toFlatObject(options, {
    metaTokens: true,
    dots: false,
    indexes: false
  }, false, function defined(option, source) {
    return !utils$1.isUndefined(source[option]);
  });
  const metaTokens = options.metaTokens;
  const visitor = options.visitor || defaultVisitor;
  const dots = options.dots;
  const indexes = options.indexes;
  const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
  const useBlob = _Blob && utils$1.isSpecCompliantForm(formData);
  if (!utils$1.isFunction(visitor)) {
    throw new TypeError("visitor must be a function");
  }
  function convertValue(value) {
    if (value === null)
      return "";
    if (utils$1.isDate(value)) {
      return value.toISOString();
    }
    if (!useBlob && utils$1.isBlob(value)) {
      throw new AxiosError("Blob is not supported. Use a Buffer instead.");
    }
    if (utils$1.isArrayBuffer(value) || utils$1.isTypedArray(value)) {
      return useBlob && typeof Blob === "function" ? new Blob([value]) : Buffer.from(value);
    }
    return value;
  }
  function defaultVisitor(value, key, path) {
    let arr = value;
    if (value && !path && typeof value === "object") {
      if (utils$1.endsWith(key, "{}")) {
        key = metaTokens ? key : key.slice(0, -2);
        value = JSON.stringify(value);
      } else if (utils$1.isArray(value) && isFlatArray(value) || (utils$1.isFileList(value) || utils$1.endsWith(key, "[]")) && (arr = utils$1.toArray(value))) {
        key = removeBrackets(key);
        arr.forEach(function each(el, index) {
          !(utils$1.isUndefined(el) || el === null) && formData.append(
            // eslint-disable-next-line no-nested-ternary
            indexes === true ? renderKey([key], index, dots) : indexes === null ? key : key + "[]",
            convertValue(el)
          );
        });
        return false;
      }
    }
    if (isVisitable(value)) {
      return true;
    }
    formData.append(renderKey(path, key, dots), convertValue(value));
    return false;
  }
  const stack = [];
  const exposedHelpers = Object.assign(predicates, {
    defaultVisitor,
    convertValue,
    isVisitable
  });
  function build(value, path) {
    if (utils$1.isUndefined(value))
      return;
    if (stack.indexOf(value) !== -1) {
      throw Error("Circular reference detected in " + path.join("."));
    }
    stack.push(value);
    utils$1.forEach(value, function each(el, key) {
      const result = !(utils$1.isUndefined(el) || el === null) && visitor.call(
        formData,
        el,
        utils$1.isString(key) ? key.trim() : key,
        path,
        exposedHelpers
      );
      if (result === true) {
        build(el, path ? path.concat(key) : [key]);
      }
    });
    stack.pop();
  }
  if (!utils$1.isObject(obj)) {
    throw new TypeError("data must be an object");
  }
  build(obj);
  return formData;
}
function encode$1(str) {
  const charMap = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
    return charMap[match];
  });
}
function AxiosURLSearchParams(params, options) {
  this._pairs = [];
  params && toFormData(params, this, options);
}
const prototype = AxiosURLSearchParams.prototype;
prototype.append = function append(name, value) {
  this._pairs.push([name, value]);
};
prototype.toString = function toString2(encoder) {
  const _encode = encoder ? function(value) {
    return encoder.call(this, value, encode$1);
  } : encode$1;
  return this._pairs.map(function each(pair) {
    return _encode(pair[0]) + "=" + _encode(pair[1]);
  }, "").join("&");
};
function encode(val) {
  return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function buildURL(url, params, options) {
  if (!params) {
    return url;
  }
  const _encode = options && options.encode || encode;
  const serializeFn = options && options.serialize;
  let serializedParams;
  if (serializeFn) {
    serializedParams = serializeFn(params, options);
  } else {
    serializedParams = utils$1.isURLSearchParams(params) ? params.toString() : new AxiosURLSearchParams(params, options).toString(_encode);
  }
  if (serializedParams) {
    const hashmarkIndex = url.indexOf("#");
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
  }
  return url;
}
class InterceptorManager {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(fulfilled, rejected, options) {
    this.handlers.push({
      fulfilled,
      rejected,
      synchronous: options ? options.synchronous : false,
      runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(id) {
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    if (this.handlers) {
      this.handlers = [];
    }
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(fn) {
    utils$1.forEach(this.handlers, function forEachHandler(h) {
      if (h !== null) {
        fn(h);
      }
    });
  }
}
const transitionalDefaults = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};
const URLSearchParams$1 = typeof URLSearchParams !== "undefined" ? URLSearchParams : AxiosURLSearchParams;
const FormData$1 = typeof FormData !== "undefined" ? FormData : null;
const Blob$1 = typeof Blob !== "undefined" ? Blob : null;
const platform$1 = {
  isBrowser: true,
  classes: {
    URLSearchParams: URLSearchParams$1,
    FormData: FormData$1,
    Blob: Blob$1
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
};
const hasBrowserEnv = typeof window !== "undefined" && typeof document !== "undefined";
const hasStandardBrowserEnv = ((product) => {
  return hasBrowserEnv && ["ReactNative", "NativeScript", "NS"].indexOf(product) < 0;
})(typeof navigator !== "undefined" && navigator.product);
const hasStandardBrowserWebWorkerEnv = (() => {
  return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
  self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
const utils = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv,
  hasStandardBrowserEnv,
  hasStandardBrowserWebWorkerEnv
}, Symbol.toStringTag, { value: "Module" }));
const platform = {
  ...utils,
  ...platform$1
};
function toURLEncodedForm(data, options) {
  return toFormData(data, new platform.classes.URLSearchParams(), Object.assign({
    visitor: function(value, key, path, helpers2) {
      if (platform.isNode && utils$1.isBuffer(value)) {
        this.append(key, value.toString("base64"));
        return false;
      }
      return helpers2.defaultVisitor.apply(this, arguments);
    }
  }, options));
}
function parsePropPath(name) {
  return utils$1.matchAll(/\w+|\[(\w*)]/g, name).map((match) => {
    return match[0] === "[]" ? "" : match[1] || match[0];
  });
}
function arrayToObject(arr) {
  const obj = {};
  const keys = Object.keys(arr);
  let i;
  const len = keys.length;
  let key;
  for (i = 0; i < len; i++) {
    key = keys[i];
    obj[key] = arr[key];
  }
  return obj;
}
function formDataToJSON(formData) {
  function buildPath(path, value, target, index) {
    let name = path[index++];
    if (name === "__proto__")
      return true;
    const isNumericKey = Number.isFinite(+name);
    const isLast = index >= path.length;
    name = !name && utils$1.isArray(target) ? target.length : name;
    if (isLast) {
      if (utils$1.hasOwnProp(target, name)) {
        target[name] = [target[name], value];
      } else {
        target[name] = value;
      }
      return !isNumericKey;
    }
    if (!target[name] || !utils$1.isObject(target[name])) {
      target[name] = [];
    }
    const result = buildPath(path, value, target[name], index);
    if (result && utils$1.isArray(target[name])) {
      target[name] = arrayToObject(target[name]);
    }
    return !isNumericKey;
  }
  if (utils$1.isFormData(formData) && utils$1.isFunction(formData.entries)) {
    const obj = {};
    utils$1.forEachEntry(formData, (name, value) => {
      buildPath(parsePropPath(name), value, obj, 0);
    });
    return obj;
  }
  return null;
}
function stringifySafely(rawValue, parser, encoder) {
  if (utils$1.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils$1.trim(rawValue);
    } catch (e) {
      if (e.name !== "SyntaxError") {
        throw e;
      }
    }
  }
  return (encoder || JSON.stringify)(rawValue);
}
const defaults = {
  transitional: transitionalDefaults,
  adapter: ["xhr", "http"],
  transformRequest: [function transformRequest(data, headers) {
    const contentType = headers.getContentType() || "";
    const hasJSONContentType = contentType.indexOf("application/json") > -1;
    const isObjectPayload = utils$1.isObject(data);
    if (isObjectPayload && utils$1.isHTMLForm(data)) {
      data = new FormData(data);
    }
    const isFormData2 = utils$1.isFormData(data);
    if (isFormData2) {
      if (!hasJSONContentType) {
        return data;
      }
      return hasJSONContentType ? JSON.stringify(formDataToJSON(data)) : data;
    }
    if (utils$1.isArrayBuffer(data) || utils$1.isBuffer(data) || utils$1.isStream(data) || utils$1.isFile(data) || utils$1.isBlob(data)) {
      return data;
    }
    if (utils$1.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils$1.isURLSearchParams(data)) {
      headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
      return data.toString();
    }
    let isFileList2;
    if (isObjectPayload) {
      if (contentType.indexOf("application/x-www-form-urlencoded") > -1) {
        return toURLEncodedForm(data, this.formSerializer).toString();
      }
      if ((isFileList2 = utils$1.isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
        const _FormData = this.env && this.env.FormData;
        return toFormData(
          isFileList2 ? { "files[]": data } : data,
          _FormData && new _FormData(),
          this.formSerializer
        );
      }
    }
    if (isObjectPayload || hasJSONContentType) {
      headers.setContentType("application/json", false);
      return stringifySafely(data);
    }
    return data;
  }],
  transformResponse: [function transformResponse(data) {
    const transitional2 = this.transitional || defaults.transitional;
    const forcedJSONParsing = transitional2 && transitional2.forcedJSONParsing;
    const JSONRequested = this.responseType === "json";
    if (data && utils$1.isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
      const silentJSONParsing = transitional2 && transitional2.silentJSONParsing;
      const strictJSONParsing = !silentJSONParsing && JSONRequested;
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === "SyntaxError") {
            throw AxiosError.from(e, AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }
    return data;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: platform.classes.FormData,
    Blob: platform.classes.Blob
  },
  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },
  headers: {
    common: {
      "Accept": "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
utils$1.forEach(["delete", "get", "head", "post", "put", "patch"], (method) => {
  defaults.headers[method] = {};
});
const defaults$1 = defaults;
const ignoreDuplicateOf = utils$1.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]);
const parseHeaders = (rawHeaders) => {
  const parsed = {};
  let key;
  let val;
  let i;
  rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
    i = line.indexOf(":");
    key = line.substring(0, i).trim().toLowerCase();
    val = line.substring(i + 1).trim();
    if (!key || parsed[key] && ignoreDuplicateOf[key]) {
      return;
    }
    if (key === "set-cookie") {
      if (parsed[key]) {
        parsed[key].push(val);
      } else {
        parsed[key] = [val];
      }
    } else {
      parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    }
  });
  return parsed;
};
const $internals = Symbol("internals");
function normalizeHeader(header) {
  return header && String(header).trim().toLowerCase();
}
function normalizeValue(value) {
  if (value === false || value == null) {
    return value;
  }
  return utils$1.isArray(value) ? value.map(normalizeValue) : String(value);
}
function parseTokens(str) {
  const tokens = /* @__PURE__ */ Object.create(null);
  const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let match;
  while (match = tokensRE.exec(str)) {
    tokens[match[1]] = match[2];
  }
  return tokens;
}
const isValidHeaderName = (str) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function matchHeaderValue(context, value, header, filter2, isHeaderNameFilter) {
  if (utils$1.isFunction(filter2)) {
    return filter2.call(this, value, header);
  }
  if (isHeaderNameFilter) {
    value = header;
  }
  if (!utils$1.isString(value))
    return;
  if (utils$1.isString(filter2)) {
    return value.indexOf(filter2) !== -1;
  }
  if (utils$1.isRegExp(filter2)) {
    return filter2.test(value);
  }
}
function formatHeader(header) {
  return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str) => {
    return char.toUpperCase() + str;
  });
}
function buildAccessors(obj, header) {
  const accessorName = utils$1.toCamelCase(" " + header);
  ["get", "set", "has"].forEach((methodName) => {
    Object.defineProperty(obj, methodName + accessorName, {
      value: function(arg1, arg2, arg3) {
        return this[methodName].call(this, header, arg1, arg2, arg3);
      },
      configurable: true
    });
  });
}
class AxiosHeaders {
  constructor(headers) {
    headers && this.set(headers);
  }
  set(header, valueOrRewrite, rewrite) {
    const self2 = this;
    function setHeader(_value, _header, _rewrite) {
      const lHeader = normalizeHeader(_header);
      if (!lHeader) {
        throw new Error("header name must be a non-empty string");
      }
      const key = utils$1.findKey(self2, lHeader);
      if (!key || self2[key] === void 0 || _rewrite === true || _rewrite === void 0 && self2[key] !== false) {
        self2[key || _header] = normalizeValue(_value);
      }
    }
    const setHeaders = (headers, _rewrite) => utils$1.forEach(headers, (_value, _header) => setHeader(_value, _header, _rewrite));
    if (utils$1.isPlainObject(header) || header instanceof this.constructor) {
      setHeaders(header, valueOrRewrite);
    } else if (utils$1.isString(header) && (header = header.trim()) && !isValidHeaderName(header)) {
      setHeaders(parseHeaders(header), valueOrRewrite);
    } else {
      header != null && setHeader(valueOrRewrite, header, rewrite);
    }
    return this;
  }
  get(header, parser) {
    header = normalizeHeader(header);
    if (header) {
      const key = utils$1.findKey(this, header);
      if (key) {
        const value = this[key];
        if (!parser) {
          return value;
        }
        if (parser === true) {
          return parseTokens(value);
        }
        if (utils$1.isFunction(parser)) {
          return parser.call(this, value, key);
        }
        if (utils$1.isRegExp(parser)) {
          return parser.exec(value);
        }
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(header, matcher) {
    header = normalizeHeader(header);
    if (header) {
      const key = utils$1.findKey(this, header);
      return !!(key && this[key] !== void 0 && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
    }
    return false;
  }
  delete(header, matcher) {
    const self2 = this;
    let deleted = false;
    function deleteHeader(_header) {
      _header = normalizeHeader(_header);
      if (_header) {
        const key = utils$1.findKey(self2, _header);
        if (key && (!matcher || matchHeaderValue(self2, self2[key], key, matcher))) {
          delete self2[key];
          deleted = true;
        }
      }
    }
    if (utils$1.isArray(header)) {
      header.forEach(deleteHeader);
    } else {
      deleteHeader(header);
    }
    return deleted;
  }
  clear(matcher) {
    const keys = Object.keys(this);
    let i = keys.length;
    let deleted = false;
    while (i--) {
      const key = keys[i];
      if (!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
        delete this[key];
        deleted = true;
      }
    }
    return deleted;
  }
  normalize(format) {
    const self2 = this;
    const headers = {};
    utils$1.forEach(this, (value, header) => {
      const key = utils$1.findKey(headers, header);
      if (key) {
        self2[key] = normalizeValue(value);
        delete self2[header];
        return;
      }
      const normalized = format ? formatHeader(header) : String(header).trim();
      if (normalized !== header) {
        delete self2[header];
      }
      self2[normalized] = normalizeValue(value);
      headers[normalized] = true;
    });
    return this;
  }
  concat(...targets) {
    return this.constructor.concat(this, ...targets);
  }
  toJSON(asStrings) {
    const obj = /* @__PURE__ */ Object.create(null);
    utils$1.forEach(this, (value, header) => {
      value != null && value !== false && (obj[header] = asStrings && utils$1.isArray(value) ? value.join(", ") : value);
    });
    return obj;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([header, value]) => header + ": " + value).join("\n");
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(thing) {
    return thing instanceof this ? thing : new this(thing);
  }
  static concat(first, ...targets) {
    const computed = new this(first);
    targets.forEach((target) => computed.set(target));
    return computed;
  }
  static accessor(header) {
    const internals = this[$internals] = this[$internals] = {
      accessors: {}
    };
    const accessors = internals.accessors;
    const prototype2 = this.prototype;
    function defineAccessor(_header) {
      const lHeader = normalizeHeader(_header);
      if (!accessors[lHeader]) {
        buildAccessors(prototype2, _header);
        accessors[lHeader] = true;
      }
    }
    utils$1.isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
    return this;
  }
}
AxiosHeaders.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
utils$1.reduceDescriptors(AxiosHeaders.prototype, ({ value }, key) => {
  let mapped = key[0].toUpperCase() + key.slice(1);
  return {
    get: () => value,
    set(headerValue) {
      this[mapped] = headerValue;
    }
  };
});
utils$1.freezeMethods(AxiosHeaders);
const AxiosHeaders$1 = AxiosHeaders;
function transformData(fns, response) {
  const config = this || defaults$1;
  const context = response || config;
  const headers = AxiosHeaders$1.from(context.headers);
  let data = context.data;
  utils$1.forEach(fns, function transform(fn) {
    data = fn.call(config, data, headers.normalize(), response ? response.status : void 0);
  });
  headers.normalize();
  return data;
}
function isCancel(value) {
  return !!(value && value.__CANCEL__);
}
function CanceledError(message, config, request) {
  AxiosError.call(this, message == null ? "canceled" : message, AxiosError.ERR_CANCELED, config, request);
  this.name = "CanceledError";
}
utils$1.inherits(CanceledError, AxiosError, {
  __CANCEL__: true
});
function settle(resolve, reject, response) {
  const validateStatus2 = response.config.validateStatus;
  if (!response.status || !validateStatus2 || validateStatus2(response.status)) {
    resolve(response);
  } else {
    reject(new AxiosError(
      "Request failed with status code " + response.status,
      [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
}
const cookies = platform.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(name, value, expires, path, domain, secure) {
      const cookie = [name + "=" + encodeURIComponent(value)];
      utils$1.isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
      utils$1.isString(path) && cookie.push("path=" + path);
      utils$1.isString(domain) && cookie.push("domain=" + domain);
      secure === true && cookie.push("secure");
      document.cookie = cookie.join("; ");
    },
    read(name) {
      const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
      return match ? decodeURIComponent(match[3]) : null;
    },
    remove(name) {
      this.write(name, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function isAbsoluteURL(url) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}
function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}
function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
}
const isURLSameOrigin = platform.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    function resolveURL(url) {
      let href = url;
      if (msie) {
        urlParsingNode.setAttribute("href", href);
        href = urlParsingNode.href;
      }
      urlParsingNode.setAttribute("href", href);
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
      };
    }
    originURL = resolveURL(window.location.href);
    return function isURLSameOrigin2(requestURL) {
      const parsed = utils$1.isString(requestURL) ? resolveURL(requestURL) : requestURL;
      return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  /* @__PURE__ */ function nonStandardBrowserEnv() {
    return function isURLSameOrigin2() {
      return true;
    };
  }()
);
function parseProtocol(url) {
  const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || "";
}
function speedometer(samplesCount, min) {
  samplesCount = samplesCount || 10;
  const bytes = new Array(samplesCount);
  const timestamps = new Array(samplesCount);
  let head = 0;
  let tail = 0;
  let firstSampleTS;
  min = min !== void 0 ? min : 1e3;
  return function push(chunkLength) {
    const now = Date.now();
    const startedAt = timestamps[tail];
    if (!firstSampleTS) {
      firstSampleTS = now;
    }
    bytes[head] = chunkLength;
    timestamps[head] = now;
    let i = tail;
    let bytesCount = 0;
    while (i !== head) {
      bytesCount += bytes[i++];
      i = i % samplesCount;
    }
    head = (head + 1) % samplesCount;
    if (head === tail) {
      tail = (tail + 1) % samplesCount;
    }
    if (now - firstSampleTS < min) {
      return;
    }
    const passed = startedAt && now - startedAt;
    return passed ? Math.round(bytesCount * 1e3 / passed) : void 0;
  };
}
function progressEventReducer(listener, isDownloadStream) {
  let bytesNotified = 0;
  const _speedometer = speedometer(50, 250);
  return (e) => {
    const loaded = e.loaded;
    const total = e.lengthComputable ? e.total : void 0;
    const progressBytes = loaded - bytesNotified;
    const rate = _speedometer(progressBytes);
    const inRange = loaded <= total;
    bytesNotified = loaded;
    const data = {
      loaded,
      total,
      progress: total ? loaded / total : void 0,
      bytes: progressBytes,
      rate: rate ? rate : void 0,
      estimated: rate && total && inRange ? (total - loaded) / rate : void 0,
      event: e
    };
    data[isDownloadStream ? "download" : "upload"] = true;
    listener(data);
  };
}
const isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
const xhrAdapter = isXHRAdapterSupported && function(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    let requestData = config.data;
    const requestHeaders = AxiosHeaders$1.from(config.headers).normalize();
    let { responseType, withXSRFToken } = config;
    let onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }
      if (config.signal) {
        config.signal.removeEventListener("abort", onCanceled);
      }
    }
    let contentType;
    if (utils$1.isFormData(requestData)) {
      if (platform.hasStandardBrowserEnv || platform.hasStandardBrowserWebWorkerEnv) {
        requestHeaders.setContentType(false);
      } else if ((contentType = requestHeaders.getContentType()) !== false) {
        const [type, ...tokens] = contentType ? contentType.split(";").map((token) => token.trim()).filter(Boolean) : [];
        requestHeaders.setContentType([type || "multipart/form-data", ...tokens].join("; "));
      }
    }
    let request = new XMLHttpRequest();
    if (config.auth) {
      const username = config.auth.username || "";
      const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
      requestHeaders.set("Authorization", "Basic " + btoa(username + ":" + password));
    }
    const fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);
    request.timeout = config.timeout;
    function onloadend() {
      if (!request) {
        return;
      }
      const responseHeaders = AxiosHeaders$1.from(
        "getAllResponseHeaders" in request && request.getAllResponseHeaders()
      );
      const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
      const response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config,
        request
      };
      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);
      request = null;
    }
    if ("onloadend" in request) {
      request.onloadend = onloadend;
    } else {
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) {
          return;
        }
        setTimeout(onloadend);
      };
    }
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }
      reject(new AxiosError("Request aborted", AxiosError.ECONNABORTED, config, request));
      request = null;
    };
    request.onerror = function handleError() {
      reject(new AxiosError("Network Error", AxiosError.ERR_NETWORK, config, request));
      request = null;
    };
    request.ontimeout = function handleTimeout() {
      let timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
      const transitional2 = config.transitional || transitionalDefaults;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(new AxiosError(
        timeoutErrorMessage,
        transitional2.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED,
        config,
        request
      ));
      request = null;
    };
    if (platform.hasStandardBrowserEnv) {
      withXSRFToken && utils$1.isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(config));
      if (withXSRFToken || withXSRFToken !== false && isURLSameOrigin(fullPath)) {
        const xsrfValue = config.xsrfHeaderName && config.xsrfCookieName && cookies.read(config.xsrfCookieName);
        if (xsrfValue) {
          requestHeaders.set(config.xsrfHeaderName, xsrfValue);
        }
      }
    }
    requestData === void 0 && requestHeaders.setContentType(null);
    if ("setRequestHeader" in request) {
      utils$1.forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
        request.setRequestHeader(key, val);
      });
    }
    if (!utils$1.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }
    if (responseType && responseType !== "json") {
      request.responseType = config.responseType;
    }
    if (typeof config.onDownloadProgress === "function") {
      request.addEventListener("progress", progressEventReducer(config.onDownloadProgress, true));
    }
    if (typeof config.onUploadProgress === "function" && request.upload) {
      request.upload.addEventListener("progress", progressEventReducer(config.onUploadProgress));
    }
    if (config.cancelToken || config.signal) {
      onCanceled = (cancel) => {
        if (!request) {
          return;
        }
        reject(!cancel || cancel.type ? new CanceledError(null, config, request) : cancel);
        request.abort();
        request = null;
      };
      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
      }
    }
    const protocol = parseProtocol(fullPath);
    if (protocol && platform.protocols.indexOf(protocol) === -1) {
      reject(new AxiosError("Unsupported protocol " + protocol + ":", AxiosError.ERR_BAD_REQUEST, config));
      return;
    }
    request.send(requestData || null);
  });
};
const knownAdapters = {
  http: httpAdapter,
  xhr: xhrAdapter
};
utils$1.forEach(knownAdapters, (fn, value) => {
  if (fn) {
    try {
      Object.defineProperty(fn, "name", { value });
    } catch (e) {
    }
    Object.defineProperty(fn, "adapterName", { value });
  }
});
const renderReason = (reason) => `- ${reason}`;
const isResolvedHandle = (adapter) => utils$1.isFunction(adapter) || adapter === null || adapter === false;
const adapters = {
  getAdapter: (adapters2) => {
    adapters2 = utils$1.isArray(adapters2) ? adapters2 : [adapters2];
    const { length } = adapters2;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for (let i = 0; i < length; i++) {
      nameOrAdapter = adapters2[i];
      let id;
      adapter = nameOrAdapter;
      if (!isResolvedHandle(nameOrAdapter)) {
        adapter = knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
        if (adapter === void 0) {
          throw new AxiosError(`Unknown adapter '${id}'`);
        }
      }
      if (adapter) {
        break;
      }
      rejectedReasons[id || "#" + i] = adapter;
    }
    if (!adapter) {
      const reasons = Object.entries(rejectedReasons).map(
        ([id, state]) => `adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build")
      );
      let s = length ? reasons.length > 1 ? "since :\n" + reasons.map(renderReason).join("\n") : " " + renderReason(reasons[0]) : "as no adapter specified";
      throw new AxiosError(
        `There is no suitable adapter to dispatch the request ` + s,
        "ERR_NOT_SUPPORT"
      );
    }
    return adapter;
  },
  adapters: knownAdapters
};
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
  if (config.signal && config.signal.aborted) {
    throw new CanceledError(null, config);
  }
}
function dispatchRequest(config) {
  throwIfCancellationRequested(config);
  config.headers = AxiosHeaders$1.from(config.headers);
  config.data = transformData.call(
    config,
    config.transformRequest
  );
  if (["post", "put", "patch"].indexOf(config.method) !== -1) {
    config.headers.setContentType("application/x-www-form-urlencoded", false);
  }
  const adapter = adapters.getAdapter(config.adapter || defaults$1.adapter);
  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);
    response.data = transformData.call(
      config,
      config.transformResponse,
      response
    );
    response.headers = AxiosHeaders$1.from(response.headers);
    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          config.transformResponse,
          reason.response
        );
        reason.response.headers = AxiosHeaders$1.from(reason.response.headers);
      }
    }
    return Promise.reject(reason);
  });
}
const headersToObject = (thing) => thing instanceof AxiosHeaders$1 ? thing.toJSON() : thing;
function mergeConfig(config1, config2) {
  config2 = config2 || {};
  const config = {};
  function getMergedValue(target, source, caseless) {
    if (utils$1.isPlainObject(target) && utils$1.isPlainObject(source)) {
      return utils$1.merge.call({ caseless }, target, source);
    } else if (utils$1.isPlainObject(source)) {
      return utils$1.merge({}, source);
    } else if (utils$1.isArray(source)) {
      return source.slice();
    }
    return source;
  }
  function mergeDeepProperties(a, b, caseless) {
    if (!utils$1.isUndefined(b)) {
      return getMergedValue(a, b, caseless);
    } else if (!utils$1.isUndefined(a)) {
      return getMergedValue(void 0, a, caseless);
    }
  }
  function valueFromConfig2(a, b) {
    if (!utils$1.isUndefined(b)) {
      return getMergedValue(void 0, b);
    }
  }
  function defaultToConfig2(a, b) {
    if (!utils$1.isUndefined(b)) {
      return getMergedValue(void 0, b);
    } else if (!utils$1.isUndefined(a)) {
      return getMergedValue(void 0, a);
    }
  }
  function mergeDirectKeys(a, b, prop) {
    if (prop in config2) {
      return getMergedValue(a, b);
    } else if (prop in config1) {
      return getMergedValue(void 0, a);
    }
  }
  const mergeMap = {
    url: valueFromConfig2,
    method: valueFromConfig2,
    data: valueFromConfig2,
    baseURL: defaultToConfig2,
    transformRequest: defaultToConfig2,
    transformResponse: defaultToConfig2,
    paramsSerializer: defaultToConfig2,
    timeout: defaultToConfig2,
    timeoutMessage: defaultToConfig2,
    withCredentials: defaultToConfig2,
    withXSRFToken: defaultToConfig2,
    adapter: defaultToConfig2,
    responseType: defaultToConfig2,
    xsrfCookieName: defaultToConfig2,
    xsrfHeaderName: defaultToConfig2,
    onUploadProgress: defaultToConfig2,
    onDownloadProgress: defaultToConfig2,
    decompress: defaultToConfig2,
    maxContentLength: defaultToConfig2,
    maxBodyLength: defaultToConfig2,
    beforeRedirect: defaultToConfig2,
    transport: defaultToConfig2,
    httpAgent: defaultToConfig2,
    httpsAgent: defaultToConfig2,
    cancelToken: defaultToConfig2,
    socketPath: defaultToConfig2,
    responseEncoding: defaultToConfig2,
    validateStatus: mergeDirectKeys,
    headers: (a, b) => mergeDeepProperties(headersToObject(a), headersToObject(b), true)
  };
  utils$1.forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
    const merge2 = mergeMap[prop] || mergeDeepProperties;
    const configValue = merge2(config1[prop], config2[prop], prop);
    utils$1.isUndefined(configValue) && merge2 !== mergeDirectKeys || (config[prop] = configValue);
  });
  return config;
}
const VERSION = "1.6.5";
const validators$1 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((type, i) => {
  validators$1[type] = function validator2(thing) {
    return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
  };
});
const deprecatedWarnings = {};
validators$1.transitional = function transitional(validator2, version, message) {
  function formatMessage(opt, desc) {
    return "[Axios v" + VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
  }
  return (value, opt, opts) => {
    if (validator2 === false) {
      throw new AxiosError(
        formatMessage(opt, " has been removed" + (version ? " in " + version : "")),
        AxiosError.ERR_DEPRECATED
      );
    }
    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      console.warn(
        formatMessage(
          opt,
          " has been deprecated since v" + version + " and will be removed in the near future"
        )
      );
    }
    return validator2 ? validator2(value, opt, opts) : true;
  };
};
function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== "object") {
    throw new AxiosError("options must be an object", AxiosError.ERR_BAD_OPTION_VALUE);
  }
  const keys = Object.keys(options);
  let i = keys.length;
  while (i-- > 0) {
    const opt = keys[i];
    const validator2 = schema[opt];
    if (validator2) {
      const value = options[opt];
      const result = value === void 0 || validator2(value, opt, options);
      if (result !== true) {
        throw new AxiosError("option " + opt + " must be " + result, AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new AxiosError("Unknown option " + opt, AxiosError.ERR_BAD_OPTION);
    }
  }
}
const validator = {
  assertOptions,
  validators: validators$1
};
const validators = validator.validators;
class Axios {
  constructor(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
      request: new InterceptorManager(),
      response: new InterceptorManager()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  request(configOrUrl, config) {
    if (typeof configOrUrl === "string") {
      config = config || {};
      config.url = configOrUrl;
    } else {
      config = configOrUrl || {};
    }
    config = mergeConfig(this.defaults, config);
    const { transitional: transitional2, paramsSerializer, headers } = config;
    if (transitional2 !== void 0) {
      validator.assertOptions(transitional2, {
        silentJSONParsing: validators.transitional(validators.boolean),
        forcedJSONParsing: validators.transitional(validators.boolean),
        clarifyTimeoutError: validators.transitional(validators.boolean)
      }, false);
    }
    if (paramsSerializer != null) {
      if (utils$1.isFunction(paramsSerializer)) {
        config.paramsSerializer = {
          serialize: paramsSerializer
        };
      } else {
        validator.assertOptions(paramsSerializer, {
          encode: validators.function,
          serialize: validators.function
        }, true);
      }
    }
    config.method = (config.method || this.defaults.method || "get").toLowerCase();
    let contextHeaders = headers && utils$1.merge(
      headers.common,
      headers[config.method]
    );
    headers && utils$1.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (method) => {
        delete headers[method];
      }
    );
    config.headers = AxiosHeaders$1.concat(contextHeaders, headers);
    const requestInterceptorChain = [];
    let synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
      if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) {
        return;
      }
      synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
      requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    const responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
      responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    let promise;
    let i = 0;
    let len;
    if (!synchronousRequestInterceptors) {
      const chain = [dispatchRequest.bind(this), void 0];
      chain.unshift.apply(chain, requestInterceptorChain);
      chain.push.apply(chain, responseInterceptorChain);
      len = chain.length;
      promise = Promise.resolve(config);
      while (i < len) {
        promise = promise.then(chain[i++], chain[i++]);
      }
      return promise;
    }
    len = requestInterceptorChain.length;
    let newConfig = config;
    i = 0;
    while (i < len) {
      const onFulfilled = requestInterceptorChain[i++];
      const onRejected = requestInterceptorChain[i++];
      try {
        newConfig = onFulfilled(newConfig);
      } catch (error) {
        onRejected.call(this, error);
        break;
      }
    }
    try {
      promise = dispatchRequest.call(this, newConfig);
    } catch (error) {
      return Promise.reject(error);
    }
    i = 0;
    len = responseInterceptorChain.length;
    while (i < len) {
      promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
    }
    return promise;
  }
  getUri(config) {
    config = mergeConfig(this.defaults, config);
    const fullPath = buildFullPath(config.baseURL, config.url);
    return buildURL(fullPath, config.params, config.paramsSerializer);
  }
}
utils$1.forEach(["delete", "get", "head", "options"], function forEachMethodNoData(method) {
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});
utils$1.forEach(["post", "put", "patch"], function forEachMethodWithData(method) {
  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method,
        headers: isForm ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url,
        data
      }));
    };
  }
  Axios.prototype[method] = generateHTTPMethod();
  Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
const Axios$1 = Axios;
class CancelToken {
  constructor(executor) {
    if (typeof executor !== "function") {
      throw new TypeError("executor must be a function.");
    }
    let resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
      resolvePromise = resolve;
    });
    const token = this;
    this.promise.then((cancel) => {
      if (!token._listeners)
        return;
      let i = token._listeners.length;
      while (i-- > 0) {
        token._listeners[i](cancel);
      }
      token._listeners = null;
    });
    this.promise.then = (onfulfilled) => {
      let _resolve;
      const promise = new Promise((resolve) => {
        token.subscribe(resolve);
        _resolve = resolve;
      }).then(onfulfilled);
      promise.cancel = function reject() {
        token.unsubscribe(_resolve);
      };
      return promise;
    };
    executor(function cancel(message, config, request) {
      if (token.reason) {
        return;
      }
      token.reason = new CanceledError(message, config, request);
      resolvePromise(token.reason);
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }
    if (this._listeners) {
      this._listeners.push(listener);
    } else {
      this._listeners = [listener];
    }
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(listener) {
    if (!this._listeners) {
      return;
    }
    const index = this._listeners.indexOf(listener);
    if (index !== -1) {
      this._listeners.splice(index, 1);
    }
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let cancel;
    const token = new CancelToken(function executor(c) {
      cancel = c;
    });
    return {
      token,
      cancel
    };
  }
}
const CancelToken$1 = CancelToken;
function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
}
function isAxiosError(payload) {
  return utils$1.isObject(payload) && payload.isAxiosError === true;
}
const HttpStatusCode = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(HttpStatusCode).forEach(([key, value]) => {
  HttpStatusCode[value] = key;
});
const HttpStatusCode$1 = HttpStatusCode;
function createInstance(defaultConfig) {
  const context = new Axios$1(defaultConfig);
  const instance = bind(Axios$1.prototype.request, context);
  utils$1.extend(instance, Axios$1.prototype, context, { allOwnKeys: true });
  utils$1.extend(instance, context, null, { allOwnKeys: true });
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };
  return instance;
}
const axios = createInstance(defaults$1);
axios.Axios = Axios$1;
axios.CanceledError = CanceledError;
axios.CancelToken = CancelToken$1;
axios.isCancel = isCancel;
axios.VERSION = VERSION;
axios.toFormData = toFormData;
axios.AxiosError = AxiosError;
axios.Cancel = axios.CanceledError;
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = spread;
axios.isAxiosError = isAxiosError;
axios.mergeConfig = mergeConfig;
axios.AxiosHeaders = AxiosHeaders$1;
axios.formToJSON = (thing) => formDataToJSON(utils$1.isHTMLForm(thing) ? new FormData(thing) : thing);
axios.getAdapter = adapters.getAdapter;
axios.HttpStatusCode = HttpStatusCode$1;
axios.default = axios;
function normalize(strArray) {
  var resultArray = [];
  if (strArray.length === 0) {
    return "";
  }
  if (typeof strArray[0] !== "string") {
    throw new TypeError("Url must be a string. Received " + strArray[0]);
  }
  if (strArray[0].match(/^[^/:]+:\/*$/) && strArray.length > 1) {
    var first = strArray.shift();
    strArray[0] = first + strArray[0];
  }
  if (strArray[0].match(/^file:\/\/\//)) {
    strArray[0] = strArray[0].replace(/^([^/:]+):\/*/, "$1:///");
  } else {
    strArray[0] = strArray[0].replace(/^([^/:]+):\/*/, "$1://");
  }
  for (var i = 0; i < strArray.length; i++) {
    var component = strArray[i];
    if (typeof component !== "string") {
      throw new TypeError("Url must be a string. Received " + component);
    }
    if (component === "") {
      continue;
    }
    if (i > 0) {
      component = component.replace(/^[\/]+/, "");
    }
    if (i < strArray.length - 1) {
      component = component.replace(/[\/]+$/, "");
    } else {
      component = component.replace(/[\/]+$/, "/");
    }
    resultArray.push(component);
  }
  var str = resultArray.join("/");
  str = str.replace(/\/(\?|&|#[^!])/g, "$1");
  var parts = str.split("?");
  str = parts.shift() + (parts.length > 0 ? "?" : "") + parts.join("&");
  return str;
}
function urlJoin() {
  var input;
  if (typeof arguments[0] === "object") {
    input = arguments[0];
  } else {
    input = [].slice.call(arguments);
  }
  return normalize(input);
}
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
var helpers = { exports: {} };
(function(module, exports) {
  (function(global2, factory) {
    factory(exports);
  })(commonjsGlobal, function(exports2) {
    class BaseError extends Error {
      // TODO Determine how to do this ??
      // public get level(): LevelNumber {
      //
      //     return this._level;
      //
      // }
      constructor(data2) {
        super();
        this._at = /* @__PURE__ */ new Date();
        this._url = window && window.location && window.location.href || "";
        this._data = data2;
        this.message = this.toString();
      }
      // TODO Determine how to do this ??
      // protected _level: LevelNumber;
      get at() {
        return new Date(this._at.valueOf());
      }
      get data() {
        return this._data;
      }
      get isOpenTicketError() {
        return true;
      }
      toFlatData() {
        const slug = this.toSlug();
        let serializedSlugData = "";
        try {
          serializedSlugData = JSON.stringify(slug.data) || "";
        } catch (_) {
        }
        return {
          ...this.additionalFlatData(),
          at: this.at.toISOString(),
          // level: levelNumberToLevel[this.level], // TODO ??
          message: this.toString(),
          slug: this.toSlug().key,
          slugData: serializedSlugData,
          url: this._url
        };
      }
      additionalFlatData() {
        return {};
      }
    }
    function isStringError(e) {
      return e && e._isStringError;
    }
    class StringError extends BaseError {
      constructor(slug, message) {
        if (!slug || !slug.length) {
          throw new Error("Expected first argument to be a non empty string.");
        }
        super(slug);
        this._message = message;
        this._isStringError = true;
      }
      toSlug() {
        return {
          key: this.data
        };
      }
      toString() {
        return this._message || this.data;
      }
    }
    class UnexpectedError extends BaseError {
      toSlug() {
        return { key: "sdkhelpers.errors.unexpected" };
      }
      toString() {
        const str = "Unexpected error";
        if (this.data) {
          if (this.data instanceof Error) {
            return `${str} [${this.data.name}]: ${this.data.message}`;
          }
          try {
            return `${str}: ${JSON.stringify(this.data)}`;
          } catch (e) {
          }
        }
        return str;
      }
    }
    function isFormValidationError(e) {
      return e && e._isFormValidationError;
    }
    class FormValidationError extends BaseError {
      constructor() {
        super(...arguments);
        this._isFormValidationError = true;
      }
      toSlug() {
        return {
          key: this.data.slug,
          data: this.data.data
        };
      }
      getFieldErrors(key) {
        return FormValidationError.getFieldErrors(this.data.messages, key);
      }
      toString() {
        const firstError = this._getFirstErrorFromFirstField();
        if (!firstError) {
          return "Validation error";
        }
        return `First validation error ${firstError.key}: ${firstError.error}`;
      }
      additionalFlatData() {
        const errors2 = {};
        for (const key in this.data.messages) {
          if (Object.prototype.hasOwnProperty.call(this.data, key)) {
            continue;
          }
          const localErrors = this.data.messages[key];
          if (localErrors) {
            errors2[key] = Array.isArray(localErrors) ? localErrors.join(", ") : localErrors;
          }
        }
        return errors2;
      }
      static getFieldErrors(messages2, key) {
        const errorOrErrors = messages2[key];
        if (!errorOrErrors) {
          return void 0;
        }
        const errors2 = Array.isArray(errorOrErrors) ? errorOrErrors : [errorOrErrors];
        return errors2.map((error) => ({
          key: "sdkhelpers.form.errors.validation_error_field",
          data: {
            key,
            error
          }
        }));
      }
      _getFirstErrorFromFirstField() {
        for (const key in this.data.messages) {
          if (!Object.prototype.hasOwnProperty.call(this.data, key)) {
            continue;
          }
          const errorOrErrors = this.data.messages[key];
          if (!errorOrErrors) {
            continue;
          }
          if (Array.isArray(errorOrErrors)) {
            return { key, error: errorOrErrors[0] };
          }
          return { key, error: errorOrErrors };
        }
        return void 0;
      }
    }
    class Form {
      constructor(config) {
        this.props = this._buildProps(config.data);
        this.original = { ...config.data };
        this.config = config;
      }
      validate(mutate = false) {
        return this._internalValidate(mutate);
      }
      validateProp(key, mutate = false) {
        return this._internalValidate(mutate, key);
      }
      async submit() {
        const validation = await this.validate(true);
        if (!validation.valid) {
          throw new FormValidationError(validation.result);
        }
        try {
          const data2 = this.serialize();
          const response = await this.config.submit(data2, this.original);
          this._resetErrors();
          this._applyChanges({
            ...data2,
            ...response
          });
        } catch (e) {
          if (isFormValidationError(e)) {
            this._mutateErrors(e.data.messages);
            throw e;
          } else if (isStringError(e)) {
            throw e;
          }
          throw new UnexpectedError(e);
        }
      }
      undo(key) {
        this.props[key].value = this.original[key];
      }
      undoAll() {
        for (const key in this.props) {
          if (!Object.prototype.hasOwnProperty.call(this.props, key)) {
            continue;
          }
          this.props[key].value = this.original[key];
        }
      }
      hasLocalChanges() {
        for (const key in this.props) {
          if (!Object.prototype.hasOwnProperty.call(this.props, key)) {
            continue;
          }
          if (this.props[key].value !== this.original[key]) {
            return true;
          }
        }
        return false;
      }
      serialize(key) {
        const data2 = {};
        if (key) {
          if (this.original[key] !== this.props[key].value) {
            data2[key] = this.props[key].value;
          }
          return data2;
        }
        for (const propKey in this.props) {
          if (!Object.prototype.hasOwnProperty.call(this.props, propKey)) {
            continue;
          }
          data2[propKey] = this.props[propKey].value;
        }
        return data2;
      }
      /**
       * Run validation and return results.
       *
       * A prop will only be validated if it is dirty.
       *
       * When a key is given, only that prop is checked if it is dirty.
       * Without a key, all dirty props are checked.
       *
       * When mutate is true, prop errors are mutated for all checked props.
       *
       * @private
       */
      async _internalValidate(mutate = false, key) {
        if (!this.config.validate) {
          return { valid: true };
        }
        const data2 = this.serialize(key);
        const result = await this.config.validate(data2);
        if (!result.valid && mutate) {
          this._mutateErrors(result.result.messages, !key);
        }
        return result;
      }
      /**
       * Mutates all given prop errors in keys.
       *
       * If no error is present in the validation data,
       * it is set to an empty array.
       *
       * @private
       */
      _mutateErrors(validationData, clearAll = true) {
        for (const key in this.props) {
          if (!Object.prototype.hasOwnProperty.call(this.props, key)) {
            continue;
          }
          if (validationData[key]) {
            const sluggedErrors = FormValidationError.getFieldErrors(validationData, key);
            this.props[key].errors = sluggedErrors || [];
          } else if (clearAll && this.props[key].errors.length) {
            this.props[key].errors = [];
          }
        }
      }
      /**
       * Removes all errors from  props
       *
       * @private
       */
      _resetErrors() {
        this._mutateErrors({});
      }
      _applyChanges(data2) {
        for (const key in data2) {
          const value = data2[key];
          this.original[key] = value;
          this.props[key].value = value;
        }
      }
      _buildProps(props) {
        const map = {};
        for (const key in props) {
          if (!Object.prototype.hasOwnProperty.call(props, key)) {
            continue;
          }
          map[key] = {
            errors: [],
            rules: [],
            value: props[key]
          };
        }
        return map;
      }
    }
    var commonjsGlobal$1 = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof commonjsGlobal !== "undefined" ? commonjsGlobal : typeof self !== "undefined" ? self : {};
    function commonjsRequire(path) {
      throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
    }
    function leapYear$1(year) {
      return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    function checkFalsePositiveDates$1(dateString = "") {
      if (dateString.length === 10) {
        let normalizedDate = dateString.replace(".", "-").replace("/", "-");
        let parts = normalizedDate.split("-");
        if (parts.length === 3) {
          if (parts[0].length === 4) {
            let y = parseInt(parts[0]);
            let m = parseInt(parts[1]);
            let d = parseInt(parts[2]);
            if (m === 2) {
              if (leapYear$1(y)) {
                if (d > 29) {
                  return false;
                }
              } else {
                if (d > 28) {
                  return false;
                }
              }
            }
            if (m === 4 || m === 6 || m === 9 || m === 11) {
              if (d > 30) {
                return false;
              }
            }
          }
        }
        return true;
      }
      return true;
    }
    function isValidDate$1(dateString) {
      let testDate;
      if (typeof dateString === "number") {
        testDate = new Date(dateString);
        if (typeof testDate === "object") {
          return true;
        }
      }
      testDate = new Date(dateString);
      if (typeof testDate === "object") {
        if (testDate.toString() === "Invalid Date") {
          return false;
        }
        if (!checkFalsePositiveDates$1(dateString)) {
          return false;
        }
        return true;
      }
      var regex_date = /^\d{4}\-\d{1,2}\-\d{1,2}$/;
      if (!regex_date.test(dateString)) {
        return false;
      }
      var parts = dateString.split("-");
      var day = parseInt(parts[2], 10);
      var month = parseInt(parts[1], 10);
      var year = parseInt(parts[0], 10);
      if (year < 1e3 || year > 3e3 || month == 0 || month > 12) {
        return false;
      }
      var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
      if (year % 400 == 0 || year % 100 != 0 && year % 4 == 0) {
        monthLength[1] = 29;
      }
      return day > 0 && day <= monthLength[month - 1];
    }
    var rules = {
      required: function(val) {
        var str;
        if (val === void 0 || val === null) {
          return false;
        }
        str = String(val).replace(/\s/g, "");
        return str.length > 0 ? true : false;
      },
      required_if: function(val, req, attribute) {
        req = this.getParameters();
        if (this.validator._objectPath(this.validator.input, req[0]) === req[1]) {
          return this.validator.getRule("required").validate(val);
        }
        return true;
      },
      required_unless: function(val, req, attribute) {
        req = this.getParameters();
        if (this.validator._objectPath(this.validator.input, req[0]) !== req[1]) {
          return this.validator.getRule("required").validate(val);
        }
        return true;
      },
      required_with: function(val, req, attribute) {
        if (this.validator._objectPath(this.validator.input, req)) {
          return this.validator.getRule("required").validate(val);
        }
        return true;
      },
      required_with_all: function(val, req, attribute) {
        req = this.getParameters();
        for (var i = 0; i < req.length; i++) {
          if (!this.validator._objectPath(this.validator.input, req[i])) {
            return true;
          }
        }
        return this.validator.getRule("required").validate(val);
      },
      required_without: function(val, req, attribute) {
        if (this.validator._objectPath(this.validator.input, req)) {
          return true;
        }
        return this.validator.getRule("required").validate(val);
      },
      required_without_all: function(val, req, attribute) {
        req = this.getParameters();
        for (var i = 0; i < req.length; i++) {
          if (this.validator._objectPath(this.validator.input, req[i])) {
            return true;
          }
        }
        return this.validator.getRule("required").validate(val);
      },
      boolean: function(val) {
        return val === true || val === false || val === 0 || val === 1 || val === "0" || val === "1" || val === "true" || val === "false";
      },
      // compares the size of strings
      // with numbers, compares the value
      size: function(val, req, attribute) {
        if (val) {
          req = parseFloat(req);
          var size = this.getSize();
          return size === req;
        }
        return true;
      },
      string: function(val, req, attribute) {
        return typeof val === "string";
      },
      sometimes: function(val) {
        return true;
      },
      /**
       * Compares the size of strings or the value of numbers if there is a truthy value
       */
      min: function(val, req, attribute) {
        var size = this.getSize();
        return size >= req;
      },
      /**
       * Compares the size of strings or the value of numbers if there is a truthy value
       */
      max: function(val, req, attribute) {
        var size = this.getSize();
        return size <= req;
      },
      between: function(val, req, attribute) {
        req = this.getParameters();
        var size = this.getSize();
        var min = parseFloat(req[0], 10);
        var max = parseFloat(req[1], 10);
        return size >= min && size <= max;
      },
      email: function(val) {
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!re.test(val)) {
          re = /^((?:[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]|[^\u0000-\u007F])+@(?:[a-zA-Z0-9]|[^\u0000-\u007F])(?:(?:[a-zA-Z0-9-]|[^\u0000-\u007F]){0,61}(?:[a-zA-Z0-9]|[^\u0000-\u007F]))?(?:\.(?:[a-zA-Z0-9]|[^\u0000-\u007F])(?:(?:[a-zA-Z0-9-]|[^\u0000-\u007F]){0,61}(?:[a-zA-Z0-9]|[^\u0000-\u007F]))?)+)*$/;
        }
        return re.test(val);
      },
      numeric: function(val) {
        var num;
        num = Number(val);
        if (typeof num === "number" && !isNaN(num) && typeof val !== "boolean") {
          return true;
        } else {
          return false;
        }
      },
      array: function(val) {
        return val instanceof Array;
      },
      url: function(url) {
        return /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_\+.~#?&/=]*)/i.test(url);
      },
      alpha: function(val) {
        return /^[a-zA-Z]+$/.test(val);
      },
      alpha_dash: function(val) {
        return /^[a-zA-Z0-9_\-]+$/.test(val);
      },
      alpha_num: function(val) {
        return /^[a-zA-Z0-9]+$/.test(val);
      },
      same: function(val, req) {
        var val1 = this.validator._flattenObject(this.validator.input)[req];
        var val2 = val;
        if (val1 === val2) {
          return true;
        }
        return false;
      },
      different: function(val, req) {
        var val1 = this.validator._flattenObject(this.validator.input)[req];
        var val2 = val;
        if (val1 !== val2) {
          return true;
        }
        return false;
      },
      in: function(val, req) {
        var list, i;
        if (val) {
          list = this.getParameters();
        }
        if (val && !(val instanceof Array)) {
          var localValue = val;
          for (i = 0; i < list.length; i++) {
            if (typeof list[i] === "string") {
              localValue = String(val);
            }
            if (localValue === list[i]) {
              return true;
            }
          }
          return false;
        }
        if (val && val instanceof Array) {
          for (i = 0; i < val.length; i++) {
            if (list.indexOf(val[i]) < 0) {
              return false;
            }
          }
        }
        return true;
      },
      not_in: function(val, req) {
        var list = this.getParameters();
        var len = list.length;
        var returnVal = true;
        for (var i = 0; i < len; i++) {
          var localValue = val;
          if (typeof list[i] === "string") {
            localValue = String(val);
          }
          if (localValue === list[i]) {
            returnVal = false;
            break;
          }
        }
        return returnVal;
      },
      accepted: function(val) {
        if (val === "on" || val === "yes" || val === 1 || val === "1" || val === true) {
          return true;
        }
        return false;
      },
      confirmed: function(val, req, key) {
        var confirmedKey = key + "_confirmation";
        if (this.validator.input[confirmedKey] === val) {
          return true;
        }
        return false;
      },
      integer: function(val) {
        return String(parseInt(val, 10)) === String(val);
      },
      digits: function(val, req) {
        var numericRule = this.validator.getRule("numeric");
        if (numericRule.validate(val) && String(val.trim()).length === parseInt(req)) {
          return true;
        }
        return false;
      },
      digits_between: function(val) {
        var numericRule = this.validator.getRule("numeric");
        var req = this.getParameters();
        var valueDigitsCount = String(val).length;
        var min = parseFloat(req[0], 10);
        var max = parseFloat(req[1], 10);
        if (numericRule.validate(val) && valueDigitsCount >= min && valueDigitsCount <= max) {
          return true;
        }
        return false;
      },
      regex: function(val, req) {
        var mod = /[g|i|m]{1,3}$/;
        var flag = req.match(mod);
        flag = flag ? flag[0] : "";
        req = req.replace(mod, "").slice(1, -1);
        req = new RegExp(req, flag);
        return !!req.test(val);
      },
      date: function(val, format) {
        return isValidDate$1(val);
      },
      present: function(val) {
        return typeof val !== "undefined";
      },
      after: function(val, req) {
        var val1 = this.validator.input[req];
        var val2 = val;
        if (!isValidDate$1(val1)) {
          return false;
        }
        if (!isValidDate$1(val2)) {
          return false;
        }
        if (new Date(val1).getTime() < new Date(val2).getTime()) {
          return true;
        }
        return false;
      },
      after_or_equal: function(val, req) {
        var val1 = this.validator.input[req];
        var val2 = val;
        if (!isValidDate$1(val1)) {
          return false;
        }
        if (!isValidDate$1(val2)) {
          return false;
        }
        if (new Date(val1).getTime() <= new Date(val2).getTime()) {
          return true;
        }
        return false;
      },
      before: function(val, req) {
        var val1 = this.validator.input[req];
        var val2 = val;
        if (!isValidDate$1(val1)) {
          return false;
        }
        if (!isValidDate$1(val2)) {
          return false;
        }
        if (new Date(val1).getTime() > new Date(val2).getTime()) {
          return true;
        }
        return false;
      },
      before_or_equal: function(val, req) {
        var val1 = this.validator.input[req];
        var val2 = val;
        if (!isValidDate$1(val1)) {
          return false;
        }
        if (!isValidDate$1(val2)) {
          return false;
        }
        if (new Date(val1).getTime() >= new Date(val2).getTime()) {
          return true;
        }
        return false;
      },
      hex: function(val) {
        return /^[0-9a-f]+$/i.test(val);
      },
      ipv4: function(val, req, attribute) {
        if (typeof val != "string")
          return false;
        var er = /^[0-9]+$/;
        octets = val.split(".");
        if (octets.length != 4)
          return false;
        for (let i = 0; i < octets.length; i++) {
          const element = octets[i];
          if (!er.test(element))
            return false;
          var octetValue = parseInt(element);
          if (octetValue >= 256)
            return false;
        }
        return true;
      },
      ipv6: function(val, req, attribute) {
        if (typeof val != "string")
          return false;
        var er = /^[0-9a-f]+$/;
        hextets = val.split(":");
        colons = val.match(/::/);
        if (colons != null && val.match(/::/g).length > 1)
          return false;
        if (val[0] == ":" && (colons == null || colons != null && colons.index != 0))
          return false;
        if (val[val.length - 1] == ":" && (colons == null || colons != null && colons.index != val.length - 2))
          return false;
        if (3 > hextets.length)
          return false;
        var isEdgeCase = hextets.length == 9 && colons != null && (colons.index == 0 || colons.index == val.length - 2);
        if (hextets.length > 8 && !isEdgeCase)
          return false;
        if (hextets.length != 8 && colons == null)
          return false;
        for (let i = 0; i < hextets.length; i++) {
          const element = hextets[i];
          if (element.length == 0)
            continue;
          if (!er.test(element))
            return false;
          if (element.length > 4)
            return false;
        }
        return true;
      },
      ip: function(val, req, attribute) {
        return rules["ipv4"](val, req, attribute) || rules["ipv6"](val, req, attribute);
      }
    };
    var missedRuleValidator = function() {
      throw new Error("Validator `" + this.name + "` is not defined!");
    };
    var missedRuleMessage;
    function Rule(name, fn, async2) {
      this.name = name;
      this.fn = fn;
      this.passes = null;
      this._customMessage = void 0;
      this.async = async2;
    }
    Rule.prototype = {
      /**
       * Validate rule
       *
       * @param  {mixed} inputValue
       * @param  {mixed} ruleValue
       * @param  {string} attribute
       * @param  {function} callback
       * @return {boolean|undefined}
       */
      validate: function(inputValue, ruleValue, attribute, callback) {
        var _this = this;
        this._setValidatingData(attribute, inputValue, ruleValue);
        if (typeof callback === "function") {
          this.callback = callback;
          var handleResponse = function(passes, message) {
            _this.response(passes, message);
          };
          if (this.async) {
            return this._apply(inputValue, ruleValue, attribute, handleResponse);
          } else {
            return handleResponse(this._apply(inputValue, ruleValue, attribute));
          }
        }
        return this._apply(inputValue, ruleValue, attribute);
      },
      /**
       * Apply validation function
       *
       * @param  {mixed} inputValue
       * @param  {mixed} ruleValue
       * @param  {string} attribute
       * @param  {function} callback
       * @return {boolean|undefined}
       */
      _apply: function(inputValue, ruleValue, attribute, callback) {
        var fn = this.isMissed() ? missedRuleValidator : this.fn;
        return fn.apply(this, [inputValue, ruleValue, attribute, callback]);
      },
      /**
       * Set validating data
       *
       * @param {string} attribute
       * @param {mixed} inputValue
       * @param {mixed} ruleValue
       * @return {void}
       */
      _setValidatingData: function(attribute, inputValue, ruleValue) {
        this.attribute = attribute;
        this.inputValue = inputValue;
        this.ruleValue = ruleValue;
      },
      /**
       * Get parameters
       *
       * @return {array}
       */
      getParameters: function() {
        var value = [];
        if (typeof this.ruleValue === "string") {
          value = this.ruleValue.split(",");
        }
        if (typeof this.ruleValue === "number") {
          value.push(this.ruleValue);
        }
        if (this.ruleValue instanceof Array) {
          value = this.ruleValue;
        }
        return value;
      },
      /**
       * Get true size of value
       *
       * @return {integer|float}
       */
      getSize: function() {
        var value = this.inputValue;
        if (value instanceof Array) {
          return value.length;
        }
        if (typeof value === "number") {
          return value;
        }
        if (this.validator._hasNumericRule(this.attribute)) {
          return parseFloat(value, 10);
        }
        return value.length;
      },
      /**
       * Get the type of value being checked; numeric or string.
       *
       * @return {string}
       */
      _getValueType: function() {
        if (typeof this.inputValue === "number" || this.validator._hasNumericRule(this.attribute)) {
          return "numeric";
        }
        return "string";
      },
      /**
       * Set the async callback response
       *
       * @param  {boolean|undefined} passes  Whether validation passed
       * @param  {string|undefined} message Custom error message
       * @return {void}
       */
      response: function(passes, message) {
        this.passes = passes === void 0 || passes === true;
        this._customMessage = message;
        this.callback(this.passes, message);
      },
      /**
       * Set validator instance
       *
       * @param {Validator} validator
       * @return {void}
       */
      setValidator: function(validator3) {
        this.validator = validator3;
      },
      /**
       * Check if rule is missed
       *
       * @return {boolean}
       */
      isMissed: function() {
        return typeof this.fn !== "function";
      },
      get customMessage() {
        return this.isMissed() ? missedRuleMessage : this._customMessage;
      }
    };
    var manager = {
      /**
       * List of async rule names
       *
       * @type {Array}
       */
      asyncRules: [],
      /**
       * Implicit rules (rules to always validate)
       *
       * @type {Array}
       */
      implicitRules: ["required", "required_if", "required_unless", "required_with", "required_with_all", "required_without", "required_without_all", "accepted", "present"],
      /**
       * Get rule by name
       *
       * @param  {string} name
       * @param {Validator}
       * @return {Rule}
       */
      make: function(name, validator3) {
        var async2 = this.isAsync(name);
        var rule = new Rule(name, rules[name], async2);
        rule.setValidator(validator3);
        return rule;
      },
      /**
       * Determine if given rule is async
       *
       * @param  {string}  name
       * @return {boolean}
       */
      isAsync: function(name) {
        for (var i = 0, len = this.asyncRules.length; i < len; i++) {
          if (this.asyncRules[i] === name) {
            return true;
          }
        }
        return false;
      },
      /**
       * Determine if rule is implicit (should always validate)
       *
       * @param {string} name
       * @return {boolean}
       */
      isImplicit: function(name) {
        return this.implicitRules.indexOf(name) > -1;
      },
      /**
       * Register new rule
       *
       * @param  {string}   name
       * @param  {function} fn
       * @return {void}
       */
      register: function(name, fn) {
        rules[name] = fn;
      },
      /**
       * Register new implicit rule
       *
       * @param  {string}   name
       * @param  {function} fn
       * @return {void}
       */
      registerImplicit: function(name, fn) {
        this.register(name, fn);
        this.implicitRules.push(name);
      },
      /**
       * Register async rule
       *
       * @param  {string}   name
       * @param  {function} fn
       * @return {void}
       */
      registerAsync: function(name, fn) {
        this.register(name, fn);
        this.asyncRules.push(name);
      },
      /**
       * Register implicit async rule
       *
       * @param  {string}   name
       * @param  {function} fn
       * @return {void}
       */
      registerAsyncImplicit: function(name, fn) {
        this.registerImplicit(name, fn);
        this.asyncRules.push(name);
      },
      registerMissedRuleValidator: function(fn, message) {
        missedRuleValidator = fn;
        missedRuleMessage = message;
      }
    };
    var rules_1 = manager;
    var replacements = {
      /**
       * Between replacement (replaces :min and :max)
       *
       * @param  {string} template
       * @param  {Rule} rule
       * @return {string}
       */
      between: function(template, rule) {
        var parameters = rule.getParameters();
        return this._replacePlaceholders(rule, template, {
          min: parameters[0],
          max: parameters[1]
        });
      },
      /**
       * Digits-Between replacement (replaces :min and :max)
       *
       * @param  {string} template
       * @param  {Rule} rule
       * @return {string}
       */
      digits_between: function(template, rule) {
        var parameters = rule.getParameters();
        return this._replacePlaceholders(rule, template, {
          min: parameters[0],
          max: parameters[1]
        });
      },
      /**
       * Required_if replacement.
       *
       * @param  {string} template
       * @param  {Rule} rule
       * @return {string}
       */
      required_if: function(template, rule) {
        var parameters = rule.getParameters();
        return this._replacePlaceholders(rule, template, {
          other: this._getAttributeName(parameters[0]),
          value: parameters[1]
        });
      },
      /**
       * Required_unless replacement.
       *
       * @param  {string} template
       * @param  {Rule} rule
       * @return {string}
       */
      required_unless: function(template, rule) {
        var parameters = rule.getParameters();
        return this._replacePlaceholders(rule, template, {
          other: this._getAttributeName(parameters[0]),
          value: parameters[1]
        });
      },
      /**
       * Required_with replacement.
       *
       * @param  {string} template
       * @param  {Rule} rule
       * @return {string}
       */
      required_with: function(template, rule) {
        var parameters = rule.getParameters();
        return this._replacePlaceholders(rule, template, {
          field: this._getAttributeName(parameters[0])
        });
      },
      /**
       * Required_with_all replacement.
       *
       * @param  {string} template
       * @param  {Rule} rule
       * @return {string}
       */
      required_with_all: function(template, rule) {
        var parameters = rule.getParameters();
        var getAttributeName = this._getAttributeName.bind(this);
        return this._replacePlaceholders(rule, template, {
          fields: parameters.map(getAttributeName).join(", ")
        });
      },
      /**
       * Required_without replacement.
       *
       * @param  {string} template
       * @param  {Rule} rule
       * @return {string}
       */
      required_without: function(template, rule) {
        var parameters = rule.getParameters();
        return this._replacePlaceholders(rule, template, {
          field: this._getAttributeName(parameters[0])
        });
      },
      /**
       * Required_without_all replacement.
       *
       * @param  {string} template
       * @param  {Rule} rule
       * @return {string}
       */
      required_without_all: function(template, rule) {
        var parameters = rule.getParameters();
        var getAttributeName = this._getAttributeName.bind(this);
        return this._replacePlaceholders(rule, template, {
          fields: parameters.map(getAttributeName).join(", ")
        });
      },
      /**
       * After replacement.
       *
       * @param  {string} template
       * @param  {Rule} rule
       * @return {string}
       */
      after: function(template, rule) {
        var parameters = rule.getParameters();
        return this._replacePlaceholders(rule, template, {
          after: this._getAttributeName(parameters[0])
        });
      },
      /**
       * Before replacement.
       *
       * @param  {string} template
       * @param  {Rule} rule
       * @return {string}
       */
      before: function(template, rule) {
        var parameters = rule.getParameters();
        return this._replacePlaceholders(rule, template, {
          before: this._getAttributeName(parameters[0])
        });
      },
      /**
       * After_or_equal replacement.
       *
       * @param  {string} template
       * @param  {Rule} rule
       * @return {string}
       */
      after_or_equal: function(template, rule) {
        var parameters = rule.getParameters();
        return this._replacePlaceholders(rule, template, {
          after_or_equal: this._getAttributeName(parameters[0])
        });
      },
      /**
       * Before_or_equal replacement.
       *
       * @param  {string} template
       * @param  {Rule} rule
       * @return {string}
       */
      before_or_equal: function(template, rule) {
        var parameters = rule.getParameters();
        return this._replacePlaceholders(rule, template, {
          before_or_equal: this._getAttributeName(parameters[0])
        });
      },
      /**
       * Same replacement.
       *
       * @param  {string} template
       * @param  {Rule} rule
       * @return {string}
       */
      same: function(template, rule) {
        var parameters = rule.getParameters();
        return this._replacePlaceholders(rule, template, {
          same: this._getAttributeName(parameters[0])
        });
      }
    };
    function formatter(attribute) {
      return attribute.replace(/[_\[]/g, " ").replace(/]/g, "");
    }
    var attributes = {
      replacements,
      formatter
    };
    var Attributes$1 = attributes;
    var Messages$1 = function(lang2, messages2) {
      this.lang = lang2;
      this.messages = messages2;
      this.customMessages = {};
      this.attributeNames = {};
    };
    Messages$1.prototype = {
      constructor: Messages$1,
      /**
       * Set custom messages
       *
       * @param {object} customMessages
       * @return {void}
       */
      _setCustom: function(customMessages) {
        this.customMessages = customMessages || {};
      },
      /**
       * Set custom attribute names.
       *
       * @param {object} attributes
       */
      _setAttributeNames: function(attributes2) {
        this.attributeNames = attributes2;
      },
      /**
       * Set the attribute formatter.
       *
       * @param {fuction} func
       * @return {void}
       */
      _setAttributeFormatter: function(func) {
        this.attributeFormatter = func;
      },
      /**
       * Get attribute name to display.
       *
       * @param  {string} attribute
       * @return {string}
       */
      _getAttributeName: function(attribute) {
        var name = attribute;
        if (this.attributeNames.hasOwnProperty(attribute)) {
          return this.attributeNames[attribute];
        } else if (this.messages.attributes.hasOwnProperty(attribute)) {
          name = this.messages.attributes[attribute];
        }
        if (this.attributeFormatter) {
          name = this.attributeFormatter(name);
        }
        return name;
      },
      /**
       * Get all messages
       *
       * @return {object}
       */
      all: function() {
        return this.messages;
      },
      /**
       * Render message
       *
       * @param  {Rule} rule
       * @return {string}
       */
      render: function(rule) {
        if (rule.customMessage) {
          return rule.customMessage;
        }
        var template = this._getTemplate(rule);
        var message;
        if (Attributes$1.replacements[rule.name]) {
          message = Attributes$1.replacements[rule.name].apply(this, [template, rule]);
        } else {
          message = this._replacePlaceholders(rule, template, {});
        }
        return message;
      },
      /**
       * Get the template to use for given rule
       *
       * @param  {Rule} rule
       * @return {string}
       */
      _getTemplate: function(rule) {
        var messages2 = this.messages;
        var template = messages2.def;
        var customMessages = this.customMessages;
        var formats = [rule.name + "." + rule.attribute, rule.name];
        for (var i = 0, format; i < formats.length; i++) {
          format = formats[i];
          if (customMessages.hasOwnProperty(format)) {
            template = customMessages[format];
            break;
          } else if (messages2.hasOwnProperty(format)) {
            template = messages2[format];
            break;
          }
        }
        if (typeof template === "object") {
          template = template[rule._getValueType()];
        }
        return template;
      },
      /**
       * Replace placeholders in the template using the data object
       *
       * @param  {Rule} rule
       * @param  {string} template
       * @param  {object} data
       * @return {string}
       */
      _replacePlaceholders: function(rule, template, data2) {
        var message, attribute;
        data2.attribute = this._getAttributeName(rule.attribute);
        data2[rule.name] = data2[rule.name] || rule.getParameters().join(",");
        if (typeof template === "string" && typeof data2 === "object") {
          message = template;
          for (attribute in data2) {
            message = message.replace(new RegExp(":" + attribute, "g"), data2[attribute]);
          }
        }
        return message;
      }
    };
    var messages$1 = Messages$1;
    var en = {
      accepted: "The :attribute must be accepted.",
      after: "The :attribute must be after :after.",
      after_or_equal: "The :attribute must be equal or after :after_or_equal.",
      alpha: "The :attribute field must contain only alphabetic characters.",
      alpha_dash: "The :attribute field may only contain alpha-numeric characters, as well as dashes and underscores.",
      alpha_num: "The :attribute field must be alphanumeric.",
      before: "The :attribute must be before :before.",
      before_or_equal: "The :attribute must be equal or before :before_or_equal.",
      between: {
        numeric: "The :attribute field must be between :min and :max.",
        string: "The :attribute field must be between :min and :max characters."
      },
      confirmed: "The :attribute confirmation does not match.",
      email: "The :attribute format is invalid.",
      date: "The :attribute is not a valid date format.",
      def: "The :attribute attribute has errors.",
      digits: "The :attribute must be :digits digits.",
      digits_between: "The :attribute field must be between :min and :max digits.",
      different: "The :attribute and :different must be different.",
      in: "The selected :attribute is invalid.",
      integer: "The :attribute must be an integer.",
      hex: "The :attribute field should have hexadecimal format",
      min: {
        numeric: "The :attribute must be at least :min.",
        string: "The :attribute must be at least :min characters."
      },
      max: {
        numeric: "The :attribute may not be greater than :max.",
        string: "The :attribute may not be greater than :max characters."
      },
      not_in: "The selected :attribute is invalid.",
      numeric: "The :attribute must be a number.",
      present: "The :attribute field must be present (but can be empty).",
      required: "The :attribute field is required.",
      required_if: "The :attribute field is required when :other is :value.",
      required_unless: "The :attribute field is required when :other is not :value.",
      required_with: "The :attribute field is required when :field is not empty.",
      required_with_all: "The :attribute field is required when :fields are not empty.",
      required_without: "The :attribute field is required when :field is empty.",
      required_without_all: "The :attribute field is required when :fields are empty.",
      same: "The :attribute and :same fields must match.",
      size: {
        numeric: "The :attribute must be :size.",
        string: "The :attribute must be :size characters."
      },
      string: "The :attribute must be a string.",
      url: "The :attribute format is invalid.",
      regex: "The :attribute format is invalid.",
      attributes: {}
    };
    var Messages = messages$1;
    var require_method = commonjsRequire;
    var container = {
      messages: {},
      /**
       * Set messages for language
       *
       * @param {string} lang
       * @param {object} rawMessages
       * @return {void}
       */
      _set: function(lang2, rawMessages) {
        this.messages[lang2] = rawMessages;
      },
      /**
       * Set message for given language's rule.
       *
       * @param {string} lang
       * @param {string} attribute
       * @param {string|object} message
       * @return {void}
       */
      _setRuleMessage: function(lang2, attribute, message) {
        this._load(lang2);
        if (message === void 0) {
          message = this.messages[lang2].def;
        }
        this.messages[lang2][attribute] = message;
      },
      /**
       * Load messages (if not already loaded)
       *
       * @param  {string} lang
       * @return {void}
       */
      _load: function(lang2) {
        if (!this.messages[lang2]) {
          try {
            var rawMessages = require_method("./lang/" + lang2);
            this._set(lang2, rawMessages);
          } catch (e) {
          }
        }
      },
      /**
       * Get raw messages for language
       *
       * @param  {string} lang
       * @return {object}
       */
      _get: function(lang2) {
        this._load(lang2);
        return this.messages[lang2];
      },
      /**
       * Make messages for given language
       *
       * @param  {string} lang
       * @return {Messages}
       */
      _make: function(lang2) {
        this._load(lang2);
        return new Messages(lang2, this.messages[lang2]);
      }
    };
    var lang = container;
    var Errors$1 = function() {
      this.errors = {};
    };
    Errors$1.prototype = {
      constructor: Errors$1,
      /**
       * Add new error message for given attribute
       *
       * @param  {string} attribute
       * @param  {string} message
       * @return {void}
       */
      add: function(attribute, message) {
        if (!this.has(attribute)) {
          this.errors[attribute] = [];
        }
        if (this.errors[attribute].indexOf(message) === -1) {
          this.errors[attribute].push(message);
        }
      },
      /**
       * Returns an array of error messages for an attribute, or an empty array
       *
       * @param  {string} attribute A key in the data object being validated
       * @return {array} An array of error messages
       */
      get: function(attribute) {
        if (this.has(attribute)) {
          return this.errors[attribute];
        }
        return [];
      },
      /**
       * Returns the first error message for an attribute, false otherwise
       *
       * @param  {string} attribute A key in the data object being validated
       * @return {string|false} First error message or false
       */
      first: function(attribute) {
        if (this.has(attribute)) {
          return this.errors[attribute][0];
        }
        return false;
      },
      /**
       * Get all error messages from all failing attributes
       *
       * @return {Object} Failed attribute names for keys and an array of messages for values
       */
      all: function() {
        return this.errors;
      },
      /**
       * Determine if there are any error messages for an attribute
       *
       * @param  {string}  attribute A key in the data object being validated
       * @return {boolean}
       */
      has: function(attribute) {
        if (this.errors.hasOwnProperty(attribute)) {
          return true;
        }
        return false;
      }
    };
    var errors = Errors$1;
    function AsyncResolvers$1(onFailedOne, onResolvedAll) {
      this.onResolvedAll = onResolvedAll;
      this.onFailedOne = onFailedOne;
      this.resolvers = {};
      this.resolversCount = 0;
      this.passed = [];
      this.failed = [];
      this.firing = false;
    }
    AsyncResolvers$1.prototype = {
      /**
       * Add resolver
       *
       * @param {Rule} rule
       * @return {integer}
       */
      add: function(rule) {
        var index2 = this.resolversCount;
        this.resolvers[index2] = rule;
        this.resolversCount++;
        return index2;
      },
      /**
       * Resolve given index
       *
       * @param  {integer} index
       * @return {void}
       */
      resolve: function(index2) {
        var rule = this.resolvers[index2];
        if (rule.passes === true) {
          this.passed.push(rule);
        } else if (rule.passes === false) {
          this.failed.push(rule);
          this.onFailedOne(rule);
        }
        this.fire();
      },
      /**
       * Determine if all have been resolved
       *
       * @return {boolean}
       */
      isAllResolved: function() {
        return this.passed.length + this.failed.length === this.resolversCount;
      },
      /**
       * Attempt to fire final all resolved callback if completed
       *
       * @return {void}
       */
      fire: function() {
        if (!this.firing) {
          return;
        }
        if (this.isAllResolved()) {
          this.onResolvedAll(this.failed.length === 0);
        }
      },
      /**
       * Enable firing
       *
       * @return {void}
       */
      enableFiring: function() {
        this.firing = true;
      }
    };
    var async = AsyncResolvers$1;
    var Rules$1 = rules_1;
    var Lang = lang;
    var Errors = errors;
    var Attributes = attributes;
    var AsyncResolvers = async;
    var Validator2 = function(input, rules2, customMessages) {
      var lang2 = Validator2.getDefaultLang();
      this.input = input || {};
      this.messages = Lang._make(lang2);
      this.messages._setCustom(customMessages);
      this.setAttributeFormatter(Validator2.prototype.attributeFormatter);
      this.errors = new Errors();
      this.errorCount = 0;
      this.hasAsync = false;
      this.rules = this._parseRules(rules2);
    };
    Validator2.prototype = {
      constructor: Validator2,
      /**
       * Default language
       *
       * @type {string}
       */
      lang: "en",
      /**
       * Numeric based rules
       *
       * @type {array}
       */
      numericRules: ["integer", "numeric"],
      /**
       * Attribute formatter.
       *
       * @type {function}
       */
      attributeFormatter: Attributes.formatter,
      /**
       * Run validator
       *
       * @return {boolean} Whether it passes; true = passes, false = fails
       */
      check: function() {
        for (var attribute in this.rules) {
          var attributeRules = this.rules[attribute];
          var inputValue = this._objectPath(this.input, attribute);
          if (this._hasRule(attribute, ["sometimes"]) && !this._suppliedWithData(attribute)) {
            continue;
          }
          for (var i = 0, len = attributeRules.length, rule, ruleOptions, rulePassed; i < len; i++) {
            ruleOptions = attributeRules[i];
            rule = this.getRule(ruleOptions.name);
            if (!this._isValidatable(rule, inputValue)) {
              continue;
            }
            rulePassed = rule.validate(inputValue, ruleOptions.value, attribute);
            if (!rulePassed) {
              this._addFailure(rule);
            }
            if (this._shouldStopValidating(attribute, rulePassed)) {
              break;
            }
          }
        }
        return this.errorCount === 0;
      },
      /**
       * Run async validator
       *
       * @param {function} passes
       * @param {function} fails
       * @return {void}
       */
      checkAsync: function(passes, fails) {
        var _this = this;
        passes = passes || function() {
        };
        fails = fails || function() {
        };
        var failsOne = function(rule2, message) {
          _this._addFailure(rule2, message);
        };
        var resolvedAll = function(allPassed) {
          if (allPassed) {
            passes();
          } else {
            fails();
          }
        };
        var asyncResolvers = new AsyncResolvers(failsOne, resolvedAll);
        var validateRule = function(inputValue2, ruleOptions2, attribute2, rule2) {
          return function() {
            var resolverIndex = asyncResolvers.add(rule2);
            rule2.validate(inputValue2, ruleOptions2.value, attribute2, function() {
              asyncResolvers.resolve(resolverIndex);
            });
          };
        };
        for (var attribute in this.rules) {
          var attributeRules = this.rules[attribute];
          var inputValue = this._objectPath(this.input, attribute);
          if (this._hasRule(attribute, ["sometimes"]) && !this._suppliedWithData(attribute)) {
            continue;
          }
          for (var i = 0, len = attributeRules.length, rule, ruleOptions; i < len; i++) {
            ruleOptions = attributeRules[i];
            rule = this.getRule(ruleOptions.name);
            if (!this._isValidatable(rule, inputValue)) {
              continue;
            }
            validateRule(inputValue, ruleOptions, attribute, rule)();
          }
        }
        asyncResolvers.enableFiring();
        asyncResolvers.fire();
      },
      /**
       * Add failure and error message for given rule
       *
       * @param {Rule} rule
       */
      _addFailure: function(rule) {
        var msg = this.messages.render(rule);
        this.errors.add(rule.attribute, msg);
        this.errorCount++;
      },
      /**
       * Flatten nested object, normalizing { foo: { bar: 1 } } into: { 'foo.bar': 1 }
       *
       * @param  {object} nested object
       * @return {object} flattened object
       */
      _flattenObject: function(obj) {
        var flattened = {};
        function recurse(current, property) {
          if (!property && Object.getOwnPropertyNames(current).length === 0) {
            return;
          }
          if (Object(current) !== current || Array.isArray(current)) {
            flattened[property] = current;
          } else {
            var isEmpty = true;
            for (var p in current) {
              isEmpty = false;
              recurse(current[p], property ? property + "." + p : p);
            }
            if (isEmpty) {
              flattened[property] = {};
            }
          }
        }
        if (obj) {
          recurse(obj);
        }
        return flattened;
      },
      /**
       * Extract value from nested object using string path with dot notation
       *
       * @param  {object} object to search in
       * @param  {string} path inside object
       * @return {any|void} value under the path
       */
      _objectPath: function(obj, path) {
        if (Object.prototype.hasOwnProperty.call(obj, path)) {
          return obj[path];
        }
        var keys = path.replace(/\[(\w+)\]/g, ".$1").replace(/^\./, "").split(".");
        var copy = {};
        for (var attr in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, attr)) {
            copy[attr] = obj[attr];
          }
        }
        for (var i = 0, l = keys.length; i < l; i++) {
          if (typeof copy === "object" && copy !== null && Object.hasOwnProperty.call(copy, keys[i])) {
            copy = copy[keys[i]];
          } else {
            return;
          }
        }
        return copy;
      },
      /**
       * Parse rules, normalizing format into: { attribute: [{ name: 'age', value: 3 }] }
       *
       * @param  {object} rules
       * @return {object}
       */
      _parseRules: function(rules2) {
        var parsedRules = {};
        rules2 = this._flattenObject(rules2);
        for (var attribute in rules2) {
          var rulesArray = rules2[attribute];
          this._parseRulesCheck(attribute, rulesArray, parsedRules);
        }
        return parsedRules;
      },
      _parseRulesCheck: function(attribute, rulesArray, parsedRules, wildCardValues) {
        if (attribute.indexOf("*") > -1) {
          this._parsedRulesRecurse(attribute, rulesArray, parsedRules, wildCardValues);
        } else {
          this._parseRulesDefault(attribute, rulesArray, parsedRules, wildCardValues);
        }
      },
      _parsedRulesRecurse: function(attribute, rulesArray, parsedRules, wildCardValues) {
        var parentPath = attribute.substr(0, attribute.indexOf("*") - 1);
        var propertyValue = this._objectPath(this.input, parentPath);
        if (propertyValue) {
          for (var propertyNumber = 0; propertyNumber < propertyValue.length; propertyNumber++) {
            var workingValues = wildCardValues ? wildCardValues.slice() : [];
            workingValues.push(propertyNumber);
            this._parseRulesCheck(attribute.replace("*", propertyNumber), rulesArray, parsedRules, workingValues);
          }
        }
      },
      _parseRulesDefault: function(attribute, rulesArray, parsedRules, wildCardValues) {
        var attributeRules = [];
        if (rulesArray instanceof Array) {
          rulesArray = this._prepareRulesArray(rulesArray);
        }
        if (typeof rulesArray === "string") {
          rulesArray = rulesArray.split("|");
        }
        for (var i = 0, len = rulesArray.length, rule; i < len; i++) {
          rule = typeof rulesArray[i] === "string" ? this._extractRuleAndRuleValue(rulesArray[i]) : rulesArray[i];
          if (rule.value) {
            rule.value = this._replaceWildCards(rule.value, wildCardValues);
            this._replaceWildCardsMessages(wildCardValues);
          }
          if (Rules$1.isAsync(rule.name)) {
            this.hasAsync = true;
          }
          attributeRules.push(rule);
        }
        parsedRules[attribute] = attributeRules;
      },
      _replaceWildCards: function(path, nums) {
        if (!nums) {
          return path;
        }
        var path2 = path;
        nums.forEach(function(value) {
          if (Array.isArray(path2)) {
            path2 = path2[0];
          }
          const pos = path2.indexOf("*");
          if (pos === -1) {
            return path2;
          }
          path2 = path2.substr(0, pos) + value + path2.substr(pos + 1);
        });
        if (Array.isArray(path)) {
          path[0] = path2;
          path2 = path;
        }
        return path2;
      },
      _replaceWildCardsMessages: function(nums) {
        var customMessages = this.messages.customMessages;
        var self2 = this;
        Object.keys(customMessages).forEach(function(key) {
          if (nums) {
            var newKey = self2._replaceWildCards(key, nums);
            customMessages[newKey] = customMessages[key];
          }
        });
        this.messages._setCustom(customMessages);
      },
      /**
       * Prepare rules if it comes in Array. Check for objects. Need for type validation.
       *
       * @param  {array} rulesArray
       * @return {array}
       */
      _prepareRulesArray: function(rulesArray) {
        var rules2 = [];
        for (var i = 0, len = rulesArray.length; i < len; i++) {
          if (typeof rulesArray[i] === "object") {
            for (var rule in rulesArray[i]) {
              rules2.push({
                name: rule,
                value: rulesArray[i][rule]
              });
            }
          } else {
            rules2.push(rulesArray[i]);
          }
        }
        return rules2;
      },
      /**
       * Determines if the attribute is supplied with the original data object.
       *
       * @param  {array} attribute
       * @return {boolean}
       */
      _suppliedWithData: function(attribute) {
        return this.input.hasOwnProperty(attribute);
      },
      /**
       * Extract a rule and a value from a ruleString (i.e. min:3), rule = min, value = 3
       *
       * @param  {string} ruleString min:3
       * @return {object} object containing the name of the rule and value
       */
      _extractRuleAndRuleValue: function(ruleString) {
        var rule = {}, ruleArray;
        rule.name = ruleString;
        if (ruleString.indexOf(":") >= 0) {
          ruleArray = ruleString.split(":");
          rule.name = ruleArray[0];
          rule.value = ruleArray.slice(1).join(":");
        }
        return rule;
      },
      /**
       * Determine if attribute has any of the given rules
       *
       * @param  {string}  attribute
       * @param  {array}   findRules
       * @return {boolean}
       */
      _hasRule: function(attribute, findRules) {
        var rules2 = this.rules[attribute] || [];
        for (var i = 0, len = rules2.length; i < len; i++) {
          if (findRules.indexOf(rules2[i].name) > -1) {
            return true;
          }
        }
        return false;
      },
      /**
       * Determine if attribute has any numeric-based rules.
       *
       * @param  {string}  attribute
       * @return {Boolean}
       */
      _hasNumericRule: function(attribute) {
        return this._hasRule(attribute, this.numericRules);
      },
      /**
       * Determine if rule is validatable
       *
       * @param  {Rule}   rule
       * @param  {mixed}  value
       * @return {boolean}
       */
      _isValidatable: function(rule, value) {
        if (Array.isArray(value)) {
          return true;
        }
        if (Rules$1.isImplicit(rule.name)) {
          return true;
        }
        return this.getRule("required").validate(value);
      },
      /**
       * Determine if we should stop validating.
       *
       * @param  {string} attribute
       * @param  {boolean} rulePassed
       * @return {boolean}
       */
      _shouldStopValidating: function(attribute, rulePassed) {
        var stopOnAttributes = this.stopOnAttributes;
        if (typeof stopOnAttributes === "undefined" || stopOnAttributes === false || rulePassed === true) {
          return false;
        }
        if (stopOnAttributes instanceof Array) {
          return stopOnAttributes.indexOf(attribute) > -1;
        }
        return true;
      },
      /**
       * Set custom attribute names.
       *
       * @param {object} attributes
       * @return {void}
       */
      setAttributeNames: function(attributes2) {
        this.messages._setAttributeNames(attributes2);
      },
      /**
       * Set the attribute formatter.
       *
       * @param {fuction} func
       * @return {void}
       */
      setAttributeFormatter: function(func) {
        this.messages._setAttributeFormatter(func);
      },
      /**
       * Get validation rule
       *
       * @param  {string} name
       * @return {Rule}
       */
      getRule: function(name) {
        return Rules$1.make(name, this);
      },
      /**
       * Stop on first error.
       *
       * @param  {boolean|array} An array of attributes or boolean true/false for all attributes.
       * @return {void}
       */
      stopOnError: function(attributes2) {
        this.stopOnAttributes = attributes2;
      },
      /**
       * Determine if validation passes
       *
       * @param {function} passes
       * @return {boolean|undefined}
       */
      passes: function(passes) {
        var async2 = this._checkAsync("passes", passes);
        if (async2) {
          return this.checkAsync(passes);
        }
        return this.check();
      },
      /**
       * Determine if validation fails
       *
       * @param {function} fails
       * @return {boolean|undefined}
       */
      fails: function(fails) {
        var async2 = this._checkAsync("fails", fails);
        if (async2) {
          return this.checkAsync(function() {
          }, fails);
        }
        return !this.check();
      },
      /**
       * Check if validation should be called asynchronously
       *
       * @param  {string}   funcName Name of the caller
       * @param  {function} callback
       * @return {boolean}
       */
      _checkAsync: function(funcName, callback) {
        var hasCallback = typeof callback === "function";
        if (this.hasAsync && !hasCallback) {
          throw funcName + " expects a callback when async rules are being tested.";
        }
        return this.hasAsync || hasCallback;
      }
    };
    Validator2.setMessages = function(lang2, messages2) {
      Lang._set(lang2, messages2);
      return this;
    };
    Validator2.getMessages = function(lang2) {
      return Lang._get(lang2);
    };
    Validator2.useLang = function(lang2) {
      this.prototype.lang = lang2;
    };
    Validator2.getDefaultLang = function() {
      return this.prototype.lang;
    };
    Validator2.setAttributeFormatter = function(func) {
      this.prototype.attributeFormatter = func;
    };
    Validator2.stopOnError = function(attributes2) {
      this.prototype.stopOnAttributes = attributes2;
    };
    Validator2.register = function(name, fn, message, fnReplacement) {
      var lang2 = Validator2.getDefaultLang();
      Rules$1.register(name, fn);
      Lang._setRuleMessage(lang2, name, message);
    };
    Validator2.registerImplicit = function(name, fn, message, fnReplacement) {
      var lang2 = Validator2.getDefaultLang();
      Rules$1.registerImplicit(name, fn);
      Lang._setRuleMessage(lang2, name, message);
    };
    Validator2.registerAsync = function(name, fn, message, fnReplacement) {
      var lang2 = Validator2.getDefaultLang();
      Rules$1.registerAsync(name, fn);
      Lang._setRuleMessage(lang2, name, message);
    };
    Validator2.registerAsyncImplicit = function(name, fn, message) {
      var lang2 = Validator2.getDefaultLang();
      Rules$1.registerAsyncImplicit(name, fn);
      Lang._setRuleMessage(lang2, name, message);
    };
    Validator2.registerMissedRuleValidator = function(fn, message) {
      Rules$1.registerMissedRuleValidator(fn, message);
    };
    var validator$2 = Validator2;
    validator$2.setMessages("en", en || { def: "The :attribute attribute has errors.", attributes: {} });
    validator$2.registerMissedRuleValidator(() => true);
    function leapYear(year) {
      return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    function checkFalsePositiveDates(dateString = "") {
      if (dateString.length === 10) {
        const normalizedDate = dateString.replace(".", "-").replace("/", "-");
        const parts = normalizedDate.split("-");
        if (parts.length === 3) {
          if (parts[0].length === 4) {
            const y = parseInt(parts[0], 10);
            const m = parseInt(parts[1], 10);
            const d = parseInt(parts[2], 10);
            if (m === 2) {
              if (leapYear(y)) {
                if (d > 29) {
                  return false;
                }
              } else if (d > 28) {
                return false;
              }
            }
            if (m === 4 || m === 6 || m === 9 || m === 11) {
              if (d > 30) {
                return false;
              }
            }
          }
        }
        return true;
      }
      return true;
    }
    function isValidDate(dateString) {
      let testDate;
      if (typeof dateString === "number") {
        testDate = new Date(dateString);
        if (typeof testDate === "object") {
          return true;
        }
        dateString = `${dateString}`;
      } else if (typeof dateString === "boolean") {
        return false;
      }
      testDate = new Date(dateString);
      if (typeof testDate === "object") {
        if (testDate.toString() === "Invalid Date") {
          return false;
        }
        if (!checkFalsePositiveDates(dateString)) {
          return false;
        }
        return true;
      }
      const regex_date = /^\d{4}-\d{1,2}-\d{1,2}$/;
      if (!regex_date.test(dateString)) {
        return false;
      }
      const parts = dateString.split("-");
      const day = parseInt(parts[2], 10);
      const month = parseInt(parts[1], 10);
      const year = parseInt(parts[0], 10);
      if (year < 1e3 || year > 3e3 || month === 0 || month > 12) {
        return false;
      }
      const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
      if (year % 400 === 0 || year % 100 !== 0 && year % 4 === 0) {
        monthLength[1] = 29;
      }
      return day > 0 && day <= monthLength[month - 1];
    }
    function after(val, req) {
      let val1 = req;
      if (!isValidDate(val)) {
        return false;
      }
      if (!isValidDate(val1)) {
        val1 = this.validator.input[val1];
        if (!isValidDate(val1)) {
          return false;
        }
      }
      return new Date(val1).getTime() < new Date(val).getTime();
    }
    function after_or_equal(val, req) {
      let val1 = req;
      if (!isValidDate(val)) {
        return false;
      }
      if (!isValidDate(val1)) {
        val1 = this.validator.input[val1];
        if (!isValidDate(val1)) {
          return false;
        }
      }
      return new Date(val1).getTime() <= new Date(val).getTime();
    }
    function before(val, req) {
      let val1 = req;
      if (!isValidDate(val)) {
        return false;
      }
      if (!isValidDate(val1)) {
        val1 = this.validator.input[val1];
        if (!isValidDate(val1)) {
          return false;
        }
      }
      return new Date(val1).getTime() > new Date(val).getTime();
    }
    function before_or_equal(val, req) {
      let val1 = req;
      if (!isValidDate(val)) {
        return false;
      }
      if (!isValidDate(val1)) {
        val1 = this.validator.input[val1];
        if (!isValidDate(val1)) {
          return false;
        }
      }
      return new Date(val1).getTime() >= new Date(val).getTime();
    }
    const messages = validator$2.getMessages(validator$2.getDefaultLang());
    validator$2.register("after", after, messages && typeof messages.after === "string" ? messages.after : void 0);
    validator$2.register("after_or_equal", after_or_equal, messages && typeof messages.after_or_equal === "string" ? messages.after_or_equal : void 0);
    validator$2.register("before", before, messages && typeof messages.before === "string" ? messages.before : void 0);
    validator$2.register("before_or_equal", before_or_equal, messages && typeof messages.before_or_equal === "string" ? messages.before_or_equal : void 0);
    function isCrudApiError(e) {
      if (!e) {
        return false;
      }
      const crudApiError = e;
      return !!crudApiError.response && crudApiError.response.status !== void 0 && Number.isInteger(crudApiError.response.status) && crudApiError.response.statusText !== void 0 && !!crudApiError.response.data && crudApiError.response.data.status_code !== void 0 && crudApiError.response.data.error_description !== void 0;
    }
    function marshalCrudValidationData(data2) {
      if (!isCrudApiError(data2)) {
        const unexpectedError = new UnexpectedError(data2);
        const unexpectedSlug = unexpectedError.toSlug();
        return {
          slug: unexpectedSlug.key,
          data: {
            ...unexpectedSlug.data,
            message: unexpectedError.toString()
          },
          messages: {}
        };
      }
      const slugData = {
        status: data2.response.status,
        statusText: data2.response.statusText,
        statusCode: data2.response.data.status_code
      };
      if (typeof data2.response.data.error_description === "string") {
        slugData.message = data2.response.data.error_description;
      }
      const messages2 = {};
      let errorDescription = data2.response.data.error_description;
      if (typeof errorDescription === "object") {
        if (typeof errorDescription.message === "object") {
          errorDescription = errorDescription.message;
        }
        for (const errorDescriptionKey in errorDescription) {
          if (!Object.prototype.hasOwnProperty.call(errorDescription, errorDescriptionKey)) {
            continue;
          }
          if (typeof errorDescription[errorDescriptionKey] === "string" || Array.isArray(errorDescription[errorDescriptionKey])) {
            messages2[errorDescriptionKey] = errorDescription[errorDescriptionKey];
          }
        }
      }
      return {
        slug: "sdkhelpers.crud.errors.validation_error",
        data: slugData,
        messages: messages2
      };
    }
    function isCrudValidationError(e) {
      return e && e._isCrudValidationError;
    }
    class CrudValidationError extends BaseError {
      constructor(data2) {
        super(marshalCrudValidationData(data2));
        this._isCrudValidationError = true;
      }
      toString() {
        throw new Error("CrudValidationError.toString not yet implemented.");
      }
      toSlug() {
        return {
          key: this.data.slug,
          data: this.data.data
        };
      }
    }
    class FormValidationResult {
      constructor(data2) {
        this.valid = false;
        this._data = data2;
      }
      static create(data2) {
        if (!data2 || Object.values(data2.messages).every((message) => !message || !message.length)) {
          return this.valid();
        }
        return this.invalid(data2);
      }
      static valid() {
        return { valid: true };
      }
      static invalid(data2) {
        return new this(data2);
      }
      get result() {
        return this._data;
      }
    }
    class ModelForm extends Form {
      constructor(relation, model) {
        super({
          data: model.props,
          submit: (data2, original) => this._submit(data2, original),
          validate: (data2) => this._validate(data2)
        });
        this._model = model;
        this._relation = relation;
        if (relation.rules) {
          void relation.rules().then((rules2) => {
            if (!rules2) {
              return;
            }
            this._rules = rules2;
            for (const key in rules2) {
              if (!this.props[key]) {
                continue;
              }
              this.props[key].rules = rules2[key];
            }
          });
        }
      }
      async _submit(data2, original) {
        const filteredData = {};
        for (const key in data2) {
          if (!Object.prototype.hasOwnProperty.call(data2, key)) {
            continue;
          }
          if (original[key] !== data2[key] || this.props[key].rules.includes("required")) {
            filteredData[key] = data2[key];
          }
        }
        try {
          if (this._model.isNew) {
            await this._relation.create(filteredData, this._model);
          } else {
            await this._relation.update(filteredData, this._model);
          }
        } catch (e) {
          if (isCrudValidationError(e)) {
            throw new FormValidationError(e.data);
          }
          throw e;
        }
      }
      async _validate(data2) {
        const validation = new validator$2(data2, this._rules);
        if (validation.check()) {
          return FormValidationResult.valid();
        }
        return FormValidationResult.invalid({
          slug: "libsdkhelpers.form.model_form.validation_error",
          messages: validation.errors.errors
        });
      }
    }
    var urlJoin$1 = { exports: {} };
    (function(module2) {
      (function(name, context, definition) {
        if (module2.exports)
          module2.exports = definition();
        else
          context[name] = definition();
      })("urljoin", commonjsGlobal$1, function() {
        function normalize2(strArray) {
          var resultArray = [];
          if (strArray.length === 0) {
            return "";
          }
          if (typeof strArray[0] !== "string") {
            throw new TypeError("Url must be a string. Received " + strArray[0]);
          }
          if (strArray[0].match(/^[^/:]+:\/*$/) && strArray.length > 1) {
            var first = strArray.shift();
            strArray[0] = first + strArray[0];
          }
          if (strArray[0].match(/^file:\/\/\//)) {
            strArray[0] = strArray[0].replace(/^([^/:]+):\/*/, "$1:///");
          } else {
            strArray[0] = strArray[0].replace(/^([^/:]+):\/*/, "$1://");
          }
          for (var i = 0; i < strArray.length; i++) {
            var component = strArray[i];
            if (typeof component !== "string") {
              throw new TypeError("Url must be a string. Received " + component);
            }
            if (component === "") {
              continue;
            }
            if (i > 0) {
              component = component.replace(/^[\/]+/, "");
            }
            if (i < strArray.length - 1) {
              component = component.replace(/[\/]+$/, "");
            } else {
              component = component.replace(/[\/]+$/, "/");
            }
            resultArray.push(component);
          }
          var str = resultArray.join("/");
          str = str.replace(/\/(\?|&|#[^!])/g, "$1");
          var parts = str.split("?");
          str = parts.shift() + (parts.length > 0 ? "?" : "") + parts.join("&");
          return str;
        }
        return function() {
          var input;
          if (typeof arguments[0] === "object") {
            input = arguments[0];
          } else {
            input = [].slice.call(arguments);
          }
          return normalize2(input);
        };
      });
    })(urlJoin$1);
    var urlJoin2 = urlJoin$1.exports;
    class CrudNode {
      constructor(parent, type, paths) {
        this._parent = parent;
        this._type = type;
        this.paths = paths || [];
      }
      get $path() {
        throw Error("$path not implemented");
      }
      get $routes() {
        return [];
      }
      get $http() {
        return this._parent.$http;
      }
      get $log() {
        return this._parent.$log;
      }
      get $root() {
        return this._parent.$root;
      }
      get $factory() {
        return this._parent.$factory;
      }
      get type() {
        return this._type;
      }
      get parent() {
        return this._parent;
      }
    }
    class CrudToOne extends CrudNode {
      constructor(parent, type, config) {
        super(parent, type);
        this._config = config;
      }
      get $path() {
        return urlJoin2(this._parent.$path, this._config.path || this.type);
      }
      async link(model) {
        const path = urlJoin2(this.$path, model.guid);
        await this.$http.put(path);
        this._model = model;
      }
      async get() {
        if (this._model) {
          return this._model;
        }
        const response = await this.$http.get(this.$path);
        return this._model = this.$factory.getOrCreate(this.rootRelation, this.type, response.data);
      }
      set(data2) {
        if (!data2.guid) {
          throw Error("to_one.set data has not guid");
        }
        this._model = this.$factory.getOrCreate(this.rootRelation, this.type, data2);
      }
      get rootRelation() {
        if (this.parent !== this.$root) {
          return this.$root.getRelation(this.type);
        }
        return this;
      }
    }
    class CrudToManyMixin {
      constructor(instance) {
        this.instance = instance;
      }
      get rootRelation() {
        if (this.instance.parent !== this.instance.$root) {
          return this.instance.$root.getRelation(this.instance.type);
        }
        return this.instance;
      }
      rawDataToModels(data2, type = this.instance.type) {
        return data2.map((item) => this.instance.$factory.getOrCreate(this.rootRelation, type, item));
      }
    }
    CrudToManyMixin.mixin = "<mixin-name>";
    CrudToManyMixin.routes = [];
    class Sort extends CrudToManyMixin {
      constructor() {
        super(...arguments);
        this.getSortedPage = async (request) => {
          const rawResponse = await this.instance.$http.get(this.instance.$path, {
            params: request
          });
          return {
            ...rawResponse.data,
            data: this.rawDataToModels(rawResponse.data.data)
          };
        };
      }
      /**
       *
       * Used to reposition a model.
       *
       * @param model The model to reposition
       * @param order Where to position the model relative to the anchor model
       * @param anchor The model after (or before) which the given model will be positioned
       *
       */
      async sortModel(model, order, anchor) {
        const path = urlJoin2(this.instance.$path, encodeURIComponent(anchor.guid), order, encodeURIComponent(model.guid));
        await this.instance.$http.put(path);
      }
    }
    Sort.mixin = "sort";
    Sort.routes = [
      {
        method: "PUT",
        uri: "sort"
      },
      {
        method: "GET|HEAD",
        uri: ""
      }
    ];
    class Pick extends CrudToManyMixin {
      constructor() {
        super(...arguments);
        this.getPickerPage = async (request) => {
          const rawResponse = await this.instance.$http.get(`${this.instance.$path}/pick`, {
            params: request
          });
          return {
            ...rawResponse.data,
            data: this.rawDataToModels(rawResponse.data.data)
          };
        };
        this.linkPickerModels = async (models) => {
          const path = urlJoin2(this.instance.$path, "multi");
          await this.instance.$http.put(path, models);
        };
        this.unlinkPickerModels = async (models) => {
          const path = urlJoin2(this.instance.$path, "multi");
          await this.instance.$http.delete(path, {
            data: models
          });
        };
      }
    }
    Pick.mixin = "pick";
    Pick.routes = [
      {
        method: "GET|HEAD",
        uri: "pick"
      }
    ];
    class NestedPick extends CrudToManyMixin {
      constructor() {
        super(...arguments);
        this.getPickerSumsPage = async (request) => {
          const rawResponse = await this.instance.$http.get(`${this.instance.$path}/pick/sums`, {
            params: request
          });
          const type = this.instance._config.pickerSumsType;
          if (!type) {
            throw Error("pickerSumsType is not defined on ToMany config");
          }
          return {
            ...rawResponse.data,
            data: this.rawDataToModels(rawResponse.data.data, type)
          };
        };
        this.getPickerNestedPage = async (request) => {
          const rawResponse = await this.instance.$http.get(`${this.instance.$path}/pick/${request.guid}`, {
            params: request
          });
          return {
            ...rawResponse.data,
            data: this.rawDataToModels(rawResponse.data.data)
          };
        };
        this.linkPickerModels = async (models) => {
          const path = urlJoin2(this.instance.$path, "multi");
          await this.instance.$http.put(path, models);
        };
        this.unlinkPickerModels = async (models) => {
          const path = urlJoin2(this.instance.$path, "multi");
          await this.instance.$http.delete(path, {
            data: models
          });
        };
      }
    }
    NestedPick.mixin = "multi_picker";
    NestedPick.routes = [
      {
        method: "GET|HEAD",
        uri: "pick/sums"
      },
      {
        method: "GET|HEAD",
        uri: "pick/{id}"
      }
    ];
    class Create extends CrudToManyMixin {
      constructor() {
        super(...arguments);
        this.create = async (data2, model) => {
          try {
            const response = await this.instance.$http.post(this.instance.$path, data2);
            model.setData(response.data);
            this.instance.$factory.add(this.instance.type, model);
          } catch (e) {
            if (isCrudApiError(e) && e.response.status === 406) {
              throw new CrudValidationError(e);
            }
            throw new UnexpectedError(e);
          }
        };
      }
      new(data2) {
        const newModel = this.instance.$factory.new(this.rootRelation, this.instance.type);
        if (data2) {
          newModel.setData(data2);
        }
        return newModel;
      }
    }
    Create.mixin = "create";
    Create.routes = [
      {
        method: "POST",
        uri: ""
      }
    ];
    class Link extends CrudToManyMixin {
      async link(model) {
        const path = urlJoin2(this.instance.$path, encodeURIComponent(model.guid));
        await this.instance.$http.put(path);
      }
    }
    Link.mixin = "link";
    Link.routes = [
      {
        method: "PUT",
        uri: "{id}"
      }
    ];
    class LinkMulti extends CrudToManyMixin {
      async linkMulti(models) {
        const path = urlJoin2(this.instance.$path, "multi");
        await this.instance.$http.put(path, models.map((model) => model.guid));
      }
    }
    LinkMulti.mixin = "link_multi";
    LinkMulti.routes = [
      {
        method: "PUT",
        uri: "multi"
      }
    ];
    class Rules extends CrudToManyMixin {
      constructor() {
        super(...arguments);
        this.rules = async () => {
          if (this.instance.__rules) {
            return this.instance.__rules;
          }
          const path = urlJoin2(this.instance.$path, "rules");
          const response = await this.instance.$http.get(path);
          return this.instance.__rules = response.data;
        };
      }
    }
    Rules.mixin = "rules";
    Rules.routes = [
      {
        method: "GET|HEAD",
        uri: "rules"
      }
    ];
    class Delete extends CrudToManyMixin {
      async delete(model) {
        const path = urlJoin2(this.instance.$path, encodeURIComponent(model.guid));
        await this.instance.$http.delete(path);
      }
    }
    Delete.mixin = "delete";
    Delete.routes = [
      {
        method: "DELETE",
        uri: "{id}"
      }
    ];
    class List extends CrudToManyMixin {
      constructor() {
        super(...arguments);
        this.getPage = async (request) => {
          const rawResponse = await this.instance.$http.get(this.instance.$path, {
            params: request
          });
          this.instance._setAdditionalFields(rawResponse.data);
          return {
            ...rawResponse.data,
            data: this.rawDataToModels(rawResponse.data.data)
          };
        };
      }
      canOrder(field) {
        if (!this.instance.__filters) {
          return false;
        }
        for (const filter2 of Object.values(this.instance.__filters)) {
          if (filter2.target !== field) {
            continue;
          }
          return filter2.match === "exact" || filter2.match === "partial";
        }
        return false;
      }
    }
    List.mixin = "list";
    List.routes = [
      {
        method: "GET|HEAD",
        uri: ""
      }
    ];
    class ListAll extends CrudToManyMixin {
      constructor() {
        super(...arguments);
        this.getPageByType = async (request) => {
          const rawResponse = await this.instance.$http.get(this.instance.$path, {
            params: request
          });
          return {
            ...rawResponse.data,
            data: this.rawDataToModels(rawResponse.data.data)
          };
        };
      }
    }
    ListAll.mixin = "list_all";
    ListAll.routes = [
      {
        method: "GET|HEAD",
        uri: ""
      },
      {
        method: "GET|HEAD",
        uri: "list/{type}"
      }
    ];
    class Reinstate extends CrudToManyMixin {
      async reinstate(guid) {
        const path = urlJoin2(this.instance.$path, encodeURIComponent(guid), "reinstate");
        await this.instance.$http.post(path);
      }
    }
    Reinstate.mixin = "reinstate";
    Reinstate.routes = [
      {
        method: "POST",
        uri: "{id}/reinstate"
      }
    ];
    class Unlink extends CrudToManyMixin {
      async unlink(model) {
        const path = urlJoin2(this.instance.$path, encodeURIComponent(model.guid));
        await this.instance.$http.delete(path);
      }
    }
    Unlink.mixin = "detach";
    Unlink.routes = [
      {
        method: "DELETE",
        uri: "{id}"
      }
    ];
    class UnlinkMulti extends CrudToManyMixin {
      async unlinkMulti(models) {
        const path = urlJoin2(this.instance.$path, "multi");
        await this.instance.$http.delete(path, {
          data: models.map((model) => model.guid)
        });
      }
    }
    UnlinkMulti.mixin = "unlink_multi";
    UnlinkMulti.routes = [
      {
        method: "DELETE",
        uri: "multi"
      }
    ];
    class Filters extends CrudToManyMixin {
      async getFilters() {
        if (this.instance.__filters) {
          return this.instance.__filters;
        }
        const path = urlJoin2(this.instance.$path, "filters");
        const response = await this.instance.$http.get(path);
        return this.instance.__filters = response.data;
      }
    }
    Filters.mixin = "filters";
    Filters.routes = [
      {
        method: "GET|HEAD",
        uri: "filters"
      }
    ];
    class Get extends CrudToManyMixin {
      async get(guid) {
        const path = urlJoin2(this.instance.$path, encodeURIComponent(guid));
        const response = await this.instance.$http.get(path);
        return this.instance.$factory.getOrCreate(this.rootRelation, this.instance.type, response.data);
      }
    }
    Get.mixin = "get";
    Get.routes = [
      {
        method: "GET|HEAD",
        uri: "{id}"
      }
    ];
    class Update extends CrudToManyMixin {
      constructor() {
        super(...arguments);
        this.update = async (data2, model) => {
          try {
            const path = urlJoin2(this.instance.$path, encodeURIComponent(model.guid));
            await this.instance.$http.patch(path, data2);
            model.setData(data2);
          } catch (e) {
            if (isCrudApiError(e) && e.response.status === 406) {
              throw new CrudValidationError(e);
            }
            throw new UnexpectedError(e);
          }
        };
      }
    }
    Update.mixin = "update";
    Update.routes = [
      {
        method: "PATCH",
        uri: "{id}"
      }
    ];
    var index = /* @__PURE__ */ Object.freeze({
      __proto__: null,
      Sort,
      Pick,
      NestedPick,
      Create,
      Link,
      LinkMulti,
      Rules,
      Delete,
      List,
      ListAll,
      Reinstate,
      Unlink,
      UnlinkMulti,
      Filters,
      Get,
      Update
    });
    function toMany(parent, type, config) {
      return new CrudToMany(parent, type, config);
    }
    class CrudToMany extends CrudNode {
      constructor(parent, type, config) {
        super(parent, type);
        this.mixins = [];
        this.__cache = {};
        this._mixinRoutes = [];
        this._config = config;
        this._applyMixin(CrudToManyMixin);
      }
      get $path() {
        return urlJoin2(this._parent.$path, this._config.path);
      }
      get $routes() {
        const routes = [];
        routes.push(...this._mixinRoutes);
        if (this.parent === this.$root) {
          const data2 = { guid: "{id}", created_at: "", updated_at: "" };
          const model = this.$factory.getOrCreate(this, this.type, data2);
          routes.push(...model.$routes);
        }
        return routes;
      }
      with(ctor) {
        this.mixins.push(ctor.mixin);
        const routes = ctor.routes.map((route) => ({
          method: route.method,
          uri: urlJoin2(this.$path, route.uri)
        }));
        this._mixinRoutes.push(...routes);
        this._applyMixin(ctor);
        return this;
      }
      _applyMixin(constructor) {
        const instance = this;
        const mixinInstance = new constructor(instance);
        Object.getOwnPropertyNames(mixinInstance).forEach((name) => {
          if (instance[name] === void 0) {
            Object.defineProperty(instance, name, Object.getOwnPropertyDescriptor(mixinInstance, name) || /* @__PURE__ */ Object.create(null));
          }
        });
        Object.getOwnPropertyNames(constructor.prototype).forEach((name) => {
          if (instance[name] === void 0) {
            Object.defineProperty(instance, name, Object.getOwnPropertyDescriptor(constructor.prototype, name) || /* @__PURE__ */ Object.create(null));
          }
        });
        return this;
      }
      _setAdditionalFields(response) {
        this.__appends = this.__appends || response.__appends;
        this.__filters = this.__filters || response.__filters;
        this.__includes = this.__includes || response.__includes;
        this.__rules = this.__rules || response.__rules;
      }
    }
    exports2.CrudModelPropType = void 0;
    (function(CrudModelPropType) {
      CrudModelPropType["String"] = "string";
      CrudModelPropType["Boolean"] = "boolean";
      CrudModelPropType["Number"] = "number";
      CrudModelPropType["Date"] = "date";
      CrudModelPropType["Array"] = "array";
    })(exports2.CrudModelPropType || (exports2.CrudModelPropType = {}));
    const CrudModelProps = {
      guid: exports2.CrudModelPropType.String
    };
    class CrudModel extends CrudNode {
      constructor(parent, type, config) {
        super(parent, type);
        if (parent !== this.$root && parent.parent !== this.$root) {
          throw Error(`Invalid parent for model of type ${type}`);
        }
        this._props = CrudModel.parsePropConfig({
          ...config.props,
          ...CrudModelProps
        });
        this.raw = { ...config.data };
        this.props = this._getPropValues(this._props, config.data);
        this._config = config;
      }
      static parsePropConfig(config) {
        const props = {};
        Object.keys(config).forEach((key) => {
          let propConfig = config[key];
          if (typeof propConfig !== "object") {
            propConfig = {
              type: propConfig
            };
          }
          props[key] = {
            type: propConfig.type,
            default: propConfig.default !== void 0 ? propConfig.default : null,
            props: propConfig.props,
            value: null,
            rules: propConfig.rules || []
          };
        });
        return props;
      }
      get guid() {
        return this.props.guid;
      }
      get isNew() {
        return !this.props.guid;
      }
      get $path() {
        if (this.parent instanceof CrudToMany && this.props.guid) {
          return urlJoin2(this.parent.$path, encodeURIComponent(this.props.guid));
        }
        return urlJoin2(this.parent.$path, this.type);
      }
      get $routes() {
        const routes = [];
        for (const node of Object.values(this)) {
          if (node instanceof CrudNode && node !== this.parent) {
            routes.push(...node.$routes);
          }
        }
        return routes;
      }
      setData(data2) {
        Object.keys(data2).forEach((strKey) => {
          const key = strKey;
          this.props[key] = data2[key];
        });
      }
      _getPropValues(props, data2) {
        const _props = {};
        for (const key of Object.keys(props)) {
          if (data2 && data2[key] !== void 0) {
            _props[key] = data2[key];
          } else {
            _props[key] = props[key].value;
          }
        }
        return _props;
      }
    }
    CrudModel.type = "<type>";
    CrudModel.props = CrudModel.parsePropConfig(CrudModelProps);
    class CrudFactory {
      constructor(config) {
        this._blueprints = {};
        this._cache = {};
        this._config = config;
        for (const blueprint of config.models) {
          this._blueprints[blueprint.type] = blueprint;
          this._cache[blueprint.type] = {};
        }
      }
      new(parent, type) {
        return new this._blueprints[type](parent);
      }
      add(type, model) {
        if (!model.props.guid) {
          throw Error("No guid set on model");
        }
        this._cache[type][model.props.guid] = model;
      }
      getOrCreate(parent, type, data2) {
        let model = this._cache[type][data2.guid];
        if (model) {
          model.setData(data2);
          return model;
        }
        model = new this._blueprints[type](parent, data2);
        this.add(type, model);
        return model;
      }
    }
    var axios$2 = { exports: {} };
    var bind$2 = function bind3(fn, thisArg) {
      return function wrap() {
        var args = new Array(arguments.length);
        for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i];
        }
        return fn.apply(thisArg, args);
      };
    };
    var bind$1 = bind$2;
    var toString3 = Object.prototype.toString;
    function isArray2(val) {
      return toString3.call(val) === "[object Array]";
    }
    function isUndefined2(val) {
      return typeof val === "undefined";
    }
    function isBuffer2(val) {
      return val !== null && !isUndefined2(val) && val.constructor !== null && !isUndefined2(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
    }
    function isArrayBuffer2(val) {
      return toString3.call(val) === "[object ArrayBuffer]";
    }
    function isFormData2(val) {
      return typeof FormData !== "undefined" && val instanceof FormData;
    }
    function isArrayBufferView2(val) {
      var result;
      if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
        result = ArrayBuffer.isView(val);
      } else {
        result = val && val.buffer && val.buffer instanceof ArrayBuffer;
      }
      return result;
    }
    function isString2(val) {
      return typeof val === "string";
    }
    function isNumber2(val) {
      return typeof val === "number";
    }
    function isObject2(val) {
      return val !== null && typeof val === "object";
    }
    function isPlainObject2(val) {
      if (toString3.call(val) !== "[object Object]") {
        return false;
      }
      var prototype2 = Object.getPrototypeOf(val);
      return prototype2 === null || prototype2 === Object.prototype;
    }
    function isDate2(val) {
      return toString3.call(val) === "[object Date]";
    }
    function isFile2(val) {
      return toString3.call(val) === "[object File]";
    }
    function isBlob2(val) {
      return toString3.call(val) === "[object Blob]";
    }
    function isFunction2(val) {
      return toString3.call(val) === "[object Function]";
    }
    function isStream2(val) {
      return isObject2(val) && isFunction2(val.pipe);
    }
    function isURLSearchParams2(val) {
      return typeof URLSearchParams !== "undefined" && val instanceof URLSearchParams;
    }
    function trim2(str) {
      return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
    }
    function isStandardBrowserEnv() {
      if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) {
        return false;
      }
      return typeof window !== "undefined" && typeof document !== "undefined";
    }
    function forEach2(obj, fn) {
      if (obj === null || typeof obj === "undefined") {
        return;
      }
      if (typeof obj !== "object") {
        obj = [obj];
      }
      if (isArray2(obj)) {
        for (var i = 0, l = obj.length; i < l; i++) {
          fn.call(null, obj[i], i, obj);
        }
      } else {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            fn.call(null, obj[key], key, obj);
          }
        }
      }
    }
    function merge2() {
      var result = {};
      function assignValue(val, key) {
        if (isPlainObject2(result[key]) && isPlainObject2(val)) {
          result[key] = merge2(result[key], val);
        } else if (isPlainObject2(val)) {
          result[key] = merge2({}, val);
        } else if (isArray2(val)) {
          result[key] = val.slice();
        } else {
          result[key] = val;
        }
      }
      for (var i = 0, l = arguments.length; i < l; i++) {
        forEach2(arguments[i], assignValue);
      }
      return result;
    }
    function extend2(a, b, thisArg) {
      forEach2(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") {
          a[key] = bind$1(val, thisArg);
        } else {
          a[key] = val;
        }
      });
      return a;
    }
    function stripBOM2(content) {
      if (content.charCodeAt(0) === 65279) {
        content = content.slice(1);
      }
      return content;
    }
    var utils$d = {
      isArray: isArray2,
      isArrayBuffer: isArrayBuffer2,
      isBuffer: isBuffer2,
      isFormData: isFormData2,
      isArrayBufferView: isArrayBufferView2,
      isString: isString2,
      isNumber: isNumber2,
      isObject: isObject2,
      isPlainObject: isPlainObject2,
      isUndefined: isUndefined2,
      isDate: isDate2,
      isFile: isFile2,
      isBlob: isBlob2,
      isFunction: isFunction2,
      isStream: isStream2,
      isURLSearchParams: isURLSearchParams2,
      isStandardBrowserEnv,
      forEach: forEach2,
      merge: merge2,
      extend: extend2,
      trim: trim2,
      stripBOM: stripBOM2
    };
    var utils$c = utils$d;
    function encode2(val) {
      return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    }
    var buildURL$2 = function buildURL3(url, params, paramsSerializer) {
      if (!params) {
        return url;
      }
      var serializedParams;
      if (paramsSerializer) {
        serializedParams = paramsSerializer(params);
      } else if (utils$c.isURLSearchParams(params)) {
        serializedParams = params.toString();
      } else {
        var parts = [];
        utils$c.forEach(params, function serialize(val, key) {
          if (val === null || typeof val === "undefined") {
            return;
          }
          if (utils$c.isArray(val)) {
            key = key + "[]";
          } else {
            val = [val];
          }
          utils$c.forEach(val, function parseValue(v) {
            if (utils$c.isDate(v)) {
              v = v.toISOString();
            } else if (utils$c.isObject(v)) {
              v = JSON.stringify(v);
            }
            parts.push(encode2(key) + "=" + encode2(v));
          });
        });
        serializedParams = parts.join("&");
      }
      if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) {
          url = url.slice(0, hashmarkIndex);
        }
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
      }
      return url;
    };
    var utils$b = utils$d;
    function InterceptorManager$1() {
      this.handlers = [];
    }
    InterceptorManager$1.prototype.use = function use(fulfilled, rejected, options) {
      this.handlers.push({
        fulfilled,
        rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
      });
      return this.handlers.length - 1;
    };
    InterceptorManager$1.prototype.eject = function eject(id) {
      if (this.handlers[id]) {
        this.handlers[id] = null;
      }
    };
    InterceptorManager$1.prototype.forEach = function forEach3(fn) {
      utils$b.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) {
          fn(h);
        }
      });
    };
    var InterceptorManager_1 = InterceptorManager$1;
    var utils$a = utils$d;
    var normalizeHeaderName$1 = function normalizeHeaderName2(headers, normalizedName) {
      utils$a.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
          headers[normalizedName] = value;
          delete headers[name];
        }
      });
    };
    var enhanceError$2 = function enhanceError2(error, config, code, request, response) {
      error.config = config;
      if (code) {
        error.code = code;
      }
      error.request = request;
      error.response = response;
      error.isAxiosError = true;
      error.toJSON = function toJSON2() {
        return {
          // Standard
          message: this.message,
          name: this.name,
          // Microsoft
          description: this.description,
          number: this.number,
          // Mozilla
          fileName: this.fileName,
          lineNumber: this.lineNumber,
          columnNumber: this.columnNumber,
          stack: this.stack,
          // Axios
          config: this.config,
          code: this.code,
          status: this.response && this.response.status ? this.response.status : null
        };
      };
      return error;
    };
    var enhanceError$1 = enhanceError$2;
    var createError$2 = function createError2(message, config, code, request, response) {
      var error = new Error(message);
      return enhanceError$1(error, config, code, request, response);
    };
    var createError$1 = createError$2;
    var settle$1 = function settle3(resolve, reject, response) {
      var validateStatus2 = response.config.validateStatus;
      if (!response.status || !validateStatus2 || validateStatus2(response.status)) {
        resolve(response);
      } else {
        reject(createError$1("Request failed with status code " + response.status, response.config, null, response.request, response));
      }
    };
    var utils$9 = utils$d;
    var cookies$1 = utils$9.isStandardBrowserEnv() ? (
      // Standard browser envs support document.cookie
      /* @__PURE__ */ function standardBrowserEnv2() {
        return {
          write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if (utils$9.isNumber(expires)) {
              cookie.push("expires=" + new Date(expires).toGMTString());
            }
            if (utils$9.isString(path)) {
              cookie.push("path=" + path);
            }
            if (utils$9.isString(domain)) {
              cookie.push("domain=" + domain);
            }
            if (secure === true) {
              cookie.push("secure");
            }
            document.cookie = cookie.join("; ");
          },
          read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
          },
          remove: function remove(name) {
            this.write(name, "", Date.now() - 864e5);
          }
        };
      }()
    ) : (
      // Non standard browser env (web workers, react-native) lack needed support.
      /* @__PURE__ */ function nonStandardBrowserEnv2() {
        return {
          write: function write() {
          },
          read: function read() {
            return null;
          },
          remove: function remove() {
          }
        };
      }()
    );
    var isAbsoluteURL$1 = function isAbsoluteURL3(url) {
      return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
    };
    var combineURLs$1 = function combineURLs3(baseURL, relativeURL) {
      return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
    };
    var isAbsoluteURL2 = isAbsoluteURL$1;
    var combineURLs2 = combineURLs$1;
    var buildFullPath$1 = function buildFullPath3(baseURL, requestedURL) {
      if (baseURL && !isAbsoluteURL2(requestedURL)) {
        return combineURLs2(baseURL, requestedURL);
      }
      return requestedURL;
    };
    var utils$8 = utils$d;
    var ignoreDuplicateOf2 = ["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"];
    var parseHeaders$1 = function parseHeaders3(headers) {
      var parsed = {};
      var key;
      var val;
      var i;
      if (!headers) {
        return parsed;
      }
      utils$8.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = utils$8.trim(line.substr(0, i)).toLowerCase();
        val = utils$8.trim(line.substr(i + 1));
        if (key) {
          if (parsed[key] && ignoreDuplicateOf2.indexOf(key) >= 0) {
            return;
          }
          if (key === "set-cookie") {
            parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
          } else {
            parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
          }
        }
      });
      return parsed;
    };
    var utils$7 = utils$d;
    var isURLSameOrigin$1 = utils$7.isStandardBrowserEnv() ? (
      // Standard browser envs have full support of the APIs needed to test
      // whether the request URL is of the same origin as current location.
      function standardBrowserEnv2() {
        var msie = /(msie|trident)/i.test(navigator.userAgent);
        var urlParsingNode = document.createElement("a");
        var originURL;
        function resolveURL(url) {
          var href = url;
          if (msie) {
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
          }
          urlParsingNode.setAttribute("href", href);
          return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
          };
        }
        originURL = resolveURL(window.location.href);
        return function isURLSameOrigin3(requestURL) {
          var parsed = utils$7.isString(requestURL) ? resolveURL(requestURL) : requestURL;
          return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
        };
      }()
    ) : (
      // Non standard browser envs (web workers, react-native) lack needed support.
      /* @__PURE__ */ function nonStandardBrowserEnv2() {
        return function isURLSameOrigin3() {
          return true;
        };
      }()
    );
    function Cancel$3(message) {
      this.message = message;
    }
    Cancel$3.prototype.toString = function toString4() {
      return "Cancel" + (this.message ? ": " + this.message : "");
    };
    Cancel$3.prototype.__CANCEL__ = true;
    var Cancel_1 = Cancel$3;
    var utils$6 = utils$d;
    var settle2 = settle$1;
    var cookies2 = cookies$1;
    var buildURL$1 = buildURL$2;
    var buildFullPath2 = buildFullPath$1;
    var parseHeaders2 = parseHeaders$1;
    var isURLSameOrigin2 = isURLSameOrigin$1;
    var createError = createError$2;
    var defaults$4 = defaults_1;
    var Cancel$2 = Cancel_1;
    var xhr = function xhrAdapter2(config) {
      return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        var onCanceled;
        function done() {
          if (config.cancelToken) {
            config.cancelToken.unsubscribe(onCanceled);
          }
          if (config.signal) {
            config.signal.removeEventListener("abort", onCanceled);
          }
        }
        if (utils$6.isFormData(requestData)) {
          delete requestHeaders["Content-Type"];
        }
        var request = new XMLHttpRequest();
        if (config.auth) {
          var username = config.auth.username || "";
          var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
          requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = buildFullPath2(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), buildURL$1(fullPath, config.params, config.paramsSerializer), true);
        request.timeout = config.timeout;
        function onloadend() {
          if (!request) {
            return;
          }
          var responseHeaders = "getAllResponseHeaders" in request ? parseHeaders2(request.getAllResponseHeaders()) : null;
          var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
          var response = {
            data: responseData,
            status: request.status,
            statusText: request.statusText,
            headers: responseHeaders,
            config,
            request
          };
          settle2(function _resolve(value) {
            resolve(value);
            done();
          }, function _reject(err) {
            reject(err);
            done();
          }, response);
          request = null;
        }
        if ("onloadend" in request) {
          request.onloadend = onloadend;
        } else {
          request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) {
              return;
            }
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) {
              return;
            }
            setTimeout(onloadend);
          };
        }
        request.onabort = function handleAbort() {
          if (!request) {
            return;
          }
          reject(createError("Request aborted", config, "ECONNABORTED", request));
          request = null;
        };
        request.onerror = function handleError() {
          reject(createError("Network Error", config, null, request));
          request = null;
        };
        request.ontimeout = function handleTimeout() {
          var timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
          var transitional2 = config.transitional || defaults$4.transitional;
          if (config.timeoutErrorMessage) {
            timeoutErrorMessage = config.timeoutErrorMessage;
          }
          reject(createError(timeoutErrorMessage, config, transitional2.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED", request));
          request = null;
        };
        if (utils$6.isStandardBrowserEnv()) {
          var xsrfValue = (config.withCredentials || isURLSameOrigin2(fullPath)) && config.xsrfCookieName ? cookies2.read(config.xsrfCookieName) : void 0;
          if (xsrfValue) {
            requestHeaders[config.xsrfHeaderName] = xsrfValue;
          }
        }
        if ("setRequestHeader" in request) {
          utils$6.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") {
              delete requestHeaders[key];
            } else {
              request.setRequestHeader(key, val);
            }
          });
        }
        if (!utils$6.isUndefined(config.withCredentials)) {
          request.withCredentials = !!config.withCredentials;
        }
        if (responseType && responseType !== "json") {
          request.responseType = config.responseType;
        }
        if (typeof config.onDownloadProgress === "function") {
          request.addEventListener("progress", config.onDownloadProgress);
        }
        if (typeof config.onUploadProgress === "function" && request.upload) {
          request.upload.addEventListener("progress", config.onUploadProgress);
        }
        if (config.cancelToken || config.signal) {
          onCanceled = function(cancel) {
            if (!request) {
              return;
            }
            reject(!cancel || cancel && cancel.type ? new Cancel$2("canceled") : cancel);
            request.abort();
            request = null;
          };
          config.cancelToken && config.cancelToken.subscribe(onCanceled);
          if (config.signal) {
            config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
          }
        }
        if (!requestData) {
          requestData = null;
        }
        request.send(requestData);
      });
    };
    var utils$5 = utils$d;
    var normalizeHeaderName = normalizeHeaderName$1;
    var enhanceError = enhanceError$2;
    var DEFAULT_CONTENT_TYPE = {
      "Content-Type": "application/x-www-form-urlencoded"
    };
    function setContentTypeIfUnset(headers, value) {
      if (!utils$5.isUndefined(headers) && utils$5.isUndefined(headers["Content-Type"])) {
        headers["Content-Type"] = value;
      }
    }
    function getDefaultAdapter() {
      var adapter;
      if (typeof XMLHttpRequest !== "undefined") {
        adapter = xhr;
      } else if (typeof process !== "undefined" && Object.prototype.toString.call(process) === "[object process]") {
        adapter = xhr;
      }
      return adapter;
    }
    function stringifySafely2(rawValue, parser, encoder) {
      if (utils$5.isString(rawValue)) {
        try {
          (parser || JSON.parse)(rawValue);
          return utils$5.trim(rawValue);
        } catch (e) {
          if (e.name !== "SyntaxError") {
            throw e;
          }
        }
      }
      return (encoder || JSON.stringify)(rawValue);
    }
    var defaults$3 = {
      transitional: {
        silentJSONParsing: true,
        forcedJSONParsing: true,
        clarifyTimeoutError: false
      },
      adapter: getDefaultAdapter(),
      transformRequest: [function transformRequest2(data2, headers) {
        normalizeHeaderName(headers, "Accept");
        normalizeHeaderName(headers, "Content-Type");
        if (utils$5.isFormData(data2) || utils$5.isArrayBuffer(data2) || utils$5.isBuffer(data2) || utils$5.isStream(data2) || utils$5.isFile(data2) || utils$5.isBlob(data2)) {
          return data2;
        }
        if (utils$5.isArrayBufferView(data2)) {
          return data2.buffer;
        }
        if (utils$5.isURLSearchParams(data2)) {
          setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
          return data2.toString();
        }
        if (utils$5.isObject(data2) || headers && headers["Content-Type"] === "application/json") {
          setContentTypeIfUnset(headers, "application/json");
          return stringifySafely2(data2);
        }
        return data2;
      }],
      transformResponse: [function transformResponse2(data2) {
        var transitional2 = this.transitional || defaults$3.transitional;
        var silentJSONParsing = transitional2 && transitional2.silentJSONParsing;
        var forcedJSONParsing = transitional2 && transitional2.forcedJSONParsing;
        var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
        if (strictJSONParsing || forcedJSONParsing && utils$5.isString(data2) && data2.length) {
          try {
            return JSON.parse(data2);
          } catch (e) {
            if (strictJSONParsing) {
              if (e.name === "SyntaxError") {
                throw enhanceError(e, this, "E_JSON_PARSE");
              }
              throw e;
            }
          }
        }
        return data2;
      }],
      /**
       * A timeout in milliseconds to abort a request. If set to 0 (default) a
       * timeout is not created.
       */
      timeout: 0,
      xsrfCookieName: "XSRF-TOKEN",
      xsrfHeaderName: "X-XSRF-TOKEN",
      maxContentLength: -1,
      maxBodyLength: -1,
      validateStatus: function validateStatus2(status) {
        return status >= 200 && status < 300;
      },
      headers: {
        common: {
          "Accept": "application/json, text/plain, */*"
        }
      }
    };
    utils$5.forEach(["delete", "get", "head"], function forEachMethodNoData2(method) {
      defaults$3.headers[method] = {};
    });
    utils$5.forEach(["post", "put", "patch"], function forEachMethodWithData2(method) {
      defaults$3.headers[method] = utils$5.merge(DEFAULT_CONTENT_TYPE);
    });
    var defaults_1 = defaults$3;
    var utils$4 = utils$d;
    var defaults$2 = defaults_1;
    var transformData$1 = function transformData3(data2, headers, fns) {
      var context = this || defaults$2;
      utils$4.forEach(fns, function transform(fn) {
        data2 = fn.call(context, data2, headers);
      });
      return data2;
    };
    var isCancel$1 = function isCancel3(value) {
      return !!(value && value.__CANCEL__);
    };
    var utils$3 = utils$d;
    var transformData2 = transformData$1;
    var isCancel2 = isCancel$1;
    var defaults$12 = defaults_1;
    var Cancel$1 = Cancel_1;
    function throwIfCancellationRequested2(config) {
      if (config.cancelToken) {
        config.cancelToken.throwIfRequested();
      }
      if (config.signal && config.signal.aborted) {
        throw new Cancel$1("canceled");
      }
    }
    var dispatchRequest$1 = function dispatchRequest3(config) {
      throwIfCancellationRequested2(config);
      config.headers = config.headers || {};
      config.data = transformData2.call(config, config.data, config.headers, config.transformRequest);
      config.headers = utils$3.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
      utils$3.forEach(["delete", "get", "head", "post", "put", "patch", "common"], function cleanHeaderConfig(method) {
        delete config.headers[method];
      });
      var adapter = config.adapter || defaults$12.adapter;
      return adapter(config).then(function onAdapterResolution(response) {
        throwIfCancellationRequested2(config);
        response.data = transformData2.call(config, response.data, response.headers, config.transformResponse);
        return response;
      }, function onAdapterRejection(reason) {
        if (!isCancel2(reason)) {
          throwIfCancellationRequested2(config);
          if (reason && reason.response) {
            reason.response.data = transformData2.call(config, reason.response.data, reason.response.headers, config.transformResponse);
          }
        }
        return Promise.reject(reason);
      });
    };
    var utils$2 = utils$d;
    var mergeConfig$2 = function mergeConfig3(config1, config2) {
      config2 = config2 || {};
      var config = {};
      function getMergedValue(target, source) {
        if (utils$2.isPlainObject(target) && utils$2.isPlainObject(source)) {
          return utils$2.merge(target, source);
        } else if (utils$2.isPlainObject(source)) {
          return utils$2.merge({}, source);
        } else if (utils$2.isArray(source)) {
          return source.slice();
        }
        return source;
      }
      function mergeDeepProperties(prop) {
        if (!utils$2.isUndefined(config2[prop])) {
          return getMergedValue(config1[prop], config2[prop]);
        } else if (!utils$2.isUndefined(config1[prop])) {
          return getMergedValue(void 0, config1[prop]);
        }
      }
      function valueFromConfig2(prop) {
        if (!utils$2.isUndefined(config2[prop])) {
          return getMergedValue(void 0, config2[prop]);
        }
      }
      function defaultToConfig2(prop) {
        if (!utils$2.isUndefined(config2[prop])) {
          return getMergedValue(void 0, config2[prop]);
        } else if (!utils$2.isUndefined(config1[prop])) {
          return getMergedValue(void 0, config1[prop]);
        }
      }
      function mergeDirectKeys(prop) {
        if (prop in config2) {
          return getMergedValue(config1[prop], config2[prop]);
        } else if (prop in config1) {
          return getMergedValue(void 0, config1[prop]);
        }
      }
      var mergeMap = {
        "url": valueFromConfig2,
        "method": valueFromConfig2,
        "data": valueFromConfig2,
        "baseURL": defaultToConfig2,
        "transformRequest": defaultToConfig2,
        "transformResponse": defaultToConfig2,
        "paramsSerializer": defaultToConfig2,
        "timeout": defaultToConfig2,
        "timeoutMessage": defaultToConfig2,
        "withCredentials": defaultToConfig2,
        "adapter": defaultToConfig2,
        "responseType": defaultToConfig2,
        "xsrfCookieName": defaultToConfig2,
        "xsrfHeaderName": defaultToConfig2,
        "onUploadProgress": defaultToConfig2,
        "onDownloadProgress": defaultToConfig2,
        "decompress": defaultToConfig2,
        "maxContentLength": defaultToConfig2,
        "maxBodyLength": defaultToConfig2,
        "transport": defaultToConfig2,
        "httpAgent": defaultToConfig2,
        "httpsAgent": defaultToConfig2,
        "cancelToken": defaultToConfig2,
        "socketPath": defaultToConfig2,
        "responseEncoding": defaultToConfig2,
        "validateStatus": mergeDirectKeys
      };
      utils$2.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
        var merge3 = mergeMap[prop] || mergeDeepProperties;
        var configValue = merge3(prop);
        utils$2.isUndefined(configValue) && merge3 !== mergeDirectKeys || (config[prop] = configValue);
      });
      return config;
    };
    var data = {
      "version": "0.24.0"
    };
    var VERSION2 = data.version;
    var validators$12 = {};
    ["object", "boolean", "number", "function", "string", "symbol"].forEach(function(type, i) {
      validators$12[type] = function validator3(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
      };
    });
    var deprecatedWarnings2 = {};
    validators$12.transitional = function transitional2(validator3, version, message) {
      function formatMessage(opt, desc) {
        return "[Axios v" + VERSION2 + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
      }
      return function(value, opt, opts) {
        if (validator3 === false) {
          throw new Error(formatMessage(opt, " has been removed" + (version ? " in " + version : "")));
        }
        if (version && !deprecatedWarnings2[opt]) {
          deprecatedWarnings2[opt] = true;
          console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator3 ? validator3(value, opt, opts) : true;
      };
    };
    function assertOptions2(options, schema, allowUnknown) {
      if (typeof options !== "object") {
        throw new TypeError("options must be an object");
      }
      var keys = Object.keys(options);
      var i = keys.length;
      while (i-- > 0) {
        var opt = keys[i];
        var validator3 = schema[opt];
        if (validator3) {
          var value = options[opt];
          var result = value === void 0 || validator3(value, opt, options);
          if (result !== true) {
            throw new TypeError("option " + opt + " must be " + result);
          }
          continue;
        }
        if (allowUnknown !== true) {
          throw Error("Unknown option " + opt);
        }
      }
    }
    var validator$1 = {
      assertOptions: assertOptions2,
      validators: validators$12
    };
    var utils$12 = utils$d;
    var buildURL2 = buildURL$2;
    var InterceptorManager2 = InterceptorManager_1;
    var dispatchRequest2 = dispatchRequest$1;
    var mergeConfig$1 = mergeConfig$2;
    var validator2 = validator$1;
    var validators2 = validator2.validators;
    function Axios$12(instanceConfig) {
      this.defaults = instanceConfig;
      this.interceptors = {
        request: new InterceptorManager2(),
        response: new InterceptorManager2()
      };
    }
    Axios$12.prototype.request = function request(config) {
      if (typeof config === "string") {
        config = arguments[1] || {};
        config.url = arguments[0];
      } else {
        config = config || {};
      }
      config = mergeConfig$1(this.defaults, config);
      if (config.method) {
        config.method = config.method.toLowerCase();
      } else if (this.defaults.method) {
        config.method = this.defaults.method.toLowerCase();
      } else {
        config.method = "get";
      }
      var transitional2 = config.transitional;
      if (transitional2 !== void 0) {
        validator2.assertOptions(transitional2, {
          silentJSONParsing: validators2.transitional(validators2.boolean),
          forcedJSONParsing: validators2.transitional(validators2.boolean),
          clarifyTimeoutError: validators2.transitional(validators2.boolean)
        }, false);
      }
      var requestInterceptorChain = [];
      var synchronousRequestInterceptors = true;
      this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) {
          return;
        }
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
      });
      var responseInterceptorChain = [];
      this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
      });
      var promise;
      if (!synchronousRequestInterceptors) {
        var chain = [dispatchRequest2, void 0];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while (chain.length) {
          promise = promise.then(chain.shift(), chain.shift());
        }
        return promise;
      }
      var newConfig = config;
      while (requestInterceptorChain.length) {
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
          newConfig = onFulfilled(newConfig);
        } catch (error) {
          onRejected(error);
          break;
        }
      }
      try {
        promise = dispatchRequest2(newConfig);
      } catch (error) {
        return Promise.reject(error);
      }
      while (responseInterceptorChain.length) {
        promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
      }
      return promise;
    };
    Axios$12.prototype.getUri = function getUri(config) {
      config = mergeConfig$1(this.defaults, config);
      return buildURL2(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
    };
    utils$12.forEach(["delete", "get", "head", "options"], function forEachMethodNoData2(method) {
      Axios$12.prototype[method] = function(url, config) {
        return this.request(mergeConfig$1(config || {}, {
          method,
          url,
          data: (config || {}).data
        }));
      };
    });
    utils$12.forEach(["post", "put", "patch"], function forEachMethodWithData2(method) {
      Axios$12.prototype[method] = function(url, data2, config) {
        return this.request(mergeConfig$1(config || {}, {
          method,
          url,
          data: data2
        }));
      };
    });
    var Axios_1 = Axios$12;
    var Cancel = Cancel_1;
    function CancelToken2(executor) {
      if (typeof executor !== "function") {
        throw new TypeError("executor must be a function.");
      }
      var resolvePromise;
      this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
      });
      var token = this;
      this.promise.then(function(cancel) {
        if (!token._listeners)
          return;
        var i;
        var l = token._listeners.length;
        for (i = 0; i < l; i++) {
          token._listeners[i](cancel);
        }
        token._listeners = null;
      });
      this.promise.then = function(onfulfilled) {
        var _resolve;
        var promise = new Promise(function(resolve) {
          token.subscribe(resolve);
          _resolve = resolve;
        }).then(onfulfilled);
        promise.cancel = function reject() {
          token.unsubscribe(_resolve);
        };
        return promise;
      };
      executor(function cancel(message) {
        if (token.reason) {
          return;
        }
        token.reason = new Cancel(message);
        resolvePromise(token.reason);
      });
    }
    CancelToken2.prototype.throwIfRequested = function throwIfRequested() {
      if (this.reason) {
        throw this.reason;
      }
    };
    CancelToken2.prototype.subscribe = function subscribe(listener) {
      if (this.reason) {
        listener(this.reason);
        return;
      }
      if (this._listeners) {
        this._listeners.push(listener);
      } else {
        this._listeners = [listener];
      }
    };
    CancelToken2.prototype.unsubscribe = function unsubscribe(listener) {
      if (!this._listeners) {
        return;
      }
      var index2 = this._listeners.indexOf(listener);
      if (index2 !== -1) {
        this._listeners.splice(index2, 1);
      }
    };
    CancelToken2.source = function source() {
      var cancel;
      var token = new CancelToken2(function executor(c) {
        cancel = c;
      });
      return {
        token,
        cancel
      };
    };
    var CancelToken_1 = CancelToken2;
    var spread2 = function spread3(callback) {
      return function wrap(arr) {
        return callback.apply(null, arr);
      };
    };
    var isAxiosError2 = function isAxiosError3(payload) {
      return typeof payload === "object" && payload.isAxiosError === true;
    };
    var utils2 = utils$d;
    var bind2 = bind$2;
    var Axios2 = Axios_1;
    var mergeConfig2 = mergeConfig$2;
    var defaults2 = defaults_1;
    function createInstance2(defaultConfig) {
      var context = new Axios2(defaultConfig);
      var instance = bind2(Axios2.prototype.request, context);
      utils2.extend(instance, Axios2.prototype, context);
      utils2.extend(instance, context);
      instance.create = function create(instanceConfig) {
        return createInstance2(mergeConfig2(defaultConfig, instanceConfig));
      };
      return instance;
    }
    var axios$1 = createInstance2(defaults2);
    axios$1.Axios = Axios2;
    axios$1.Cancel = Cancel_1;
    axios$1.CancelToken = CancelToken_1;
    axios$1.isCancel = isCancel$1;
    axios$1.VERSION = data.version;
    axios$1.all = function all2(promises) {
      return Promise.all(promises);
    };
    axios$1.spread = spread2;
    axios$1.isAxiosError = isAxiosError2;
    axios$2.exports = axios$1;
    axios$2.exports.default = axios$1;
    var axios2 = axios$2.exports;
    exports2.Level = void 0;
    (function(Level) {
      Level["None"] = "none";
      Level["Fatal"] = "fatal";
      Level["Error"] = "error";
      Level["Warning"] = "warning";
      Level["Info"] = "info";
      Level["Debug"] = "debug";
    })(exports2.Level || (exports2.Level = {}));
    exports2.LevelNumber = void 0;
    (function(LevelNumber) {
      LevelNumber[LevelNumber["None"] = 1] = "None";
      LevelNumber[LevelNumber["Fatal"] = 2] = "Fatal";
      LevelNumber[LevelNumber["Error"] = 3] = "Error";
      LevelNumber[LevelNumber["Warning"] = 4] = "Warning";
      LevelNumber[LevelNumber["Info"] = 5] = "Info";
      LevelNumber[LevelNumber["Debug"] = 6] = "Debug";
    })(exports2.LevelNumber || (exports2.LevelNumber = {}));
    const levelNumberToLevel = {
      [exports2.LevelNumber.None]: exports2.Level.None,
      [exports2.LevelNumber.Fatal]: exports2.Level.Fatal,
      [exports2.LevelNumber.Error]: exports2.Level.Error,
      [exports2.LevelNumber.Warning]: exports2.Level.Warning,
      [exports2.LevelNumber.Info]: exports2.Level.Info,
      [exports2.LevelNumber.Debug]: exports2.Level.Debug
    };
    const levelToLevelNumber = {
      [exports2.Level.None]: exports2.LevelNumber.None,
      [exports2.Level.Fatal]: exports2.LevelNumber.Fatal,
      [exports2.Level.Error]: exports2.LevelNumber.Error,
      [exports2.Level.Warning]: exports2.LevelNumber.Warning,
      [exports2.Level.Info]: exports2.LevelNumber.Info,
      [exports2.Level.Debug]: exports2.LevelNumber.Debug
    };
    class BaseOutput {
      constructor(sessionId, origin, settings) {
        this._level = exports2.LevelNumber.None;
        if (!sessionId || !sessionId.length) {
          throw new Error("Invalid first argument sessionsId. Expected a non zero length string.");
        }
        if (!origin || !origin) {
          throw new Error("Invalid second argument origin. Expected a non zero length string.");
        }
        this._sessionId = sessionId;
        this._origin = origin;
        if (settings && settings.level) {
          this.setLevel(settings.level);
        } else {
          this.setLevel(exports2.Level.Info);
        }
      }
      setLevel(level) {
        if (!levelToLevelNumber[level]) {
          console.warn("hello");
          throw new Error("Invalid level, cannot transform to level number");
        }
        this._level = levelToLevelNumber[level];
      }
    }
    class ConsoleOutput extends BaseOutput {
      constructor() {
        super(...arguments);
        this._level = exports2.LevelNumber.Debug;
      }
      send(err) {
        const consoleMethod = this._getConsoleMethod(exports2.LevelNumber.Debug);
        consoleMethod(this._marshalMessage(err), err.toFlatData());
      }
      /**
       *  Retrieve the correct console processor.
       *
       *  Depends on the console logging level.
       */
      _getConsoleMethod(errorLevel) {
        if (errorLevel > this._level) {
          return () => {
          };
        }
        switch (errorLevel) {
          case exports2.LevelNumber.Debug:
            return window.console.debug;
          case exports2.LevelNumber.Info:
            return window.console.info;
          case exports2.LevelNumber.Warning:
            return window.console.warn;
          case exports2.LevelNumber.Error:
          case exports2.LevelNumber.Fatal:
          default:
            return window.console.error;
        }
      }
      _marshalMessage(error) {
        const parts = [
          [
            this._sessionId,
            this._origin,
            error.at.toLocaleTimeString()
          ].join(" | "),
          error.toSlug().key,
          error.toString()
        ];
        return parts.join("\n");
      }
    }
    const SIZEOF_SHORT = 2;
    const SIZEOF_INT = 4;
    const FILE_IDENTIFIER_LENGTH = 4;
    const SIZE_PREFIX_LENGTH = 4;
    const int32 = new Int32Array(2);
    const float32 = new Float32Array(int32.buffer);
    const float64 = new Float64Array(int32.buffer);
    const isLittleEndian = new Uint16Array(new Uint8Array([1, 0]).buffer)[0] === 1;
    class Long {
      constructor(low, high) {
        this.low = low | 0;
        this.high = high | 0;
      }
      static create(low, high) {
        return low == 0 && high == 0 ? Long.ZERO : new Long(low, high);
      }
      toFloat64() {
        return (this.low >>> 0) + this.high * 4294967296;
      }
      equals(other) {
        return this.low == other.low && this.high == other.high;
      }
    }
    Long.ZERO = new Long(0, 0);
    var Encoding;
    (function(Encoding2) {
      Encoding2[Encoding2["UTF8_BYTES"] = 1] = "UTF8_BYTES";
      Encoding2[Encoding2["UTF16_STRING"] = 2] = "UTF16_STRING";
    })(Encoding || (Encoding = {}));
    class ByteBuffer {
      /**
       * Create a new ByteBuffer with a given array of bytes (`Uint8Array`)
       */
      constructor(bytes_) {
        this.bytes_ = bytes_;
        this.position_ = 0;
      }
      /**
       * Create and allocate a new ByteBuffer with a given size.
       */
      static allocate(byte_size) {
        return new ByteBuffer(new Uint8Array(byte_size));
      }
      clear() {
        this.position_ = 0;
      }
      /**
       * Get the underlying `Uint8Array`.
       */
      bytes() {
        return this.bytes_;
      }
      /**
       * Get the buffer's position.
       */
      position() {
        return this.position_;
      }
      /**
       * Set the buffer's position.
       */
      setPosition(position) {
        this.position_ = position;
      }
      /**
       * Get the buffer's capacity.
       */
      capacity() {
        return this.bytes_.length;
      }
      readInt8(offset) {
        return this.readUint8(offset) << 24 >> 24;
      }
      readUint8(offset) {
        return this.bytes_[offset];
      }
      readInt16(offset) {
        return this.readUint16(offset) << 16 >> 16;
      }
      readUint16(offset) {
        return this.bytes_[offset] | this.bytes_[offset + 1] << 8;
      }
      readInt32(offset) {
        return this.bytes_[offset] | this.bytes_[offset + 1] << 8 | this.bytes_[offset + 2] << 16 | this.bytes_[offset + 3] << 24;
      }
      readUint32(offset) {
        return this.readInt32(offset) >>> 0;
      }
      readInt64(offset) {
        return new Long(this.readInt32(offset), this.readInt32(offset + 4));
      }
      readUint64(offset) {
        return new Long(this.readUint32(offset), this.readUint32(offset + 4));
      }
      readFloat32(offset) {
        int32[0] = this.readInt32(offset);
        return float32[0];
      }
      readFloat64(offset) {
        int32[isLittleEndian ? 0 : 1] = this.readInt32(offset);
        int32[isLittleEndian ? 1 : 0] = this.readInt32(offset + 4);
        return float64[0];
      }
      writeInt8(offset, value) {
        this.bytes_[offset] = value;
      }
      writeUint8(offset, value) {
        this.bytes_[offset] = value;
      }
      writeInt16(offset, value) {
        this.bytes_[offset] = value;
        this.bytes_[offset + 1] = value >> 8;
      }
      writeUint16(offset, value) {
        this.bytes_[offset] = value;
        this.bytes_[offset + 1] = value >> 8;
      }
      writeInt32(offset, value) {
        this.bytes_[offset] = value;
        this.bytes_[offset + 1] = value >> 8;
        this.bytes_[offset + 2] = value >> 16;
        this.bytes_[offset + 3] = value >> 24;
      }
      writeUint32(offset, value) {
        this.bytes_[offset] = value;
        this.bytes_[offset + 1] = value >> 8;
        this.bytes_[offset + 2] = value >> 16;
        this.bytes_[offset + 3] = value >> 24;
      }
      writeInt64(offset, value) {
        this.writeInt32(offset, value.low);
        this.writeInt32(offset + 4, value.high);
      }
      writeUint64(offset, value) {
        this.writeUint32(offset, value.low);
        this.writeUint32(offset + 4, value.high);
      }
      writeFloat32(offset, value) {
        float32[0] = value;
        this.writeInt32(offset, int32[0]);
      }
      writeFloat64(offset, value) {
        float64[0] = value;
        this.writeInt32(offset, int32[isLittleEndian ? 0 : 1]);
        this.writeInt32(offset + 4, int32[isLittleEndian ? 1 : 0]);
      }
      /**
       * Return the file identifier.   Behavior is undefined for FlatBuffers whose
       * schema does not include a file_identifier (likely points at padding or the
       * start of a the root vtable).
       */
      getBufferIdentifier() {
        if (this.bytes_.length < this.position_ + SIZEOF_INT + FILE_IDENTIFIER_LENGTH) {
          throw new Error("FlatBuffers: ByteBuffer is too short to contain an identifier.");
        }
        let result = "";
        for (let i = 0; i < FILE_IDENTIFIER_LENGTH; i++) {
          result += String.fromCharCode(this.readInt8(this.position_ + SIZEOF_INT + i));
        }
        return result;
      }
      /**
       * Look up a field in the vtable, return an offset into the object, or 0 if the
       * field is not present.
       */
      __offset(bb_pos, vtable_offset) {
        const vtable = bb_pos - this.readInt32(bb_pos);
        return vtable_offset < this.readInt16(vtable) ? this.readInt16(vtable + vtable_offset) : 0;
      }
      /**
       * Initialize any Table-derived type to point to the union at the given offset.
       */
      __union(t, offset) {
        t.bb_pos = offset + this.readInt32(offset);
        t.bb = this;
        return t;
      }
      /**
       * Create a JavaScript string from UTF-8 data stored inside the FlatBuffer.
       * This allocates a new string and converts to wide chars upon each access.
       *
       * To avoid the conversion to UTF-16, pass Encoding.UTF8_BYTES as
       * the "optionalEncoding" argument. This is useful for avoiding conversion to
       * and from UTF-16 when the data will just be packaged back up in another
       * FlatBuffer later on.
       *
       * @param offset
       * @param opt_encoding Defaults to UTF16_STRING
       */
      __string(offset, opt_encoding) {
        offset += this.readInt32(offset);
        const length = this.readInt32(offset);
        let result = "";
        let i = 0;
        offset += SIZEOF_INT;
        if (opt_encoding === Encoding.UTF8_BYTES) {
          return this.bytes_.subarray(offset, offset + length);
        }
        while (i < length) {
          let codePoint;
          const a = this.readUint8(offset + i++);
          if (a < 192) {
            codePoint = a;
          } else {
            const b = this.readUint8(offset + i++);
            if (a < 224) {
              codePoint = (a & 31) << 6 | b & 63;
            } else {
              const c = this.readUint8(offset + i++);
              if (a < 240) {
                codePoint = (a & 15) << 12 | (b & 63) << 6 | c & 63;
              } else {
                const d = this.readUint8(offset + i++);
                codePoint = (a & 7) << 18 | (b & 63) << 12 | (c & 63) << 6 | d & 63;
              }
            }
          }
          if (codePoint < 65536) {
            result += String.fromCharCode(codePoint);
          } else {
            codePoint -= 65536;
            result += String.fromCharCode((codePoint >> 10) + 55296, (codePoint & (1 << 10) - 1) + 56320);
          }
        }
        return result;
      }
      /**
       * Handle unions that can contain string as its member, if a Table-derived type then initialize it,
       * if a string then return a new one
       *
       * WARNING: strings are immutable in JS so we can't change the string that the user gave us, this
       * makes the behaviour of __union_with_string different compared to __union
       */
      __union_with_string(o, offset) {
        if (typeof o === "string") {
          return this.__string(offset);
        }
        return this.__union(o, offset);
      }
      /**
       * Retrieve the relative offset stored at "offset"
       */
      __indirect(offset) {
        return offset + this.readInt32(offset);
      }
      /**
       * Get the start of data of a vector whose offset is stored at "offset" in this object.
       */
      __vector(offset) {
        return offset + this.readInt32(offset) + SIZEOF_INT;
      }
      /**
       * Get the length of a vector whose offset is stored at "offset" in this object.
       */
      __vector_len(offset) {
        return this.readInt32(offset + this.readInt32(offset));
      }
      __has_identifier(ident) {
        if (ident.length != FILE_IDENTIFIER_LENGTH) {
          throw new Error("FlatBuffers: file identifier must be length " + FILE_IDENTIFIER_LENGTH);
        }
        for (let i = 0; i < FILE_IDENTIFIER_LENGTH; i++) {
          if (ident.charCodeAt(i) != this.readInt8(this.position() + SIZEOF_INT + i)) {
            return false;
          }
        }
        return true;
      }
      /**
       * A helper function to avoid generated code depending on this file directly.
       */
      createLong(low, high) {
        return Long.create(low, high);
      }
      /**
       * A helper function for generating list for obj api
       */
      createScalarList(listAccessor, listLength) {
        const ret = [];
        for (let i = 0; i < listLength; ++i) {
          if (listAccessor(i) !== null) {
            ret.push(listAccessor(i));
          }
        }
        return ret;
      }
      /**
       * A helper function for generating list for obj api
       * @param listAccessor function that accepts an index and return data at that index
       * @param listLength listLength
       * @param res result list
       */
      createObjList(listAccessor, listLength) {
        const ret = [];
        for (let i = 0; i < listLength; ++i) {
          const val = listAccessor(i);
          if (val !== null) {
            ret.push(val.unpack());
          }
        }
        return ret;
      }
    }
    class Builder {
      /**
       * Create a FlatBufferBuilder.
       */
      constructor(opt_initial_size) {
        this.minalign = 1;
        this.vtable = null;
        this.vtable_in_use = 0;
        this.isNested = false;
        this.object_start = 0;
        this.vtables = [];
        this.vector_num_elems = 0;
        this.force_defaults = false;
        this.string_maps = null;
        let initial_size;
        if (!opt_initial_size) {
          initial_size = 1024;
        } else {
          initial_size = opt_initial_size;
        }
        this.bb = ByteBuffer.allocate(initial_size);
        this.space = initial_size;
      }
      clear() {
        this.bb.clear();
        this.space = this.bb.capacity();
        this.minalign = 1;
        this.vtable = null;
        this.vtable_in_use = 0;
        this.isNested = false;
        this.object_start = 0;
        this.vtables = [];
        this.vector_num_elems = 0;
        this.force_defaults = false;
        this.string_maps = null;
      }
      /**
       * In order to save space, fields that are set to their default value
       * don't get serialized into the buffer. Forcing defaults provides a
       * way to manually disable this optimization.
       *
       * @param forceDefaults true always serializes default values
       */
      forceDefaults(forceDefaults) {
        this.force_defaults = forceDefaults;
      }
      /**
       * Get the ByteBuffer representing the FlatBuffer. Only call this after you've
       * called finish(). The actual data starts at the ByteBuffer's current position,
       * not necessarily at 0.
       */
      dataBuffer() {
        return this.bb;
      }
      /**
       * Get the bytes representing the FlatBuffer. Only call this after you've
       * called finish().
       */
      asUint8Array() {
        return this.bb.bytes().subarray(this.bb.position(), this.bb.position() + this.offset());
      }
      /**
       * Prepare to write an element of `size` after `additional_bytes` have been
       * written, e.g. if you write a string, you need to align such the int length
       * field is aligned to 4 bytes, and the string data follows it directly. If all
       * you need to do is alignment, `additional_bytes` will be 0.
       *
       * @param size This is the of the new element to write
       * @param additional_bytes The padding size
       */
      prep(size, additional_bytes) {
        if (size > this.minalign) {
          this.minalign = size;
        }
        const align_size = ~(this.bb.capacity() - this.space + additional_bytes) + 1 & size - 1;
        while (this.space < align_size + size + additional_bytes) {
          const old_buf_size = this.bb.capacity();
          this.bb = Builder.growByteBuffer(this.bb);
          this.space += this.bb.capacity() - old_buf_size;
        }
        this.pad(align_size);
      }
      pad(byte_size) {
        for (let i = 0; i < byte_size; i++) {
          this.bb.writeInt8(--this.space, 0);
        }
      }
      writeInt8(value) {
        this.bb.writeInt8(this.space -= 1, value);
      }
      writeInt16(value) {
        this.bb.writeInt16(this.space -= 2, value);
      }
      writeInt32(value) {
        this.bb.writeInt32(this.space -= 4, value);
      }
      writeInt64(value) {
        this.bb.writeInt64(this.space -= 8, value);
      }
      writeFloat32(value) {
        this.bb.writeFloat32(this.space -= 4, value);
      }
      writeFloat64(value) {
        this.bb.writeFloat64(this.space -= 8, value);
      }
      /**
       * Add an `int8` to the buffer, properly aligned, and grows the buffer (if necessary).
       * @param value The `int8` to add the the buffer.
       */
      addInt8(value) {
        this.prep(1, 0);
        this.writeInt8(value);
      }
      /**
       * Add an `int16` to the buffer, properly aligned, and grows the buffer (if necessary).
       * @param value The `int16` to add the the buffer.
       */
      addInt16(value) {
        this.prep(2, 0);
        this.writeInt16(value);
      }
      /**
       * Add an `int32` to the buffer, properly aligned, and grows the buffer (if necessary).
       * @param value The `int32` to add the the buffer.
       */
      addInt32(value) {
        this.prep(4, 0);
        this.writeInt32(value);
      }
      /**
       * Add an `int64` to the buffer, properly aligned, and grows the buffer (if necessary).
       * @param value The `int64` to add the the buffer.
       */
      addInt64(value) {
        this.prep(8, 0);
        this.writeInt64(value);
      }
      /**
       * Add a `float32` to the buffer, properly aligned, and grows the buffer (if necessary).
       * @param value The `float32` to add the the buffer.
       */
      addFloat32(value) {
        this.prep(4, 0);
        this.writeFloat32(value);
      }
      /**
       * Add a `float64` to the buffer, properly aligned, and grows the buffer (if necessary).
       * @param value The `float64` to add the the buffer.
       */
      addFloat64(value) {
        this.prep(8, 0);
        this.writeFloat64(value);
      }
      addFieldInt8(voffset, value, defaultValue) {
        if (this.force_defaults || value != defaultValue) {
          this.addInt8(value);
          this.slot(voffset);
        }
      }
      addFieldInt16(voffset, value, defaultValue) {
        if (this.force_defaults || value != defaultValue) {
          this.addInt16(value);
          this.slot(voffset);
        }
      }
      addFieldInt32(voffset, value, defaultValue) {
        if (this.force_defaults || value != defaultValue) {
          this.addInt32(value);
          this.slot(voffset);
        }
      }
      addFieldInt64(voffset, value, defaultValue) {
        if (this.force_defaults || !value.equals(defaultValue)) {
          this.addInt64(value);
          this.slot(voffset);
        }
      }
      addFieldFloat32(voffset, value, defaultValue) {
        if (this.force_defaults || value != defaultValue) {
          this.addFloat32(value);
          this.slot(voffset);
        }
      }
      addFieldFloat64(voffset, value, defaultValue) {
        if (this.force_defaults || value != defaultValue) {
          this.addFloat64(value);
          this.slot(voffset);
        }
      }
      addFieldOffset(voffset, value, defaultValue) {
        if (this.force_defaults || value != defaultValue) {
          this.addOffset(value);
          this.slot(voffset);
        }
      }
      /**
       * Structs are stored inline, so nothing additional is being added. `d` is always 0.
       */
      addFieldStruct(voffset, value, defaultValue) {
        if (value != defaultValue) {
          this.nested(value);
          this.slot(voffset);
        }
      }
      /**
       * Structures are always stored inline, they need to be created right
       * where they're used.  You'll get this assertion failure if you
       * created it elsewhere.
       */
      nested(obj) {
        if (obj != this.offset()) {
          throw new Error("FlatBuffers: struct must be serialized inline.");
        }
      }
      /**
       * Should not be creating any other object, string or vector
       * while an object is being constructed
       */
      notNested() {
        if (this.isNested) {
          throw new Error("FlatBuffers: object serialization must not be nested.");
        }
      }
      /**
       * Set the current vtable at `voffset` to the current location in the buffer.
       */
      slot(voffset) {
        if (this.vtable !== null)
          this.vtable[voffset] = this.offset();
      }
      /**
       * @returns Offset relative to the end of the buffer.
       */
      offset() {
        return this.bb.capacity() - this.space;
      }
      /**
       * Doubles the size of the backing ByteBuffer and copies the old data towards
       * the end of the new buffer (since we build the buffer backwards).
       *
       * @param bb The current buffer with the existing data
       * @returns A new byte buffer with the old data copied
       * to it. The data is located at the end of the buffer.
       *
       * uint8Array.set() formally takes {Array<number>|ArrayBufferView}, so to pass
       * it a uint8Array we need to suppress the type check:
       * @suppress {checkTypes}
       */
      static growByteBuffer(bb) {
        const old_buf_size = bb.capacity();
        if (old_buf_size & 3221225472) {
          throw new Error("FlatBuffers: cannot grow buffer beyond 2 gigabytes.");
        }
        const new_buf_size = old_buf_size << 1;
        const nbb = ByteBuffer.allocate(new_buf_size);
        nbb.setPosition(new_buf_size - old_buf_size);
        nbb.bytes().set(bb.bytes(), new_buf_size - old_buf_size);
        return nbb;
      }
      /**
       * Adds on offset, relative to where it will be written.
       *
       * @param offset The offset to add.
       */
      addOffset(offset) {
        this.prep(SIZEOF_INT, 0);
        this.writeInt32(this.offset() - offset + SIZEOF_INT);
      }
      /**
       * Start encoding a new object in the buffer.  Users will not usually need to
       * call this directly. The FlatBuffers compiler will generate helper methods
       * that call this method internally.
       */
      startObject(numfields) {
        this.notNested();
        if (this.vtable == null) {
          this.vtable = [];
        }
        this.vtable_in_use = numfields;
        for (let i = 0; i < numfields; i++) {
          this.vtable[i] = 0;
        }
        this.isNested = true;
        this.object_start = this.offset();
      }
      /**
       * Finish off writing the object that is under construction.
       *
       * @returns The offset to the object inside `dataBuffer`
       */
      endObject() {
        if (this.vtable == null || !this.isNested) {
          throw new Error("FlatBuffers: endObject called without startObject");
        }
        this.addInt32(0);
        const vtableloc = this.offset();
        let i = this.vtable_in_use - 1;
        for (; i >= 0 && this.vtable[i] == 0; i--) {
        }
        const trimmed_size = i + 1;
        for (; i >= 0; i--) {
          this.addInt16(this.vtable[i] != 0 ? vtableloc - this.vtable[i] : 0);
        }
        const standard_fields = 2;
        this.addInt16(vtableloc - this.object_start);
        const len = (trimmed_size + standard_fields) * SIZEOF_SHORT;
        this.addInt16(len);
        let existing_vtable = 0;
        const vt1 = this.space;
        outer_loop:
          for (i = 0; i < this.vtables.length; i++) {
            const vt2 = this.bb.capacity() - this.vtables[i];
            if (len == this.bb.readInt16(vt2)) {
              for (let j = SIZEOF_SHORT; j < len; j += SIZEOF_SHORT) {
                if (this.bb.readInt16(vt1 + j) != this.bb.readInt16(vt2 + j)) {
                  continue outer_loop;
                }
              }
              existing_vtable = this.vtables[i];
              break;
            }
          }
        if (existing_vtable) {
          this.space = this.bb.capacity() - vtableloc;
          this.bb.writeInt32(this.space, existing_vtable - vtableloc);
        } else {
          this.vtables.push(this.offset());
          this.bb.writeInt32(this.bb.capacity() - vtableloc, this.offset() - vtableloc);
        }
        this.isNested = false;
        return vtableloc;
      }
      /**
       * Finalize a buffer, poiting to the given `root_table`.
       */
      finish(root_table, opt_file_identifier, opt_size_prefix) {
        const size_prefix = opt_size_prefix ? SIZE_PREFIX_LENGTH : 0;
        if (opt_file_identifier) {
          const file_identifier = opt_file_identifier;
          this.prep(this.minalign, SIZEOF_INT + FILE_IDENTIFIER_LENGTH + size_prefix);
          if (file_identifier.length != FILE_IDENTIFIER_LENGTH) {
            throw new Error("FlatBuffers: file identifier must be length " + FILE_IDENTIFIER_LENGTH);
          }
          for (let i = FILE_IDENTIFIER_LENGTH - 1; i >= 0; i--) {
            this.writeInt8(file_identifier.charCodeAt(i));
          }
        }
        this.prep(this.minalign, SIZEOF_INT + size_prefix);
        this.addOffset(root_table);
        if (size_prefix) {
          this.addInt32(this.bb.capacity() - this.space);
        }
        this.bb.setPosition(this.space);
      }
      /**
       * Finalize a size prefixed buffer, pointing to the given `root_table`.
       */
      finishSizePrefixed(root_table, opt_file_identifier) {
        this.finish(root_table, opt_file_identifier, true);
      }
      /**
       * This checks a required field has been set in a given table that has
       * just been constructed.
       */
      requiredField(table, field) {
        const table_start = this.bb.capacity() - table;
        const vtable_start = table_start - this.bb.readInt32(table_start);
        const ok = this.bb.readInt16(vtable_start + field) != 0;
        if (!ok) {
          throw new Error("FlatBuffers: field " + field + " must be set");
        }
      }
      /**
       * Start a new array/vector of objects.  Users usually will not call
       * this directly. The FlatBuffers compiler will create a start/end
       * method for vector types in generated code.
       *
       * @param elem_size The size of each element in the array
       * @param num_elems The number of elements in the array
       * @param alignment The alignment of the array
       */
      startVector(elem_size, num_elems, alignment) {
        this.notNested();
        this.vector_num_elems = num_elems;
        this.prep(SIZEOF_INT, elem_size * num_elems);
        this.prep(alignment, elem_size * num_elems);
      }
      /**
       * Finish off the creation of an array and all its elements. The array must be
       * created with `startVector`.
       *
       * @returns The offset at which the newly created array
       * starts.
       */
      endVector() {
        this.writeInt32(this.vector_num_elems);
        return this.offset();
      }
      /**
       * Encode the string `s` in the buffer using UTF-8. If the string passed has
       * already been seen, we return the offset of the already written string
       *
       * @param s The string to encode
       * @return The offset in the buffer where the encoded string starts
       */
      createSharedString(s) {
        if (!s) {
          return 0;
        }
        if (!this.string_maps) {
          this.string_maps = /* @__PURE__ */ new Map();
        }
        if (this.string_maps.has(s)) {
          return this.string_maps.get(s);
        }
        const offset = this.createString(s);
        this.string_maps.set(s, offset);
        return offset;
      }
      /**
       * Encode the string `s` in the buffer using UTF-8. If a Uint8Array is passed
       * instead of a string, it is assumed to contain valid UTF-8 encoded data.
       *
       * @param s The string to encode
       * @return The offset in the buffer where the encoded string starts
       */
      createString(s) {
        if (!s) {
          return 0;
        }
        let utf8;
        if (s instanceof Uint8Array) {
          utf8 = s;
        } else {
          utf8 = [];
          let i = 0;
          while (i < s.length) {
            let codePoint;
            const a = s.charCodeAt(i++);
            if (a < 55296 || a >= 56320) {
              codePoint = a;
            } else {
              const b = s.charCodeAt(i++);
              codePoint = (a << 10) + b + (65536 - (55296 << 10) - 56320);
            }
            if (codePoint < 128) {
              utf8.push(codePoint);
            } else {
              if (codePoint < 2048) {
                utf8.push(codePoint >> 6 & 31 | 192);
              } else {
                if (codePoint < 65536) {
                  utf8.push(codePoint >> 12 & 15 | 224);
                } else {
                  utf8.push(codePoint >> 18 & 7 | 240, codePoint >> 12 & 63 | 128);
                }
                utf8.push(codePoint >> 6 & 63 | 128);
              }
              utf8.push(codePoint & 63 | 128);
            }
          }
        }
        this.addInt8(0);
        this.startVector(1, utf8.length, 1);
        this.bb.setPosition(this.space -= utf8.length);
        for (let i = 0, offset = this.space, bytes = this.bb.bytes(); i < utf8.length; i++) {
          bytes[offset++] = utf8[i];
        }
        return this.endVector();
      }
      /**
       * A helper function to avoid generated code depending on this file directly.
       */
      createLong(low, high) {
        return Long.create(low, high);
      }
      /**
       * A helper function to pack an object
       *
       * @returns offset of obj
       */
      createObjectOffset(obj) {
        if (obj === null) {
          return 0;
        }
        if (typeof obj === "string") {
          return this.createString(obj);
        } else {
          return obj.pack(this);
        }
      }
      /**
       * A helper function to pack a list of object
       *
       * @returns list of offsets of each non null object
       */
      createObjectOffsetList(list) {
        const ret = [];
        for (let i = 0; i < list.length; ++i) {
          const val = list[i];
          if (val !== null) {
            ret.push(this.createObjectOffset(val));
          } else {
            throw new Error("FlatBuffers: Argument for createObjectOffsetList cannot contain null.");
          }
        }
        return ret;
      }
      createStructOffsetList(list, startFunc) {
        startFunc(this, list.length);
        this.createObjectOffsetList(list);
        return this.endVector();
      }
    }
    function getProtocolAndHostPathFromUrl(url) {
      const proto = url.startsWith("http://") ? "http" : "https";
      const hostPath = url.replace(/^(?:[a-z]+:)?\/\//, "").replace(/\/*$/, "");
      return [proto, hostPath];
    }
    function buildFlatBuffer(level, slug, data2) {
      const builder = new Builder(128);
      const messageOffset = builder.createString(slug);
      const fieldsArr = [];
      for (const [key, value] of Object.entries(data2)) {
        const keyOffset = builder.createString(key);
        const valueOffset = builder.createString(value);
        builder.startObject(2);
        builder.addFieldOffset(0, keyOffset, 0);
        builder.addFieldOffset(1, valueOffset, 0);
        fieldsArr.unshift(builder.endObject());
      }
      builder.startVector(4, fieldsArr.length, 4);
      for (const offset of fieldsArr) {
        builder.addOffset(offset);
      }
      const fieldsOffset = builder.endVector();
      builder.startObject(3);
      builder.addFieldOffset(0, messageOffset, 0);
      builder.addFieldInt8(1, level, 0);
      builder.addFieldOffset(2, fieldsOffset, 0);
      builder.finish(builder.endObject());
      return builder.asUint8Array();
    }
    class ServiceOutput extends BaseOutput {
      constructor(sessionId, origin, settings) {
        super(sessionId, origin, settings);
        this._level = exports2.LevelNumber.Error;
        if (!settings) {
          throw new Error("Missing settings for logging service output.");
        }
        if (!settings.baseUrl || !settings.baseUrl.trim().length) {
          throw new Error("Missing baseUrl settings for logging service output.");
        }
        const [proto, hostPath] = getProtocolAndHostPathFromUrl(settings.baseUrl);
        if (!hostPath.trim().length) {
          throw new Error("Invalid base url for logging service output, expected a host name.");
        }
        this._url = `${proto}://${hostPath}`;
        this._http = settings.http || axios2.create();
      }
      async send(err) {
        try {
          await this._http.post(this._url, Buffer.from(buildFlatBuffer(exports2.LevelNumber.Fatal, err.toString(), {
            ...err.toFlatData(),
            sessionId: this._sessionId,
            origin: this._origin
          })));
        } catch (e) {
          window.console.error("Failed to send log to external service", e);
        }
      }
    }
    let random2 = (bytes) => crypto.getRandomValues(new Uint8Array(bytes));
    let customRandom2 = (alphabet, size, getRandom) => {
      let mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
      let step = -~(1.6 * mask * size / alphabet.length);
      return () => {
        let id = "";
        while (true) {
          let bytes = getRandom(step);
          let j = step;
          while (j--) {
            id += alphabet[bytes[j] & mask] || "";
            if (id.length === size)
              return id;
          }
        }
      };
    };
    let customAlphabet2 = (alphabet, size) => customRandom2(alphabet, size, random2);
    const sessionIdGenerator2 = customAlphabet2("346789ABCDEFGHJKLMNPQRTUVWXY", 12);
    class Logger {
      constructor(origin, config) {
        this._outputs = [];
        this._origin = origin;
        this._sessionId = config && config.sessionId ? config.sessionId : Logger.generateSessionId();
        this.addOutput(ConsoleOutput);
      }
      static generateSessionId() {
        return sessionIdGenerator2();
      }
      get sessionId() {
        return this._sessionId;
      }
      addOutput(OutputConstructor, ...settings) {
        const output = new OutputConstructor(this._sessionId, this._origin, ...settings);
        this._outputs.push(output);
        return output;
      }
      throw(error) {
        if (!error || !error.isOpenTicketError) {
          console.error("Failed to throw error, error object is not an OpenTicketError", error);
          this.log(new UnexpectedError(error));
        } else {
          this.log(error);
        }
        throw error;
      }
      log(error) {
        let err = error;
        if (!error || !error.isOpenTicketError) {
          console.error("Failed to properly log error, error object is not an OpenTicketError", error);
          err = new UnexpectedError(error);
        }
        this._send(err);
      }
      _send(err) {
        for (const output of this._outputs) {
          void new Promise((resolve) => {
            output.send(err);
            resolve();
          });
        }
      }
    }
    class CrudRoot extends CrudNode {
      constructor(config) {
        super(null, "root");
        this.$config = config;
        this._http = config.http || axios2.create();
        this._factory = new CrudFactory({
          models: config.models
        });
        this._logger = new Logger(config.origin);
      }
      get $http() {
        return this._http;
      }
      get $root() {
        return this;
      }
      get $factory() {
        return this._factory;
      }
      get $log() {
        return this._logger;
      }
      get $path() {
        return this.$config.baseUrl;
      }
      getRelation(type) {
        for (const prop of Object.values(this)) {
          if (prop instanceof CrudToMany && prop.type === type) {
            return prop;
          }
        }
        throw Error(`Root relation for type ${type} not found`);
      }
      get $routes() {
        const routes = [];
        for (const prop of Object.values(this)) {
          if (prop instanceof CrudNode) {
            routes.push(...prop.$routes);
          }
        }
        return routes;
      }
    }
    class Picker {
      constructor(parent) {
        this.hasLocalChanges = false;
        this.count = 0;
        this.linked = {};
        this._originalLinked = {};
        this._models = {};
        this.pending = {
          link: [],
          unlink: []
        };
        this.getPickerPage = async (request) => {
          const response = await this._parent.getPickerPage(request);
          this._updateLinkedData(response);
          return response;
        };
        this._parent = parent;
      }
      // Link a model in the local state, add as a pending operation
      link(model) {
        const unlinkIndex = this.pending.unlink.indexOf(model.guid);
        if (unlinkIndex > -1) {
          this.pending.unlink.splice(unlinkIndex, 1);
        } else {
          this.pending.link.push(model.guid);
        }
        this.linked[model.guid] = true;
        this.count++;
        this._updateHasLocalChanges();
      }
      // Unlink a model in the local state, add as a pending operation
      unlink(model) {
        const linkIndex = this.pending.link.indexOf(model.guid);
        if (linkIndex > -1) {
          this.pending.link.splice(linkIndex, 1);
        } else {
          this.pending.unlink.push(model.guid);
        }
        this.linked[model.guid] = false;
        this.count--;
        this._updateHasLocalChanges();
      }
      // Save the pending operations via the NestedPickable and apply changes
      // to the local state.
      async save() {
        const promises = [];
        if (this.pending.link.length) {
          promises.push(this._parent.linkPickerModels(this.pending.link));
        }
        if (this.pending.unlink.length) {
          promises.push(this._parent.unlinkPickerModels(this.pending.unlink));
        }
        if (!promises.length) {
          return;
        }
        await Promise.all(promises);
        for (const guid of this.pending.link) {
          this._originalLinked[guid] = true;
        }
        for (const guid of this.pending.unlink) {
          this._originalLinked[guid] = false;
        }
        this.reset();
        this.count = Object.values(this.linked).filter((linked) => linked).length;
      }
      // Undo pending changes and reset linked states
      reset() {
        this.pending.link = [];
        this.pending.unlink = [];
        Object.assign(this.linked, this._originalLinked);
        this._updateHasLocalChanges();
      }
      // set `.hasLocalChanges` depending on whether or not there are
      // pending local changes to save.
      _updateHasLocalChanges() {
        this.hasLocalChanges = !!(this.pending.link.length || this.pending.unlink.length);
      }
      // Add metadata to the local state
      _updateLinkedData(response) {
        for (let i = 0; i < response.data.length; i++) {
          const item = response.data[i];
          this._originalLinked[item.guid] = !!item.raw.linked;
          this.linked[item.guid] = !!item.raw.linked;
          if (!!item.raw.linked && !this._models[item.guid]) {
            this.count++;
          }
          this._models[item.guid] = item;
        }
      }
    }
    class NestedPicker {
      // NestedPicker needs a NestedPickable implementation to function, for
      // example the nested_pick CRUD mixin.
      constructor(parent) {
        this.hasLocalChanges = false;
        this.linked = {};
        this.count = {};
        this.pending = {};
        this._models = {};
        this.getNestedPage = async (request) => {
          const response = await this._parent.getPickerNestedPage(request);
          this._setLinkedStatus(request, response);
          return response;
        };
        this.getSumsPage = async (request) => {
          const response = await this._parent.getPickerSumsPage(request);
          this._setSumsLinkedStatus(response);
          return response;
        };
        this._parent = parent;
      }
      // Save the pending operations via the NestedPickable and apply changes
      // to the local state.
      async save() {
        const link = [];
        const unlink = [];
        for (const nestedPending of Object.values(this.pending)) {
          link.push(...nestedPending.link);
          unlink.push(...nestedPending.unlink);
        }
        const promises = [];
        if (link.length) {
          promises.push(this._parent.linkPickerModels(link));
        }
        if (unlink.length) {
          promises.push(this._parent.unlinkPickerModels(unlink));
        }
        await Promise.all(promises);
        for (const sumsGuid of Object.keys(this.pending)) {
          for (const linked of this.pending[sumsGuid].link) {
            this.linked[sumsGuid][linked] = true;
          }
          for (const unlinked of this.pending[sumsGuid].unlink) {
            this.linked[sumsGuid][unlinked] = false;
          }
          this.pending[sumsGuid].link = [];
          this.pending[sumsGuid].unlink = [];
        }
        this._updateHasLocalChanges();
      }
      // Undo pending changes and reset linked states
      reset() {
        for (const sumsGuid of Object.keys(this.pending)) {
          for (const linked of this.pending[sumsGuid].link) {
            this.linked[sumsGuid][linked] = false;
          }
          for (const unlinked of this.pending[sumsGuid].unlink) {
            this.linked[sumsGuid][unlinked] = true;
          }
          this.pending[sumsGuid].link = [];
          this.pending[sumsGuid].unlink = [];
        }
      }
      // Link a model in the local state, add as a pending operation
      link(sumsGuid, model) {
        const unlinkIndex = this.pending[sumsGuid].unlink.indexOf(model.guid);
        if (unlinkIndex > -1) {
          this.pending[sumsGuid].unlink.splice(unlinkIndex, 1);
        } else {
          this.pending[sumsGuid].link.push(model.guid);
        }
        this.linked[sumsGuid][model.guid] = true;
        this.count[sumsGuid]++;
        this._updateHasLocalChanges();
      }
      // Unlink a model in the local state, add as a pending operation
      unlink(sumsGuid, model) {
        const linkIndex = this.pending[sumsGuid].link.indexOf(model.guid);
        if (linkIndex > -1) {
          this.pending[sumsGuid].link.splice(linkIndex, 1);
        } else {
          this.pending[sumsGuid].unlink.push(model.guid);
        }
        this.linked[sumsGuid][model.guid] = false;
        this.count[sumsGuid]--;
        this._updateHasLocalChanges();
      }
      // Add sums metadata to the local state
      _setSumsLinkedStatus(response) {
        response.data.forEach((model) => {
          if (!this.count[model.guid]) {
            this.count[model.guid] = model.raw.linked;
          }
        });
      }
      // Add nested metadata to the local state
      _setLinkedStatus(request, response) {
        if (!this.linked[request.guid]) {
          this.linked[request.guid] = {};
        }
        if (!this.pending[request.guid]) {
          this.pending[request.guid] = {
            link: [],
            unlink: []
          };
        }
        response.data.forEach((model) => {
          this._models[model.guid] = model;
          if (this.linked[request.guid][model.guid] === void 0) {
            this.linked[request.guid][model.guid] = !!model.raw.linked;
          }
        });
      }
      // set `.hasLocalChanges` depending on whether or not there are
      // pending local changes to save.
      _updateHasLocalChanges() {
        for (const nestedPending of Object.values(this.pending)) {
          if (nestedPending.link.length || nestedPending.unlink.length) {
            this.hasLocalChanges = true;
            return;
          }
        }
        this.hasLocalChanges = false;
      }
    }
    function arr_move(arr, oldIndex, newIndex) {
      const element = arr[oldIndex];
      arr.splice(oldIndex, 1);
      arr.splice(newIndex, 0, element);
    }
    class Sorter {
      constructor(parent) {
        this._dirty = [];
        this._original = [];
        this._events = [];
        this.getPage = async (request) => {
          const response = await this._parent.getSortedPage(request);
          this._updateSortData(response);
          return response;
        };
        this._parent = parent;
      }
      hasLocalChanges() {
        for (let i = 0; i < this._original.length; i++) {
          if (this._original[i].guid !== this._dirty[i].guid) {
            return true;
          }
        }
        return false;
      }
      move(oldIndex, newIndex) {
        const item = this._dirty[oldIndex];
        const anchor = this._dirty[newIndex];
        const order = newIndex > oldIndex ? "after" : "before";
        arr_move(this._dirty, oldIndex, newIndex);
        this._events.push({
          item,
          order,
          anchor
        });
      }
      async save() {
        try {
          for (const event of this._events) {
            await this._parent.sortModel(event.item, event.order, event.anchor);
            const oldIndex = this._dirty.findIndex((model) => model.guid === event.item.guid);
            const newIndex = this._dirty.findIndex((model) => model.guid === event.anchor.guid);
            arr_move(this._original, oldIndex, newIndex);
          }
        } finally {
          this.reset();
        }
      }
      reset() {
        this._events = [];
        this._dirty = Array.from(this._original);
      }
      _updateSortData(response) {
        this._dirty.push(...response.data);
        this._original.push(...response.data);
      }
    }
    exports2.PaginationOrder = void 0;
    (function(PaginationOrder) {
      PaginationOrder["ASC"] = "asc";
      PaginationOrder["DESC"] = "desc";
    })(exports2.PaginationOrder || (exports2.PaginationOrder = {}));
    function parseFilters(filters) {
      const map = {};
      for (const key of Object.keys(filters)) {
        map[`filter[${key}]`] = `${filters[key]}`;
      }
      return map;
    }
    function parseOrdering(ordering) {
      const params = {
        sort: ""
      };
      const ordered = Object.entries(ordering).map(([field, fieldOrdering]) => ({ field, ...fieldOrdering })).sort((a, b) => a.index - b.index);
      for (const item of ordered) {
        params.sort += item.order === exports2.PaginationOrder.DESC ? `-${item.field}` : item.field;
      }
      return params;
    }
    class ArrayPaginatable {
      constructor(data2) {
        this.getPage = async (request) => {
          const total = this._data.length;
          const page = request.page || 1;
          const perPage = request.per_page || 5;
          const lastPage = Math.ceil(total / perPage);
          const data3 = [];
          for (let i = 0; i < perPage; i++) {
            const j = perPage * (page - 1) + i;
            if (j >= total) {
              break;
            }
            data3.push(this._data[j]);
          }
          return {
            current_page: page,
            last_page: lastPage,
            per_page: perPage,
            total,
            data: data3,
            path: "",
            first_page_url: "",
            last_page_url: "",
            from: "",
            to: ""
          };
        };
        this._data = data2;
      }
    }
    const REFRESH_DEBOUNCE_MILLIS$1 = 300;
    class Pagination {
      /**
       * @param paginatable
       * @param optionals
       */
      constructor(paginatable, optionals) {
        this.loading = false;
        this.page = null;
        this.filters = {};
        this._ordering = {};
        this._refreshDebounce = null;
        this._refreshPromise = null;
        this._refreshPromiseResolve = null;
        this._initialized = false;
        if (typeof paginatable === "function") {
          this._paginatable = paginatable;
        } else {
          this._paginatable = paginatable.getPage;
        }
        this._optionals = optionals || {};
      }
      defaults() {
        return { ...this._request };
      }
      /**
       * Initialize with default or specified configuration and fetch the first page.
       * @param _config
       */
      async init(_config) {
        const config = _config || {};
        this._request = { page: 1, ...config.defaults };
        if (config && config.filters) {
          Object.assign(this.filters, config.filters);
        }
        await this.getPage(this._request);
        this._initialized = true;
      }
      /**
       * @param field
       * @param value
       */
      async addFilter(field, value) {
        this._checkIfInitialized();
        this.filters[field] = value;
        return this._refreshWithDebounce();
      }
      /**
       * @param field
       */
      async removeFilter(field) {
        this._checkIfInitialized();
        delete this.filters[field];
        return this._refreshWithDebounce();
      }
      /**
       * Check if the canOrder method is implemented and the specified field can be ordered.
       * @param field
       */
      canOrder(field) {
        if (!this._optionals.canOrder) {
          return false;
        }
        return this._optionals.canOrder(field);
      }
      /**
       * Returns the ordering that is set for the specified field.
       * @param field
       */
      getFieldOrder(field) {
        if (this._ordering[field]) {
          return this._ordering[field];
        }
        return null;
      }
      /**
       * @param field
       * @param order
       */
      async addOrder(field, order) {
        this._checkIfInitialized();
        if (!this.canOrder(field)) {
          throw new StringError("Field cannot be ordered");
        }
        this._ordering = {
          [field]: {
            order,
            index: 0
          }
        };
        return this._refreshWithDebounce();
      }
      /**
       * @param field
       */
      async removeOrder(field) {
        this._checkIfInitialized();
        this._ordering = {};
        return this._refreshWithDebounce();
      }
      /**
       * Retrieves the page from the api again, overwriting the local state.
       * If no custom request is specified the request in the local state is used.
       * @param request
       */
      async refresh(request) {
        return this.getPage(request || this._request);
      }
      async nextPage() {
        this._checkIfInitialized();
        return this.getPage({
          ...this._request,
          page: this.page.current_page + 1
        });
      }
      async prevPage() {
        this._checkIfInitialized();
        return this.getPage({
          ...this._request,
          page: this.page.current_page - 1
        });
      }
      /**
       * Retrieve the correct page from the api based on the specified request.
       * @param request
       */
      async getPage(request) {
        this.loading = true;
        try {
          this.page = await this._paginatable({
            ...parseFilters(this.filters),
            ...parseOrdering(this._ordering),
            ...this._request,
            ...request
          });
          return this.page;
        } finally {
          this.loading = false;
        }
      }
      /**
       * Retrieves the page from the api with a debounce to keep the amount of api requests low.
       * The local state request is used.
       * @private
       */
      async _refreshWithDebounce() {
        if (!this._refreshPromise) {
          this._refreshPromise = new Promise((resolve) => {
            this._refreshPromiseResolve = resolve;
          });
        }
        this.loading = true;
        if (this._refreshDebounce) {
          window.clearTimeout(this._refreshDebounce);
        }
        this._refreshDebounce = window.setTimeout(async () => {
          this._refreshDebounce = null;
          const p = await this.getPage(this._request);
          this._refreshPromiseResolve(p);
          this._refreshPromise = null;
          this._refreshPromiseResolve = null;
        }, REFRESH_DEBOUNCE_MILLIS$1);
        return this._refreshPromise;
      }
      /**
       * @private
       */
      _checkIfInitialized() {
        if (!this._initialized) {
          throw new StringError("Pagination not initialized");
        }
      }
    }
    const REFRESH_DEBOUNCE_MILLIS = 300;
    class LazyList {
      /**
       * @param paginatable
       * @param optionals
       */
      constructor(paginatable, optionals) {
        this.loading = false;
        this.filters = {};
        this.data = [];
        this.response = null;
        this.hasMore = true;
        this._refreshDebounce = null;
        this._refreshPromise = null;
        this._refreshPromiseResolve = null;
        if (typeof paginatable === "function") {
          this._paginatable = paginatable;
        } else {
          this._paginatable = paginatable.getPage;
        }
        this._optionals = optionals || {};
      }
      /**
       * Initialize with default or specified configuration and fetch the first data.
       * @param _config
       */
      async init(_config) {
        const config = _config || {};
        this._request = { page: 1, ...config.defaults };
        this.data = [];
        this.hasMore = true;
        if (config && config.filters) {
          Object.assign(this.filters, config.filters);
        }
        await this.loadMore();
      }
      /**
       * @param key
       * @param filter
       */
      async addFilter(key, filter2) {
        this.filters[key] = filter2;
        await this._refreshWithDebounce();
      }
      /**
       * @param key
       */
      async removeFilter(key) {
        delete this.filters[key];
        await this._refreshWithDebounce();
      }
      async refresh() {
        await this._refreshWithDebounce();
      }
      /**
       * Load the next page and append it to the local state data.
       */
      async loadMore() {
        if (!this.hasMore) {
          throw new StringError("No items left to retrieve");
        }
        this.loading = true;
        try {
          const page = this._request.page++;
          const res = await this._paginatable({
            ...this._request,
            ...parseFilters(this.filters),
            page
          });
          this.data.push(...res.data);
          this.response = {
            ...res,
            data: void 0
          };
          if (this.data.length === res.total) {
            this.hasMore = false;
          }
        } finally {
          this.loading = false;
        }
      }
      /**
       * Load the next page and append it to the local state data with a debounce to keep the amount of api request low.
       * @private
       */
      async _refreshWithDebounce() {
        if (!this._refreshPromise) {
          this._refreshPromise = new Promise((resolve) => {
            this._refreshPromiseResolve = resolve;
          });
        }
        this.loading = true;
        this.data = [];
        if (this._refreshDebounce) {
          window.clearTimeout(this._refreshDebounce);
        }
        this._refreshDebounce = window.setTimeout(async () => {
          this._refreshDebounce = null;
          this._request.page = 1;
          await this.init({ defaults: this._request });
          this._refreshPromiseResolve();
          this._refreshPromise = null;
          this._refreshPromiseResolve = null;
        }, REFRESH_DEBOUNCE_MILLIS);
        return this._refreshPromise;
      }
    }
    function addGlobal(scope, ref) {
      let root = window || commonjsGlobal;
      if (!root) {
        return;
      }
      root = root.OpenTicket = root.OpenTicket || {};
      root[scope] = ref;
    }
    exports2.ArrayPaginatable = ArrayPaginatable;
    exports2.BaseError = BaseError;
    exports2.ConsoleOutput = ConsoleOutput;
    exports2.CrudFactory = CrudFactory;
    exports2.CrudModel = CrudModel;
    exports2.CrudModelProps = CrudModelProps;
    exports2.CrudNode = CrudNode;
    exports2.CrudRoot = CrudRoot;
    exports2.CrudRoute = index;
    exports2.CrudToMany = CrudToMany;
    exports2.CrudToManyMixin = CrudToManyMixin;
    exports2.CrudToOne = CrudToOne;
    exports2.Form = Form;
    exports2.FormValidationError = FormValidationError;
    exports2.LazyList = LazyList;
    exports2.Logger = Logger;
    exports2.ModelForm = ModelForm;
    exports2.NestedPicker = NestedPicker;
    exports2.Pagination = Pagination;
    exports2.Picker = Picker;
    exports2.ServiceOutput = ServiceOutput;
    exports2.Sorter = Sorter;
    exports2.StringError = StringError;
    exports2.UnexpectedError = UnexpectedError;
    exports2.addGlobal = addGlobal;
    exports2.levelNumberToLevel = levelNumberToLevel;
    exports2.levelToLevelNumber = levelToLevelNumber;
    exports2.parseFilters = parseFilters;
    exports2.parseOrdering = parseOrdering;
    exports2.toMany = toMany;
    Object.defineProperty(exports2, "__esModule", { value: true });
  });
})(helpers, helpers.exports);
var helpersExports = helpers.exports;
var uaParser = { exports: {} };
(function(module, exports) {
  (function(window2, undefined$1) {
    var LIBVERSION = "1.0.37", EMPTY = "", UNKNOWN = "?", FUNC_TYPE = "function", UNDEF_TYPE = "undefined", OBJ_TYPE = "object", STR_TYPE = "string", MAJOR = "major", MODEL = "model", NAME = "name", TYPE = "type", VENDOR = "vendor", VERSION2 = "version", ARCHITECTURE = "architecture", CONSOLE = "console", MOBILE = "mobile", TABLET = "tablet", SMARTTV = "smarttv", WEARABLE = "wearable", EMBEDDED = "embedded", UA_MAX_LENGTH = 500;
    var AMAZON = "Amazon", APPLE = "Apple", ASUS = "ASUS", BLACKBERRY = "BlackBerry", BROWSER = "Browser", CHROME = "Chrome", EDGE = "Edge", FIREFOX = "Firefox", GOOGLE = "Google", HUAWEI = "Huawei", LG = "LG", MICROSOFT = "Microsoft", MOTOROLA = "Motorola", OPERA = "Opera", SAMSUNG = "Samsung", SHARP = "Sharp", SONY = "Sony", XIAOMI = "Xiaomi", ZEBRA = "Zebra", FACEBOOK = "Facebook", CHROMIUM_OS = "Chromium OS", MAC_OS = "Mac OS";
    var extend2 = function(regexes2, extensions) {
      var mergedRegexes = {};
      for (var i in regexes2) {
        if (extensions[i] && extensions[i].length % 2 === 0) {
          mergedRegexes[i] = extensions[i].concat(regexes2[i]);
        } else {
          mergedRegexes[i] = regexes2[i];
        }
      }
      return mergedRegexes;
    }, enumerize = function(arr) {
      var enums = {};
      for (var i = 0; i < arr.length; i++) {
        enums[arr[i].toUpperCase()] = arr[i];
      }
      return enums;
    }, has = function(str1, str2) {
      return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    }, lowerize = function(str) {
      return str.toLowerCase();
    }, majorize = function(version) {
      return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split(".")[0] : undefined$1;
    }, trim2 = function(str, len) {
      if (typeof str === STR_TYPE) {
        str = str.replace(/^\s\s*/, EMPTY);
        return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
      }
    };
    var rgxMapper = function(ua, arrays) {
      var i = 0, j, k, p, q, matches, match;
      while (i < arrays.length && !matches) {
        var regex = arrays[i], props = arrays[i + 1];
        j = k = 0;
        while (j < regex.length && !matches) {
          if (!regex[j]) {
            break;
          }
          matches = regex[j++].exec(ua);
          if (!!matches) {
            for (p = 0; p < props.length; p++) {
              match = matches[++k];
              q = props[p];
              if (typeof q === OBJ_TYPE && q.length > 0) {
                if (q.length === 2) {
                  if (typeof q[1] == FUNC_TYPE) {
                    this[q[0]] = q[1].call(this, match);
                  } else {
                    this[q[0]] = q[1];
                  }
                } else if (q.length === 3) {
                  if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                    this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined$1;
                  } else {
                    this[q[0]] = match ? match.replace(q[1], q[2]) : undefined$1;
                  }
                } else if (q.length === 4) {
                  this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined$1;
                }
              } else {
                this[q] = match ? match : undefined$1;
              }
            }
          }
        }
        i += 2;
      }
    }, strMapper = function(str, map) {
      for (var i in map) {
        if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
          for (var j = 0; j < map[i].length; j++) {
            if (has(map[i][j], str)) {
              return i === UNKNOWN ? undefined$1 : i;
            }
          }
        } else if (has(map[i], str)) {
          return i === UNKNOWN ? undefined$1 : i;
        }
      }
      return str;
    };
    var oldSafariMap = {
      "1.0": "/8",
      "1.2": "/1",
      "1.3": "/3",
      "2.0": "/412",
      "2.0.2": "/416",
      "2.0.3": "/417",
      "2.0.4": "/419",
      "?": "/"
    }, windowsVersionMap = {
      "ME": "4.90",
      "NT 3.11": "NT3.51",
      "NT 4.0": "NT4.0",
      "2000": "NT 5.0",
      "XP": ["NT 5.1", "NT 5.2"],
      "Vista": "NT 6.0",
      "7": "NT 6.1",
      "8": "NT 6.2",
      "8.1": "NT 6.3",
      "10": ["NT 6.4", "NT 10.0"],
      "RT": "ARM"
    };
    var regexes = {
      browser: [
        [
          /\b(?:crmo|crios)\/([\w\.]+)/i
          // Chrome for Android/iOS
        ],
        [VERSION2, [NAME, "Chrome"]],
        [
          /edg(?:e|ios|a)?\/([\w\.]+)/i
          // Microsoft Edge
        ],
        [VERSION2, [NAME, "Edge"]],
        [
          // Presto based
          /(opera mini)\/([-\w\.]+)/i,
          // Opera Mini
          /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
          // Opera Mobi/Tablet
          /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
          // Opera
        ],
        [NAME, VERSION2],
        [
          /opios[\/ ]+([\w\.]+)/i
          // Opera mini on iphone >= 8.0
        ],
        [VERSION2, [NAME, OPERA + " Mini"]],
        [
          /\bopr\/([\w\.]+)/i
          // Opera Webkit
        ],
        [VERSION2, [NAME, OPERA]],
        [
          // Mixed
          /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
          // Baidu
        ],
        [VERSION2, [NAME, "Baidu"]],
        [
          /(kindle)\/([\w\.]+)/i,
          // Kindle
          /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
          // Lunascape/Maxthon/Netfront/Jasmine/Blazer
          // Trident based
          /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i,
          // Avant/IEMobile/SlimBrowser
          /(?:ms|\()(ie) ([\w\.]+)/i,
          // Internet Explorer
          // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
          /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
          // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
          /(heytap|ovi)browser\/([\d\.]+)/i,
          // Heytap/Ovi
          /(weibo)__([\d\.]+)/i
          // Weibo
        ],
        [NAME, VERSION2],
        [
          /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
          // UCBrowser
        ],
        [VERSION2, [NAME, "UC" + BROWSER]],
        [
          /microm.+\bqbcore\/([\w\.]+)/i,
          // WeChat Desktop for Windows Built-in Browser
          /\bqbcore\/([\w\.]+).+microm/i,
          /micromessenger\/([\w\.]+)/i
          // WeChat
        ],
        [VERSION2, [NAME, "WeChat"]],
        [
          /konqueror\/([\w\.]+)/i
          // Konqueror
        ],
        [VERSION2, [NAME, "Konqueror"]],
        [
          /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
          // IE11
        ],
        [VERSION2, [NAME, "IE"]],
        [
          /ya(?:search)?browser\/([\w\.]+)/i
          // Yandex
        ],
        [VERSION2, [NAME, "Yandex"]],
        [
          /slbrowser\/([\w\.]+)/i
          // Smart Lenovo Browser
        ],
        [VERSION2, [NAME, "Smart Lenovo " + BROWSER]],
        [
          /(avast|avg)\/([\w\.]+)/i
          // Avast/AVG Secure Browser
        ],
        [[NAME, /(.+)/, "$1 Secure " + BROWSER], VERSION2],
        [
          /\bfocus\/([\w\.]+)/i
          // Firefox Focus
        ],
        [VERSION2, [NAME, FIREFOX + " Focus"]],
        [
          /\bopt\/([\w\.]+)/i
          // Opera Touch
        ],
        [VERSION2, [NAME, OPERA + " Touch"]],
        [
          /coc_coc\w+\/([\w\.]+)/i
          // Coc Coc Browser
        ],
        [VERSION2, [NAME, "Coc Coc"]],
        [
          /dolfin\/([\w\.]+)/i
          // Dolphin
        ],
        [VERSION2, [NAME, "Dolphin"]],
        [
          /coast\/([\w\.]+)/i
          // Opera Coast
        ],
        [VERSION2, [NAME, OPERA + " Coast"]],
        [
          /miuibrowser\/([\w\.]+)/i
          // MIUI Browser
        ],
        [VERSION2, [NAME, "MIUI " + BROWSER]],
        [
          /fxios\/([-\w\.]+)/i
          // Firefox for iOS
        ],
        [VERSION2, [NAME, FIREFOX]],
        [
          /\bqihu|(qi?ho?o?|360)browser/i
          // 360
        ],
        [[NAME, "360 " + BROWSER]],
        [
          /(oculus|sailfish|huawei|vivo)browser\/([\w\.]+)/i
        ],
        [[NAME, /(.+)/, "$1 " + BROWSER], VERSION2],
        [
          // Oculus/Sailfish/HuaweiBrowser/VivoBrowser
          /samsungbrowser\/([\w\.]+)/i
          // Samsung Internet
        ],
        [VERSION2, [NAME, SAMSUNG + " Internet"]],
        [
          /(comodo_dragon)\/([\w\.]+)/i
          // Comodo Dragon
        ],
        [[NAME, /_/g, " "], VERSION2],
        [
          /metasr[\/ ]?([\d\.]+)/i
          // Sogou Explorer
        ],
        [VERSION2, [NAME, "Sogou Explorer"]],
        [
          /(sogou)mo\w+\/([\d\.]+)/i
          // Sogou Mobile
        ],
        [[NAME, "Sogou Mobile"], VERSION2],
        [
          /(electron)\/([\w\.]+) safari/i,
          // Electron-based App
          /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
          // Tesla
          /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i
          // QQBrowser/2345 Browser
        ],
        [NAME, VERSION2],
        [
          /(lbbrowser)/i,
          // LieBao Browser
          /\[(linkedin)app\]/i
          // LinkedIn App for iOS & Android
        ],
        [NAME],
        [
          // WebView
          /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
          // Facebook App for iOS & Android
        ],
        [[NAME, FACEBOOK], VERSION2],
        [
          /(Klarna)\/([\w\.]+)/i,
          // Klarna Shopping Browser for iOS & Android
          /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
          // Kakao App
          /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
          // Naver InApp
          /safari (line)\/([\w\.]+)/i,
          // Line App for iOS
          /\b(line)\/([\w\.]+)\/iab/i,
          // Line App for Android
          /(alipay)client\/([\w\.]+)/i,
          // Alipay
          /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i
          // Chromium/Instagram/Snapchat
        ],
        [NAME, VERSION2],
        [
          /\bgsa\/([\w\.]+) .*safari\//i
          // Google Search Appliance on iOS
        ],
        [VERSION2, [NAME, "GSA"]],
        [
          /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
          // TikTok
        ],
        [VERSION2, [NAME, "TikTok"]],
        [
          /headlesschrome(?:\/([\w\.]+)| )/i
          // Chrome Headless
        ],
        [VERSION2, [NAME, CHROME + " Headless"]],
        [
          / wv\).+(chrome)\/([\w\.]+)/i
          // Chrome WebView
        ],
        [[NAME, CHROME + " WebView"], VERSION2],
        [
          /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
          // Android Browser
        ],
        [VERSION2, [NAME, "Android " + BROWSER]],
        [
          /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
          // Chrome/OmniWeb/Arora/Tizen/Nokia
        ],
        [NAME, VERSION2],
        [
          /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
          // Mobile Safari
        ],
        [VERSION2, [NAME, "Mobile Safari"]],
        [
          /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
          // Safari & Safari Mobile
        ],
        [VERSION2, NAME],
        [
          /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
          // Safari < 3.0
        ],
        [NAME, [VERSION2, strMapper, oldSafariMap]],
        [
          /(webkit|khtml)\/([\w\.]+)/i
        ],
        [NAME, VERSION2],
        [
          // Gecko based
          /(navigator|netscape\d?)\/([-\w\.]+)/i
          // Netscape
        ],
        [[NAME, "Netscape"], VERSION2],
        [
          /mobile vr; rv:([\w\.]+)\).+firefox/i
          // Firefox Reality
        ],
        [VERSION2, [NAME, FIREFOX + " Reality"]],
        [
          /ekiohf.+(flow)\/([\w\.]+)/i,
          // Flow
          /(swiftfox)/i,
          // Swiftfox
          /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
          // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
          /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
          // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
          /(firefox)\/([\w\.]+)/i,
          // Other Firefox-based
          /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
          // Mozilla
          // Other
          /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
          // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
          /(links) \(([\w\.]+)/i,
          // Links
          /panasonic;(viera)/i
          // Panasonic Viera
        ],
        [NAME, VERSION2],
        [
          /(cobalt)\/([\w\.]+)/i
          // Cobalt
        ],
        [NAME, [VERSION2, /master.|lts./, ""]]
      ],
      cpu: [
        [
          /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i
          // AMD64 (x64)
        ],
        [[ARCHITECTURE, "amd64"]],
        [
          /(ia32(?=;))/i
          // IA32 (quicktime)
        ],
        [[ARCHITECTURE, lowerize]],
        [
          /((?:i[346]|x)86)[;\)]/i
          // IA32 (x86)
        ],
        [[ARCHITECTURE, "ia32"]],
        [
          /\b(aarch64|arm(v?8e?l?|_?64))\b/i
          // ARM64
        ],
        [[ARCHITECTURE, "arm64"]],
        [
          /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i
          // ARMHF
        ],
        [[ARCHITECTURE, "armhf"]],
        [
          // PocketPC mistakenly identified as PowerPC
          /windows (ce|mobile); ppc;/i
        ],
        [[ARCHITECTURE, "arm"]],
        [
          /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i
          // PowerPC
        ],
        [[ARCHITECTURE, /ower/, EMPTY, lowerize]],
        [
          /(sun4\w)[;\)]/i
          // SPARC
        ],
        [[ARCHITECTURE, "sparc"]],
        [
          /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
          // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
        ],
        [[ARCHITECTURE, lowerize]]
      ],
      device: [
        [
          //////////////////////////
          // MOBILES & TABLETS
          /////////////////////////
          // Samsung
          /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
        ],
        [MODEL, [VENDOR, SAMSUNG], [TYPE, TABLET]],
        [
          /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
          /samsung[- ]([-\w]+)/i,
          /sec-(sgh\w+)/i
        ],
        [MODEL, [VENDOR, SAMSUNG], [TYPE, MOBILE]],
        [
          // Apple
          /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
          // iPod/iPhone
        ],
        [MODEL, [VENDOR, APPLE], [TYPE, MOBILE]],
        [
          /\((ipad);[-\w\),; ]+apple/i,
          // iPad
          /applecoremedia\/[\w\.]+ \((ipad)/i,
          /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
        ],
        [MODEL, [VENDOR, APPLE], [TYPE, TABLET]],
        [
          /(macintosh);/i
        ],
        [MODEL, [VENDOR, APPLE]],
        [
          // Sharp
          /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
        ],
        [MODEL, [VENDOR, SHARP], [TYPE, MOBILE]],
        [
          // Huawei
          /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
        ],
        [MODEL, [VENDOR, HUAWEI], [TYPE, TABLET]],
        [
          /(?:huawei|honor)([-\w ]+)[;\)]/i,
          /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
        ],
        [MODEL, [VENDOR, HUAWEI], [TYPE, MOBILE]],
        [
          // Xiaomi
          /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
          // Xiaomi POCO
          /\b; (\w+) build\/hm\1/i,
          // Xiaomi Hongmi 'numeric' models
          /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
          // Xiaomi Hongmi
          /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
          // Xiaomi Redmi
          /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
          // Xiaomi Redmi 'numeric' models
          /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i
          // Xiaomi Mi
        ],
        [[MODEL, /_/g, " "], [VENDOR, XIAOMI], [TYPE, MOBILE]],
        [
          /oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,
          // Redmi Pad
          /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i
          // Mi Pad tablets
        ],
        [[MODEL, /_/g, " "], [VENDOR, XIAOMI], [TYPE, TABLET]],
        [
          // OPPO
          /; (\w+) bui.+ oppo/i,
          /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
        ],
        [MODEL, [VENDOR, "OPPO"], [TYPE, MOBILE]],
        [
          // Vivo
          /vivo (\w+)(?: bui|\))/i,
          /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
        ],
        [MODEL, [VENDOR, "Vivo"], [TYPE, MOBILE]],
        [
          // Realme
          /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
        ],
        [MODEL, [VENDOR, "Realme"], [TYPE, MOBILE]],
        [
          // Motorola
          /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
          /\bmot(?:orola)?[- ](\w*)/i,
          /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
        ],
        [MODEL, [VENDOR, MOTOROLA], [TYPE, MOBILE]],
        [
          /\b(mz60\d|xoom[2 ]{0,2}) build\//i
        ],
        [MODEL, [VENDOR, MOTOROLA], [TYPE, TABLET]],
        [
          // LG
          /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
        ],
        [MODEL, [VENDOR, LG], [TYPE, TABLET]],
        [
          /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
          /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
          /\blg-?([\d\w]+) bui/i
        ],
        [MODEL, [VENDOR, LG], [TYPE, MOBILE]],
        [
          // Lenovo
          /(ideatab[-\w ]+)/i,
          /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
        ],
        [MODEL, [VENDOR, "Lenovo"], [TYPE, TABLET]],
        [
          // Nokia
          /(?:maemo|nokia).*(n900|lumia \d+)/i,
          /nokia[-_ ]?([-\w\.]*)/i
        ],
        [[MODEL, /_/g, " "], [VENDOR, "Nokia"], [TYPE, MOBILE]],
        [
          // Google
          /(pixel c)\b/i
          // Google Pixel C
        ],
        [MODEL, [VENDOR, GOOGLE], [TYPE, TABLET]],
        [
          /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
          // Google Pixel
        ],
        [MODEL, [VENDOR, GOOGLE], [TYPE, MOBILE]],
        [
          // Sony
          /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
        ],
        [MODEL, [VENDOR, SONY], [TYPE, MOBILE]],
        [
          /sony tablet [ps]/i,
          /\b(?:sony)?sgp\w+(?: bui|\))/i
        ],
        [[MODEL, "Xperia Tablet"], [VENDOR, SONY], [TYPE, TABLET]],
        [
          // OnePlus
          / (kb2005|in20[12]5|be20[12][59])\b/i,
          /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
        ],
        [MODEL, [VENDOR, "OnePlus"], [TYPE, MOBILE]],
        [
          // Amazon
          /(alexa)webm/i,
          /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,
          // Kindle Fire without Silk / Echo Show
          /(kf[a-z]+)( bui|\)).+silk\//i
          // Kindle Fire HD
        ],
        [MODEL, [VENDOR, AMAZON], [TYPE, TABLET]],
        [
          /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
          // Fire Phone
        ],
        [[MODEL, /(.+)/g, "Fire Phone $1"], [VENDOR, AMAZON], [TYPE, MOBILE]],
        [
          // BlackBerry
          /(playbook);[-\w\),; ]+(rim)/i
          // BlackBerry PlayBook
        ],
        [MODEL, VENDOR, [TYPE, TABLET]],
        [
          /\b((?:bb[a-f]|st[hv])100-\d)/i,
          /\(bb10; (\w+)/i
          // BlackBerry 10
        ],
        [MODEL, [VENDOR, BLACKBERRY], [TYPE, MOBILE]],
        [
          // Asus
          /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
        ],
        [MODEL, [VENDOR, ASUS], [TYPE, TABLET]],
        [
          / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
        ],
        [MODEL, [VENDOR, ASUS], [TYPE, MOBILE]],
        [
          // HTC
          /(nexus 9)/i
          // HTC Nexus 9
        ],
        [MODEL, [VENDOR, "HTC"], [TYPE, TABLET]],
        [
          /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
          // HTC
          // ZTE
          /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
          /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
          // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
        ],
        [VENDOR, [MODEL, /_/g, " "], [TYPE, MOBILE]],
        [
          // Acer
          /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
        ],
        [MODEL, [VENDOR, "Acer"], [TYPE, TABLET]],
        [
          // Meizu
          /droid.+; (m[1-5] note) bui/i,
          /\bmz-([-\w]{2,})/i
        ],
        [MODEL, [VENDOR, "Meizu"], [TYPE, MOBILE]],
        [
          // Ulefone
          /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
        ],
        [MODEL, [VENDOR, "Ulefone"], [TYPE, MOBILE]],
        [
          // MIXED
          /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,
          // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
          /(hp) ([\w ]+\w)/i,
          // HP iPAQ
          /(asus)-?(\w+)/i,
          // Asus
          /(microsoft); (lumia[\w ]+)/i,
          // Microsoft Lumia
          /(lenovo)[-_ ]?([-\w]+)/i,
          // Lenovo
          /(jolla)/i,
          // Jolla
          /(oppo) ?([\w ]+) bui/i
          // OPPO
        ],
        [VENDOR, MODEL, [TYPE, MOBILE]],
        [
          /(kobo)\s(ereader|touch)/i,
          // Kobo
          /(archos) (gamepad2?)/i,
          // Archos
          /(hp).+(touchpad(?!.+tablet)|tablet)/i,
          // HP TouchPad
          /(kindle)\/([\w\.]+)/i,
          // Kindle
          /(nook)[\w ]+build\/(\w+)/i,
          // Nook
          /(dell) (strea[kpr\d ]*[\dko])/i,
          // Dell Streak
          /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
          // Le Pan Tablets
          /(trinity)[- ]*(t\d{3}) bui/i,
          // Trinity Tablets
          /(gigaset)[- ]+(q\w{1,9}) bui/i,
          // Gigaset Tablets
          /(vodafone) ([\w ]+)(?:\)| bui)/i
          // Vodafone
        ],
        [VENDOR, MODEL, [TYPE, TABLET]],
        [
          /(surface duo)/i
          // Surface Duo
        ],
        [MODEL, [VENDOR, MICROSOFT], [TYPE, TABLET]],
        [
          /droid [\d\.]+; (fp\du?)(?: b|\))/i
          // Fairphone
        ],
        [MODEL, [VENDOR, "Fairphone"], [TYPE, MOBILE]],
        [
          /(u304aa)/i
          // AT&T
        ],
        [MODEL, [VENDOR, "AT&T"], [TYPE, MOBILE]],
        [
          /\bsie-(\w*)/i
          // Siemens
        ],
        [MODEL, [VENDOR, "Siemens"], [TYPE, MOBILE]],
        [
          /\b(rct\w+) b/i
          // RCA Tablets
        ],
        [MODEL, [VENDOR, "RCA"], [TYPE, TABLET]],
        [
          /\b(venue[\d ]{2,7}) b/i
          // Dell Venue Tablets
        ],
        [MODEL, [VENDOR, "Dell"], [TYPE, TABLET]],
        [
          /\b(q(?:mv|ta)\w+) b/i
          // Verizon Tablet
        ],
        [MODEL, [VENDOR, "Verizon"], [TYPE, TABLET]],
        [
          /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
          // Barnes & Noble Tablet
        ],
        [MODEL, [VENDOR, "Barnes & Noble"], [TYPE, TABLET]],
        [
          /\b(tm\d{3}\w+) b/i
        ],
        [MODEL, [VENDOR, "NuVision"], [TYPE, TABLET]],
        [
          /\b(k88) b/i
          // ZTE K Series Tablet
        ],
        [MODEL, [VENDOR, "ZTE"], [TYPE, TABLET]],
        [
          /\b(nx\d{3}j) b/i
          // ZTE Nubia
        ],
        [MODEL, [VENDOR, "ZTE"], [TYPE, MOBILE]],
        [
          /\b(gen\d{3}) b.+49h/i
          // Swiss GEN Mobile
        ],
        [MODEL, [VENDOR, "Swiss"], [TYPE, MOBILE]],
        [
          /\b(zur\d{3}) b/i
          // Swiss ZUR Tablet
        ],
        [MODEL, [VENDOR, "Swiss"], [TYPE, TABLET]],
        [
          /\b((zeki)?tb.*\b) b/i
          // Zeki Tablets
        ],
        [MODEL, [VENDOR, "Zeki"], [TYPE, TABLET]],
        [
          /\b([yr]\d{2}) b/i,
          /\b(dragon[- ]+touch |dt)(\w{5}) b/i
          // Dragon Touch Tablet
        ],
        [[VENDOR, "Dragon Touch"], MODEL, [TYPE, TABLET]],
        [
          /\b(ns-?\w{0,9}) b/i
          // Insignia Tablets
        ],
        [MODEL, [VENDOR, "Insignia"], [TYPE, TABLET]],
        [
          /\b((nxa|next)-?\w{0,9}) b/i
          // NextBook Tablets
        ],
        [MODEL, [VENDOR, "NextBook"], [TYPE, TABLET]],
        [
          /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
          // Voice Xtreme Phones
        ],
        [[VENDOR, "Voice"], MODEL, [TYPE, MOBILE]],
        [
          /\b(lvtel\-)?(v1[12]) b/i
          // LvTel Phones
        ],
        [[VENDOR, "LvTel"], MODEL, [TYPE, MOBILE]],
        [
          /\b(ph-1) /i
          // Essential PH-1
        ],
        [MODEL, [VENDOR, "Essential"], [TYPE, MOBILE]],
        [
          /\b(v(100md|700na|7011|917g).*\b) b/i
          // Envizen Tablets
        ],
        [MODEL, [VENDOR, "Envizen"], [TYPE, TABLET]],
        [
          /\b(trio[-\w\. ]+) b/i
          // MachSpeed Tablets
        ],
        [MODEL, [VENDOR, "MachSpeed"], [TYPE, TABLET]],
        [
          /\btu_(1491) b/i
          // Rotor Tablets
        ],
        [MODEL, [VENDOR, "Rotor"], [TYPE, TABLET]],
        [
          /(shield[\w ]+) b/i
          // Nvidia Shield Tablets
        ],
        [MODEL, [VENDOR, "Nvidia"], [TYPE, TABLET]],
        [
          /(sprint) (\w+)/i
          // Sprint Phones
        ],
        [VENDOR, MODEL, [TYPE, MOBILE]],
        [
          /(kin\.[onetw]{3})/i
          // Microsoft Kin
        ],
        [[MODEL, /\./g, " "], [VENDOR, MICROSOFT], [TYPE, MOBILE]],
        [
          /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
          // Zebra
        ],
        [MODEL, [VENDOR, ZEBRA], [TYPE, TABLET]],
        [
          /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
        ],
        [MODEL, [VENDOR, ZEBRA], [TYPE, MOBILE]],
        [
          ///////////////////
          // SMARTTVS
          ///////////////////
          /smart-tv.+(samsung)/i
          // Samsung
        ],
        [VENDOR, [TYPE, SMARTTV]],
        [
          /hbbtv.+maple;(\d+)/i
        ],
        [[MODEL, /^/, "SmartTV"], [VENDOR, SAMSUNG], [TYPE, SMARTTV]],
        [
          /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
          // LG SmartTV
        ],
        [[VENDOR, LG], [TYPE, SMARTTV]],
        [
          /(apple) ?tv/i
          // Apple TV
        ],
        [VENDOR, [MODEL, APPLE + " TV"], [TYPE, SMARTTV]],
        [
          /crkey/i
          // Google Chromecast
        ],
        [[MODEL, CHROME + "cast"], [VENDOR, GOOGLE], [TYPE, SMARTTV]],
        [
          /droid.+aft(\w+)( bui|\))/i
          // Fire TV
        ],
        [MODEL, [VENDOR, AMAZON], [TYPE, SMARTTV]],
        [
          /\(dtv[\);].+(aquos)/i,
          /(aquos-tv[\w ]+)\)/i
          // Sharp
        ],
        [MODEL, [VENDOR, SHARP], [TYPE, SMARTTV]],
        [
          /(bravia[\w ]+)( bui|\))/i
          // Sony
        ],
        [MODEL, [VENDOR, SONY], [TYPE, SMARTTV]],
        [
          /(mitv-\w{5}) bui/i
          // Xiaomi
        ],
        [MODEL, [VENDOR, XIAOMI], [TYPE, SMARTTV]],
        [
          /Hbbtv.*(technisat) (.*);/i
          // TechniSAT
        ],
        [VENDOR, MODEL, [TYPE, SMARTTV]],
        [
          /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
          // Roku
          /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
          // HbbTV devices
        ],
        [[VENDOR, trim2], [MODEL, trim2], [TYPE, SMARTTV]],
        [
          /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
          // SmartTV from Unidentified Vendors
        ],
        [[TYPE, SMARTTV]],
        [
          ///////////////////
          // CONSOLES
          ///////////////////
          /(ouya)/i,
          // Ouya
          /(nintendo) ([wids3utch]+)/i
          // Nintendo
        ],
        [VENDOR, MODEL, [TYPE, CONSOLE]],
        [
          /droid.+; (shield) bui/i
          // Nvidia
        ],
        [MODEL, [VENDOR, "Nvidia"], [TYPE, CONSOLE]],
        [
          /(playstation [345portablevi]+)/i
          // Playstation
        ],
        [MODEL, [VENDOR, SONY], [TYPE, CONSOLE]],
        [
          /\b(xbox(?: one)?(?!; xbox))[\); ]/i
          // Microsoft Xbox
        ],
        [MODEL, [VENDOR, MICROSOFT], [TYPE, CONSOLE]],
        [
          ///////////////////
          // WEARABLES
          ///////////////////
          /((pebble))app/i
          // Pebble
        ],
        [VENDOR, MODEL, [TYPE, WEARABLE]],
        [
          /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
          // Apple Watch
        ],
        [MODEL, [VENDOR, APPLE], [TYPE, WEARABLE]],
        [
          /droid.+; (glass) \d/i
          // Google Glass
        ],
        [MODEL, [VENDOR, GOOGLE], [TYPE, WEARABLE]],
        [
          /droid.+; (wt63?0{2,3})\)/i
        ],
        [MODEL, [VENDOR, ZEBRA], [TYPE, WEARABLE]],
        [
          /(quest( 2| pro)?)/i
          // Oculus Quest
        ],
        [MODEL, [VENDOR, FACEBOOK], [TYPE, WEARABLE]],
        [
          ///////////////////
          // EMBEDDED
          ///////////////////
          /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
          // Tesla
        ],
        [VENDOR, [TYPE, EMBEDDED]],
        [
          /(aeobc)\b/i
          // Echo Dot
        ],
        [MODEL, [VENDOR, AMAZON], [TYPE, EMBEDDED]],
        [
          ////////////////////
          // MIXED (GENERIC)
          ///////////////////
          /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i
          // Android Phones from Unidentified Vendors
        ],
        [MODEL, [TYPE, MOBILE]],
        [
          /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
          // Android Tablets from Unidentified Vendors
        ],
        [MODEL, [TYPE, TABLET]],
        [
          /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
          // Unidentifiable Tablet
        ],
        [[TYPE, TABLET]],
        [
          /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
          // Unidentifiable Mobile
        ],
        [[TYPE, MOBILE]],
        [
          /(android[-\w\. ]{0,9});.+buil/i
          // Generic Android Device
        ],
        [MODEL, [VENDOR, "Generic"]]
      ],
      engine: [
        [
          /windows.+ edge\/([\w\.]+)/i
          // EdgeHTML
        ],
        [VERSION2, [NAME, EDGE + "HTML"]],
        [
          /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
          // Blink
        ],
        [VERSION2, [NAME, "Blink"]],
        [
          /(presto)\/([\w\.]+)/i,
          // Presto
          /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
          // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
          /ekioh(flow)\/([\w\.]+)/i,
          // Flow
          /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
          // KHTML/Tasman/Links
          /(icab)[\/ ]([23]\.[\d\.]+)/i,
          // iCab
          /\b(libweb)/i
        ],
        [NAME, VERSION2],
        [
          /rv\:([\w\.]{1,9})\b.+(gecko)/i
          // Gecko
        ],
        [VERSION2, NAME]
      ],
      os: [
        [
          // Windows
          /microsoft (windows) (vista|xp)/i
          // Windows (iTunes)
        ],
        [NAME, VERSION2],
        [
          /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i
          // Windows Phone
        ],
        [NAME, [VERSION2, strMapper, windowsVersionMap]],
        [
          /windows nt 6\.2; (arm)/i,
          // Windows RT
          /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
          /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
        ],
        [[VERSION2, strMapper, windowsVersionMap], [NAME, "Windows"]],
        [
          // iOS/macOS
          /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
          // iOS
          /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
          /cfnetwork\/.+darwin/i
        ],
        [[VERSION2, /_/g, "."], [NAME, "iOS"]],
        [
          /(mac os x) ?([\w\. ]*)/i,
          /(macintosh|mac_powerpc\b)(?!.+haiku)/i
          // Mac OS
        ],
        [[NAME, MAC_OS], [VERSION2, /_/g, "."]],
        [
          // Mobile OSes
          /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
          // Android-x86/HarmonyOS
        ],
        [VERSION2, NAME],
        [
          // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
          /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
          /(blackberry)\w*\/([\w\.]*)/i,
          // Blackberry
          /(tizen|kaios)[\/ ]([\w\.]+)/i,
          // Tizen/KaiOS
          /\((series40);/i
          // Series 40
        ],
        [NAME, VERSION2],
        [
          /\(bb(10);/i
          // BlackBerry 10
        ],
        [VERSION2, [NAME, BLACKBERRY]],
        [
          /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i
          // Symbian
        ],
        [VERSION2, [NAME, "Symbian"]],
        [
          /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
          // Firefox OS
        ],
        [VERSION2, [NAME, FIREFOX + " OS"]],
        [
          /web0s;.+rt(tv)/i,
          /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
          // WebOS
        ],
        [VERSION2, [NAME, "webOS"]],
        [
          /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
          // watchOS
        ],
        [VERSION2, [NAME, "watchOS"]],
        [
          // Google Chromecast
          /crkey\/([\d\.]+)/i
          // Google Chromecast
        ],
        [VERSION2, [NAME, CHROME + "cast"]],
        [
          /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
          // Chromium OS
        ],
        [[NAME, CHROMIUM_OS], VERSION2],
        [
          // Smart TVs
          /panasonic;(viera)/i,
          // Panasonic Viera
          /(netrange)mmh/i,
          // Netrange
          /(nettv)\/(\d+\.[\w\.]+)/i,
          // NetTV
          // Console
          /(nintendo|playstation) ([wids345portablevuch]+)/i,
          // Nintendo/Playstation
          /(xbox); +xbox ([^\);]+)/i,
          // Microsoft Xbox (360, One, X, S, Series X, Series S)
          // Other
          /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
          // Joli/Palm
          /(mint)[\/\(\) ]?(\w*)/i,
          // Mint
          /(mageia|vectorlinux)[; ]/i,
          // Mageia/VectorLinux
          /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
          // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
          /(hurd|linux) ?([\w\.]*)/i,
          // Hurd/Linux
          /(gnu) ?([\w\.]*)/i,
          // GNU
          /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
          // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
          /(haiku) (\w+)/i
          // Haiku
        ],
        [NAME, VERSION2],
        [
          /(sunos) ?([\w\.\d]*)/i
          // Solaris
        ],
        [[NAME, "Solaris"], VERSION2],
        [
          /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
          // Solaris
          /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
          // AIX
          /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
          // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX/SerenityOS
          /(unix) ?([\w\.]*)/i
          // UNIX
        ],
        [NAME, VERSION2]
      ]
    };
    var UAParser = function(ua, extensions) {
      if (typeof ua === OBJ_TYPE) {
        extensions = ua;
        ua = undefined$1;
      }
      if (!(this instanceof UAParser)) {
        return new UAParser(ua, extensions).getResult();
      }
      var _navigator = typeof window2 !== UNDEF_TYPE && window2.navigator ? window2.navigator : undefined$1;
      var _ua = ua || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY);
      var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined$1;
      var _rgxmap = extensions ? extend2(regexes, extensions) : regexes;
      var _isSelfNav = _navigator && _navigator.userAgent == _ua;
      this.getBrowser = function() {
        var _browser = {};
        _browser[NAME] = undefined$1;
        _browser[VERSION2] = undefined$1;
        rgxMapper.call(_browser, _ua, _rgxmap.browser);
        _browser[MAJOR] = majorize(_browser[VERSION2]);
        if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) {
          _browser[NAME] = "Brave";
        }
        return _browser;
      };
      this.getCPU = function() {
        var _cpu = {};
        _cpu[ARCHITECTURE] = undefined$1;
        rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
        return _cpu;
      };
      this.getDevice = function() {
        var _device = {};
        _device[VENDOR] = undefined$1;
        _device[MODEL] = undefined$1;
        _device[TYPE] = undefined$1;
        rgxMapper.call(_device, _ua, _rgxmap.device);
        if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) {
          _device[TYPE] = MOBILE;
        }
        if (_isSelfNav && _device[MODEL] == "Macintosh" && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
          _device[MODEL] = "iPad";
          _device[TYPE] = TABLET;
        }
        return _device;
      };
      this.getEngine = function() {
        var _engine = {};
        _engine[NAME] = undefined$1;
        _engine[VERSION2] = undefined$1;
        rgxMapper.call(_engine, _ua, _rgxmap.engine);
        return _engine;
      };
      this.getOS = function() {
        var _os = {};
        _os[NAME] = undefined$1;
        _os[VERSION2] = undefined$1;
        rgxMapper.call(_os, _ua, _rgxmap.os);
        if (_isSelfNav && !_os[NAME] && _uach && _uach.platform != "Unknown") {
          _os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS);
        }
        return _os;
      };
      this.getResult = function() {
        return {
          ua: this.getUA(),
          browser: this.getBrowser(),
          engine: this.getEngine(),
          os: this.getOS(),
          device: this.getDevice(),
          cpu: this.getCPU()
        };
      };
      this.getUA = function() {
        return _ua;
      };
      this.setUA = function(ua2) {
        _ua = typeof ua2 === STR_TYPE && ua2.length > UA_MAX_LENGTH ? trim2(ua2, UA_MAX_LENGTH) : ua2;
        return this;
      };
      this.setUA(_ua);
      return this;
    };
    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = enumerize([NAME, VERSION2, MAJOR]);
    UAParser.CPU = enumerize([ARCHITECTURE]);
    UAParser.DEVICE = enumerize([MODEL, VENDOR, TYPE, CONSOLE, MOBILE, SMARTTV, TABLET, WEARABLE, EMBEDDED]);
    UAParser.ENGINE = UAParser.OS = enumerize([NAME, VERSION2]);
    {
      if (module.exports) {
        exports = module.exports = UAParser;
      }
      exports.UAParser = UAParser;
    }
    var $ = typeof window2 !== UNDEF_TYPE && (window2.jQuery || window2.Zepto);
    if ($ && !$.ua) {
      var parser = new UAParser();
      $.ua = parser.getResult();
      $.ua.get = function() {
        return parser.getUA();
      };
      $.ua.set = function(ua) {
        parser.setUA(ua);
        var result = parser.getResult();
        for (var prop in result) {
          $.ua[prop] = result[prop];
        }
      };
    }
  })(typeof window === "object" ? window : commonjsGlobal);
})(uaParser, uaParser.exports);
var uaParserExports = uaParser.exports;
class OrderError extends helpersExports.StringError {
}
class OrderRefundError extends helpersExports.StringError {
  constructor(slug, message, data, response) {
    super(slug, message);
    __publicField(this, "_isOrderRefundError", true);
    __publicField(this, "_refundData");
    __publicField(this, "_response");
    this._refundData = data || {};
    this._response = response;
  }
  static is(e) {
    return Object.prototype.hasOwnProperty.call(e, "_isOrderRefundError");
  }
  additionalFlatData() {
    try {
      return {
        ...this._refundData,
        ...marshalOrderError(this._response)
      };
    } catch (e) {
      return this._refundData;
    }
  }
  toSlug() {
    return {
      key: this.data,
      data: this.additionalFlatData()
    };
  }
}
function marshalOrderError(e) {
  if (e) {
    try {
      return {
        errors: e.data.errors.map((error) => error.reason).join("\n"),
        firstError: getOrderErrorSlug(e.data.errors)
      };
    } catch (_) {
    }
  }
  return {
    errors: "<unknown errors>",
    firstError: "order.errors.refund.unknown"
  };
}
function getOrderErrorSlug(errors) {
  for (const error of errors) {
    if (!error.reason) {
      continue;
    }
    switch (error.reason) {
      case "cannot execute refund for order, please enter IBAN information":
        return "order.errors.refund.iban";
      case "Order cannot be found":
        return "order.errors.refund.order_not_found";
      case "Cannot handle returns for order, it was never paid":
        return "order.errors.refund.never_paid";
      case "payment present more than once":
        return "order.errors.refund.payment_duplicate";
      case "ticket present more than once":
        return "order.errors.refund.ticket_duplicate";
      case "product present more than once":
        return "order.errors.refund.product_duplicate";
      case "product not found":
        return "order.errors.refund.product_not_found";
      case "ticket not found":
        return "order.errors.refund.ticket_not_found";
      case "payment not found":
        return "order.errors.refund.payment_not_found";
      case "Arbitrary return larger than sum of item values":
        return "order.errors.refund.arbitrary_larger_than_sum";
    }
  }
  return "order.errors.refund.unknown";
}
class OrderRefundItemError extends helpersExports.BaseError {
  constructor() {
    super(...arguments);
    __publicField(this, "_level", helpersExports.LevelNumber.Debug);
  }
  toSlug() {
    return {
      data: {
        name: this.data.name
      },
      key: "sdk.errors.not_refundable"
    };
  }
  toString() {
    return `Not refundable ${this.data.type} ${this.data.guid}`;
  }
  additionalFlatData() {
    return this.data;
  }
}
function jsonStringify(value, or) {
  try {
    return JSON.stringify(value);
  } catch (e) {
    return or;
  }
}
class OrderRefundMessage extends helpersExports.BaseError {
  constructor(slug, data) {
    super(data);
    __publicField(this, "_level", helpersExports.LevelNumber.Debug);
    __publicField(this, "_slug");
    this._slug = slug;
  }
  toSlug() {
    return {
      key: this._slug
    };
  }
  toString() {
    return `Refund debug message: ${this.toSlug().key}`;
  }
  additionalFlatData() {
    const flatData = {
      donatePercentage: jsonStringify(this.data.donatePercentage, "NaN"),
      items: jsonStringify(this.data.items, "[]"),
      refundSetting: jsonStringify(this.data.refundSetting, "null"),
      toVoucher: jsonStringify(this.data.toVoucher, "null")
    };
    if (this.data.refundOrderId) {
      flatData.refundOrderId = this.data.refundOrderId;
    }
    if (this.data.refundAmount) {
      flatData.refundAmount = jsonStringify(this.data.refundAmount, "NaN");
    }
    if (this.data.refundRedirectUrl) {
      flatData.refundRedirectUrl = this.data.refundRedirectUrl;
    }
    return flatData;
  }
}
class UnknownOrderError extends OrderError {
  constructor(slug, message, error) {
    super(slug, message);
    __publicField(this, "_error");
    this._error = error;
  }
  additionalFlatData() {
    if (!this._error) {
      return {
        error: "Unknown"
      };
    }
    try {
      const data = {
        error: JSON.stringify({
          ...this._error
        }),
        errorMessage: this._error.message,
        errorName: this._error.name
      };
      if (this._error.stack) {
        data.errorStack = this._error.stack;
      }
      const { response } = this._error;
      if (response && response.data) {
        data.responseData = JSON.stringify(response.data);
      }
      return data;
    } catch (e) {
      if (e instanceof Error) {
        return { error: "Unknown", jsonError: `${e.name}: ${e.message}` };
      }
      return { error: "Unknown", jsonError: "Unknown" };
    }
  }
}
let adsBlockedPromise;
async function adsBlocked() {
  if (adsBlockedPromise) {
    return adsBlockedPromise;
  }
  if (!window || !window.fetch) {
    return true;
  }
  adsBlockedPromise = window.fetch("https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js", {
    method: "HEAD",
    mode: "no-cors",
    credentials: "omit",
    referrerPolicy: "no-referrer",
    cache: "no-store"
  }).then(() => false).catch(() => true);
  return adsBlockedPromise;
}
function guessTimezone() {
  try {
    const zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (zone && zone.length > 3) {
      return zone;
    }
  } catch (e) {
  }
  return void 0;
}
function parseQuery() {
  if (!document || !document.location || !document.location.search) {
    return {};
  }
  const searchParams = new URLSearchParams(document.location.search);
  const map = {};
  for (const [key, value] of searchParams) {
    if (Object.prototype.hasOwnProperty.call(map, key)) {
      map[key] = [].concat(map[key], value);
    } else {
      map[key] = value;
    }
  }
  return map;
}
async function handleRefund(config, options) {
  if (!config) {
    throw new OrderRefundError("order.errors.orderbuilder.refund.handle.config", "Failed to handle refund order: No config provided");
  }
  if (!config.httpClient || !config.httpClient.post) {
    throw new OrderRefundError("order.errors.orderbuilder.refund.handle.config", "Failed to handle refund order: No valid http client provided");
  }
  if (!config.baseUrl) {
    throw new OrderRefundError("order.errors.orderbuilder.refund.handle.config", "Failed to handle refund order: No valid base URL provided");
  }
  const logData = {
    baseUrl: config.baseUrl
  };
  if (!config.shopId) {
    throw new OrderRefundError("order.errors.orderbuilder.refund.handle.config", "Failed to handle refund order: No valid shop ID provided", logData);
  }
  logData.shopId = config.shopId;
  if (!options) {
    throw new OrderRefundError("order.errors.orderbuilder.refund.handle.options", "Failed to handle refund order: No options provided", logData);
  }
  if (!options.booker || !options.booker.email || !options.booker.firstname || !options.booker.lastname || !options.booker.locale) {
    throw new OrderRefundError("order.errors.orderbuilder.refund.handle.bookerinfo", "Failed to handle refund order: No valid bookerinfo provided", logData);
  }
  try {
    logData.booker = JSON.stringify(options.booker);
  } catch (e) {
    logData.booker = "<invalid json>";
  }
  if (!options.orderId) {
    throw new OrderRefundError("order.errors.orderbuilder.refund.handle.orderid", "Failed to handle refund order: No valid order ID provided", logData);
  }
  logData.orderId = options.orderId;
  if (!options.items || !options.items.length) {
    throw new OrderRefundError("order.errors.orderbuilder.refund.handle.items", "Failed to handle refund order: No valid return items provided", logData);
  }
  try {
    logData.items = JSON.stringify(options.items);
  } catch (e) {
    logData.items = "<invalid json>";
  }
  if (!options.paymentMethod || !options.paymentMethod.guid || !options.paymentMethod.currency) {
    throw new OrderRefundError("order.errors.orderbuilder.refund.handle.paymentmethod", "Failed to handle refund order: No valid payment method provided", logData);
  }
  try {
    logData.booker = JSON.stringify(options.paymentMethod);
  } catch (e) {
    logData.booker = "<invalid json>";
  }
  if (!options.reason) {
    throw new OrderRefundError("order.errors.orderbuilder.refund.handle.reason", "Failed to handle refund order: No valid reason provided", logData);
  }
  logData.reason = options.reason;
  const returnsOrderData = {
    includes_fees: options.includesFees,
    items: options.items,
    order_id: options.orderId,
    reason: options.reason,
    to_voucher: options.toVoucher
  };
  if (options.donatePercentage && options.donatePercentage > 0) {
    returnsOrderData.arbitrary = {
      percentage: options.donatePercentage,
      // A gift is by default 0 vat.
      // However, this might not be true for all countries!!!
      // We do not have this notion right now though...
      vat: 0
    };
  }
  const orderData = {
    receiver: {
      email: options.booker.email,
      firstname: options.booker.firstname,
      lastname: options.booker.lastname,
      locale: options.booker.locale
    },
    return: returnsOrderData,
    paymentProvider: options.paymentMethod.guid,
    currency: options.paymentMethod.currency,
    extraMetaData: {
      ...await getTechData(options.initAt),
      originalOrderId: options.orderId
    }
  };
  const url = config.getNoCacheUrl(urlJoin(config.baseUrl, config.shopId, "order"));
  try {
    const response = await config.httpClient.post(url, orderData);
    return response.data;
  } catch (error) {
    if (isResponseError(error) && error.response.status >= 400 && error.response.status < 500) {
      throw new OrderRefundError("order.errors.orderbuilder.refund.handle.failed", "Failed to send refund order", logData, error.response);
    } else if (error instanceof Error) {
      error.refundData = logData;
      throw new UnknownOrderError("order.errors.orderbuilder.refund.handle.fatal", "Failed to send refund order", error);
    } else {
      throw new OrderRefundError("order.errors.orderbuilder.refund.handle.fatal", "Failed to send refund order", logData);
    }
  }
}
async function getTechData(initAt) {
  const dppx = +(window ? window.devicePixelRatio : 0);
  const dpi = dppx * 96;
  const uaParser2 = new uaParserExports.UAParser();
  const adblock = await adsBlocked();
  return {
    adblock,
    cookieEnabled: navigator.cookieEnabled,
    doNotTrack: !!navigator.doNotTrack,
    queryParams: parseQuery(),
    referrer: document.referrer,
    screen: {
      dpcm: dpi / 2.54,
      dpi,
      dppx,
      height: window.screen.height,
      orientation: {
        angle: window.screen && window.screen.orientation && window.screen.orientation.angle || null,
        type: window.screen && window.screen.orientation && window.screen.orientation.type || null
      },
      width: window.screen.width
    },
    seatsioHoldToken: null,
    timeToBank: Math.ceil(((/* @__PURE__ */ new Date()).getTime() - initAt.getTime()) / 1e3),
    timezone: guessTimezone() || null,
    userAgent: uaParser2.getResult()
  };
}
function isResponseError(error) {
  if (!error || !Object.prototype.hasOwnProperty.call(error, "response")) {
    return false;
  }
  if (!Object.prototype.hasOwnProperty.call(error.response, "status") || !Object.prototype.hasOwnProperty.call(error.response, "data") || !Object.prototype.hasOwnProperty.call(error.response.data, "errors") || !Array.isArray(error.response.data.errors)) {
    return false;
  }
  for (const errorElement of error.response.data.errors) {
    if (!Object.prototype.hasOwnProperty.call(errorElement, "reason")) {
      return false;
    }
  }
  return true;
}
class Validator {
  constructor(validatorFn) {
    __publicField(this, "_validatorFn");
    this._validatorFn = validatorFn;
  }
  metadata(metadata, mutateErrors) {
    const validationErrors = this._validatorFn(metadata, mutateErrors);
    return {
      valid: !validationErrors.length,
      message: validationErrors[0] || "",
      errors: validationErrors
    };
  }
}
function castDateAsIs(value) {
  if (!value) {
    return null;
  }
  if (Object.prototype.toString.call(value) === "[object Date]") {
    return value;
  }
  if (typeof value !== "string") {
    return null;
  }
  const parsed = Date.parse(value);
  if (Number.isNaN(parsed)) {
    return null;
  }
  const date = new Date(value);
  const year = parseInt(value.substring(0, 4), 10);
  const month = parseInt(value.substring(5, 7), 10);
  const day = parseInt(value.substring(8, 10), 10);
  const hours = parseInt(value.substring(11, 13), 10);
  const minutes = parseInt(value.substring(14, 16), 10);
  const seconds = parseInt(value.substring(17, 19), 10);
  date.setFullYear(year, month - 1, day);
  date.setHours(hours, minutes, seconds);
  return date;
}
function toBoolean(value, defaultValue = false) {
  if (value === true || value === 1 || value === "1") {
    return true;
  }
  if (value === false || value === 0 || value === "0") {
    return false;
  }
  return defaultValue;
}
class ShopParser {
  /**
   * Normalizes shop and adds it to the map
   * @param apiShop
   * @private
   */
  static normalizeShop(apiShop) {
    if (!apiShop.guid) {
      throw new Error("Missing shop guid.");
    }
    this.shop_map[apiShop.guid] = {
      company_terms: apiShop.company_terms && typeof apiShop.company_terms === "string" ? apiShop.company_terms : "",
      currency: apiShop.currency && typeof apiShop.currency === "string" ? apiShop.currency : "",
      description: apiShop.description && typeof apiShop.description === "string" ? apiShop.description : "",
      email_must_be_unique: toBoolean(apiShop.email_must_be_unique, false),
      email_validation_rule: apiShop.email_validation_rule && typeof apiShop.email_validation_rule === "string" ? apiShop.email_validation_rule : "",
      event_selection: apiShop.event_selection && typeof apiShop.event_selection === "string" ? apiShop.event_selection : "auto",
      facebook_auto_attend: toBoolean(apiShop.facebook_auto_attend, false),
      facebook_page_url: apiShop.facebook_page_url && typeof apiShop.facebook_page_url === "string" ? apiShop.facebook_page_url : "",
      global_terms: apiShop.global_terms && typeof apiShop.global_terms === "string" ? apiShop.global_terms : "",
      google_tag: apiShop.google_tag && typeof apiShop.google_tag === "string" ? apiShop.google_tag : "",
      greedy_date_selection: toBoolean(apiShop.greedy_date_selection, false),
      guid: apiShop.guid && typeof apiShop.guid === "string" ? apiShop.guid : "",
      name: apiShop.name && typeof apiShop.name === "string" ? apiShop.name : "",
      reservation_time: apiShop.reservation_time && typeof apiShop.reservation_time === "number" ? apiShop.reservation_time : 0,
      seats_allow_orphan: toBoolean(apiShop.seats_allow_orphan, false),
      seats_public_key: apiShop.seats_public_key && typeof apiShop.seats_public_key === "string" ? apiShop.seats_public_key : ""
    };
    return this.shop_map[apiShop.guid];
  }
}
__publicField(ShopParser, "shop_map", {});
class MissingGuidError extends helpersExports.BaseError {
  constructor() {
    super(...arguments);
    __publicField(this, "_level", helpersExports.LevelNumber.Warning);
  }
  toSlug() {
    return {
      data: {
        name: this.data.elementName
      },
      key: "order.error.missing.guid"
    };
  }
  toString() {
    return `Element ${this.data.elementName} is missing guid in API data.`;
  }
  additionalFlatData() {
    return {
      ...this.data,
      receivedData: JSON.stringify(this.data.receivedData)
    };
  }
}
class EventsParser {
  /**
   * Normalizes event dates and adds them to the event date map
   * @private
   * @param apiEventDates
   */
  static normalizeEventDates(apiEventDates) {
    const event_dates = [];
    apiEventDates.forEach((event_date) => {
      if (!event_date.guid) {
        console.warn(new MissingGuidError({ elementName: "event_date", receivedData: event_date }));
        return;
      }
      const event_date_event = this.normalizeEvent(event_date.event ? event_date.event : {});
      const location = {
        address: event_date.location && event_date.location.address && typeof event_date.location.address === "string" ? event_date.location.address : "",
        capacity: event_date.location && event_date.location.capacity && typeof event_date.location.capacity === "string" ? event_date.location.capacity : 0,
        company_id: event_date.location && event_date.location.company_id && typeof event_date.location.company_id === "string" ? event_date.location.company_id : "",
        created_at: event_date.location && event_date.location.created_at && typeof event_date.location.created_at === "string" ? event_date.location.created_at : "",
        description: event_date.location && event_date.location.description && typeof event_date.location.description === "string" ? event_date.location.description : "",
        guid: event_date.location && event_date.location.guid && typeof event_date.location.guid === "string" ? event_date.location.guid : "",
        latitude: event_date.location && event_date.location.latitude && typeof event_date.location.latitude === "number" ? event_date.location.latitude : 0,
        longitude: event_date.location && event_date.location.longitude && typeof event_date.location.longitude === "number" ? event_date.location.longitude : 0,
        name: event_date.location && event_date.location.name && typeof event_date.location.name === "string" ? event_date.location.name : "",
        public: !!event_date.location && toBoolean(event_date.location.public, false),
        seated: !!event_date.location && toBoolean(event_date.location.seated, false),
        seats_chart_key: event_date.location && event_date.location.seats_chart_key && typeof event_date.location.seats_chart_key === "string" ? event_date.location.seats_chart_key : "",
        updated_at: event_date.location && event_date.location.updated_at && typeof event_date.location.updated_at === "string" ? event_date.location.updated_at : ""
      };
      if (event_date.location && event_date.location.guid) {
        this.location_map[event_date.location.guid] = location;
      }
      this.event_date_map[event_date.guid] = {
        company_id: event_date.company_id && typeof event_date.company_id === "string" ? event_date.company_id : "",
        end: event_date.end && typeof event_date.end === "string" ? castDateAsIs(event_date.end) : null,
        event: event_date_event,
        event_id: event_date.event_id && typeof event_date.event_id === "string" ? event_date.event_id : "",
        facebook_event_id: event_date.facebook_event_id && typeof event_date.facebook_event_id === "string" ? event_date.facebook_event_id : "",
        guid: event_date.guid && typeof event_date.guid === "string" ? event_date.guid : "",
        location,
        name: event_date.name && typeof event_date.name === "string" ? event_date.name : "",
        seated: toBoolean(event_date.seated, false),
        seats_event_key: event_date.seats_event_key && typeof event_date.seats_event_key === "string" ? event_date.seats_event_key : "",
        start: event_date.start && typeof event_date.start === "string" ? castDateAsIs(event_date.start) : null
      };
      event_dates.push(this.event_date_map[event_date.guid]);
    });
    return event_dates;
  }
  /**
   * Normalizes a event including the location, and adds them to the event and location map
   * @param apiEvent
   * @private
   */
  static normalizeEvent(apiEvent) {
    if (!apiEvent.guid) {
      console.warn(new MissingGuidError({ elementName: "event", receivedData: apiEvent }));
    }
    const location = {
      address: apiEvent.location && apiEvent.location.address && typeof apiEvent.location.address === "string" ? apiEvent.location.address : "",
      capacity: apiEvent.location && apiEvent.location.capacity && typeof apiEvent.location.capacity === "number" ? apiEvent.location.capacity : 0,
      company_id: apiEvent.location && apiEvent.location.company_id && typeof apiEvent.location.company_id === "string" ? apiEvent.location.company_id : "",
      created_at: apiEvent.location && apiEvent.location.created_at && typeof apiEvent.location.created_at === "string" ? apiEvent.location.created_at : "",
      description: apiEvent.location && apiEvent.location.description && typeof apiEvent.location.description === "string" ? apiEvent.location.description : "",
      guid: apiEvent.location && apiEvent.location.guid && typeof apiEvent.location.guid === "string" ? apiEvent.location.guid : "",
      latitude: apiEvent.location && apiEvent.location.latitude && typeof apiEvent.location.latitude === "number" ? apiEvent.location.latitude : 0,
      longitude: apiEvent.location && apiEvent.location.longitude && typeof apiEvent.location.longitude === "number" ? apiEvent.location.longitude : 0,
      name: apiEvent.location && apiEvent.location.name && typeof apiEvent.location.name === "string" ? apiEvent.location.name : "",
      public: !!apiEvent.location && toBoolean(apiEvent.location.public, false),
      seated: !!apiEvent.location && toBoolean(apiEvent.location.seated, false),
      seats_chart_key: apiEvent.location && apiEvent.location.seats_chart_key && typeof apiEvent.location.seats_chart_key === "string" ? apiEvent.location.seats_chart_key : "",
      updated_at: apiEvent.location && apiEvent.location.updated_at && typeof apiEvent.location.updated_at === "string" ? apiEvent.location.updated_at : ""
    };
    if (apiEvent.location && apiEvent.location.guid) {
      this.location_map[apiEvent.location.guid] = location;
    }
    const event = {
      company_id: apiEvent.company_id && typeof apiEvent.company_id === "string" ? apiEvent.company_id : "",
      currency: apiEvent.currency && typeof apiEvent.currency === "string" ? apiEvent.currency : "",
      description: apiEvent.description && typeof apiEvent.description === "string" ? apiEvent.description : "",
      email_info: apiEvent.email_info && typeof apiEvent.email_info === "string" ? apiEvent.email_info : "",
      end: apiEvent.end && typeof apiEvent.end === "string" ? castDateAsIs(apiEvent.end) : null,
      guid: apiEvent.guid && typeof apiEvent.guid === "string" ? apiEvent.guid : "",
      locale: apiEvent.locale && typeof apiEvent.locale === "string" ? apiEvent.locale : "",
      location,
      location_id: apiEvent.location_id && typeof apiEvent.location_id === "string" ? apiEvent.location_id : "",
      name: apiEvent.name && typeof apiEvent.name === "string" ? apiEvent.name : "",
      payout_profile: apiEvent.payout_profile ? apiEvent.payout_profile : null,
      products: [],
      refund_setting: apiEvent.refund_setting ? apiEvent.refund_setting : null,
      retrievable_after: apiEvent.retrievable_after && typeof apiEvent.retrievable_after === "string" ? apiEvent.retrievable_after : null,
      start: apiEvent.start && typeof apiEvent.start === "string" ? castDateAsIs(apiEvent.start) : null,
      status: apiEvent.status && typeof apiEvent.status === "string" ? apiEvent.status : "normal",
      status_until: apiEvent.status_until && typeof apiEvent.status_until === "string" ? apiEvent.status_until : "",
      tickets: [],
      visitor_contact_email: apiEvent.visitor_contact_email && typeof apiEvent.visitor_contact_email === "string" ? apiEvent.visitor_contact_email : "",
      visitor_contact_phone: apiEvent.visitor_contact_phone && typeof apiEvent.visitor_contact_phone === "string" ? apiEvent.visitor_contact_phone : "",
      visitor_contact_url: apiEvent.visitor_contact_url && typeof apiEvent.visitor_contact_url === "string" ? apiEvent.visitor_contact_url : "",
      website: apiEvent.website && typeof apiEvent.website === "string" ? apiEvent.website : ""
    };
    if (apiEvent.guid) {
      this.event_map[apiEvent.guid] = event;
    }
    return event;
  }
}
__publicField(EventsParser, "event_map", {});
__publicField(EventsParser, "location_map", {});
__publicField(EventsParser, "event_date_map", {});
class MetaDataParser {
  /**
   * Normalizes the metadata and it's nested metadata
   * @param apiMetaData
   * @private
   */
  static normalizeMetaData(apiMetaData) {
    const metadata = [];
    apiMetaData.forEach((data, i) => {
      let options;
      let extra = [];
      if (!data.guid) {
        console.warn(new MissingGuidError({ elementName: "metadata", receivedData: data }));
        return;
      }
      if (!data.metadata) {
        console.warn(`orderMetadata ${data.guid} has no metadata`);
        return;
      }
      if (data.metadata.extra) {
        const typedItem = data.metadata;
        typedItem.extra = Array.isArray(data.metadata.extra) ? data.metadata.extra : data.metadata.extra.split("|");
        if (typedItem.type === "enum" || typedItem.type === "enumOther" || typedItem.type === "values") {
          const rule = typedItem.extra.find((r) => r.includes("in:"));
          options = rule ? rule.split(":").slice(1).join(":").split(",") : [];
        }
        extra = typedItem.extra;
      }
      const nestedMetadata = {
        auto_fill_facebook: data.metadata.auto_fill_facebook && typeof data.metadata.auto_fill_facebook === "string" ? data.metadata.auto_fill_facebook : "none",
        copy_on_swap: toBoolean(data.metadata.copy_on_swap, true),
        extra,
        guid: data.metadata.guid && typeof data.metadata.guid === "string" ? data.metadata.guid : "",
        name: data.metadata.name && typeof data.metadata.name === "string" ? data.metadata.name : "",
        options,
        shop_description: data.metadata.shop_description && typeof data.metadata.shop_description === "string" ? data.metadata.shop_description : "",
        translatable: toBoolean(data.metadata.translatable, false),
        translateName: data.metadata.translateName && typeof data.metadata.translateName === "string" ? data.metadata.translateName : "",
        type: data.metadata.type && typeof data.metadata.type === "string" ? data.metadata.type : "string"
      };
      this.metadata_map[data.guid] = {
        errors: [],
        guid: data.guid,
        index: i,
        is_complete: toBoolean(data.is_complete, false),
        is_required: toBoolean(data.is_required, false),
        item: nestedMetadata,
        metadata: nestedMetadata,
        metadata_id: data.metadata_id && typeof data.metadata_id === "string" ? data.metadata_id : "",
        order_id: data.order_id && typeof data.order_id === "string" ? data.order_id : "",
        value: extra.includes("numeric") && data.value === "" ? null : data.value
      };
      metadata.push(this.metadata_map[data.guid]);
    });
    return metadata;
  }
}
__publicField(MetaDataParser, "metadata_map", {});
class ProductsParser {
  /**
   * Normalizes the products and adds them to the map
   * @param apiProducts
   * @private
   */
  static normalizeGlobalProducts(apiProducts) {
    const products = [];
    apiProducts.forEach((product) => {
      if (!product.guid) {
        console.warn(new MissingGuidError({ elementName: "product", receivedData: product }));
        return;
      }
      this.global_product_map[product.guid] = this._normalizeProduct(product);
      products.push(this.global_product_map[product.guid]);
    });
    return products;
  }
  /**
   * Normalizes products, similar to global products but with metadata coupon code and event dates
   * @param apiProducts
   */
  static normalizeProducts(apiProducts) {
    const products = [];
    apiProducts.forEach((product) => {
      if (!product.guid) {
        console.warn(new MissingGuidError({ elementName: "product", receivedData: product }));
        return;
      }
      const product_event_dates = product.product && product.product.event_dates ? EventsParser.normalizeEventDates(product.product.event_dates) : [];
      const product_metadata = product.metadata ? MetaDataParser.normalizeMetaData(product.metadata) : [];
      const normalizedProduct = this._normalizeProduct(product);
      this.product_map[product.guid] = {
        ...normalizedProduct,
        coupon_code: product.coupon_code ? product.coupon_code : null,
        metadata: product_metadata,
        product: {
          ...normalizedProduct.product,
          event_dates: product_event_dates
        }
      };
      products.push(this.product_map[product.guid]);
    });
    return products;
  }
  /**
   * Normalizes a single product to a IOrderGlobalProduct
   * @param product
   * @private
   */
  static _normalizeProduct(product) {
    return {
      coupon_code_id: product.coupon_code_id && typeof product.coupon_code_id === "string" ? product.coupon_code_id : null,
      finn_inner_value: product.finn_inner_value && typeof product.finn_inner_value === "number" ? product.finn_inner_value : 0,
      finn_original_price: product.finn_original_price && typeof product.finn_original_price === "number" ? product.finn_original_price : 0,
      finn_price: product.finn_price && typeof product.finn_price === "number" ? product.finn_price : 0,
      finn_service_fee: product.finn_service_fee && typeof product.finn_service_fee === "number" ? product.finn_service_fee : 0,
      finn_value: product.finn_value && typeof product.finn_value === "number" ? product.finn_value : 0,
      guid: product.guid && typeof product.guid === "string" ? product.guid : "",
      invalidated_reason: product.invalidated_reason && typeof product.invalidated_reason === "string" ? product.invalidated_reason : null,
      invalidated_since: product.invalidated_since && typeof product.invalidated_since === "string" ? product.invalidated_since : null,
      is_complete: toBoolean(product.is_complete, false),
      is_optional: toBoolean(product.is_optional, false),
      product: {
        class: product.product && product.product.class && typeof product.product.class === "string" ? product.product.class : null,
        company_id: product.product && product.product.company_id && typeof product.product.company_id === "string" ? product.product.company_id : "",
        description: product.product && product.product.description && typeof product.product.description === "string" ? product.product.description : "",
        event_id: product.product && product.product.event_id && typeof product.product.event_id === "string" ? product.product.event_id : "",
        extra_data: product.product && product.product.extra_data && typeof product.product.extra_data === "object" ? product.product.extra_data : [],
        guid: product.product && product.product.guid && typeof product.product.guid === "string" ? product.product.guid : "",
        name: product.product && product.product.name && typeof product.product.name === "string" ? product.product.name : "",
        origin_type: product.product && product.product.origin_type && typeof product.product.origin_type === "string" ? product.product.origin_type : "product",
        price: product.product && product.product.price && typeof product.price === "number" ? product.product.price : 0,
        pricing_method: product.product && product.product.pricing_method && typeof product.product.pricing_method === "string" ? product.product.pricing_method : "own",
        status: product.product && product.product.status && typeof product.product.status === "string" ? product.product.status : "available",
        vat_percentage: product.product && product.product.vat_percentage && typeof product.product.vat_percentage === "number" ? product.product.vat_percentage : 0
      },
      vat: product.vat && typeof product.vat === "number" ? product.vat : 0
    };
  }
}
__publicField(ProductsParser, "global_product_map", {});
__publicField(ProductsParser, "product_map", {});
class PaymentsParser {
  /**
   * Normalizes payments and adds them to the map
   * @param apiPayments
   * @private
   */
  static normalizePayments(apiPayments) {
    const payments = [];
    apiPayments.forEach((payment) => {
      if (!payment.guid) {
        console.warn(new MissingGuidError({ elementName: "payment", receivedData: payment }));
        return;
      }
      const payment_method = {
        guid: payment.payment_method && payment.payment_method.guid && typeof payment.payment_method.guid === "string" ? payment.payment_method.guid : "",
        name: payment.payment_method && payment.payment_method.name && typeof payment.payment_method.name === "string" ? payment.payment_method.name : ""
      };
      if (payment.payment_method && payment.payment_method.guid) {
        this.payment_method_map[payment.payment_method.guid] = payment_method;
      }
      this.payment_map[payment.guid] = {
        amount: payment.amount && typeof payment.amount === "number" ? payment.amount : 0,
        currency: payment.currency && typeof payment.currency === "string" ? payment.currency : "",
        description: payment.description && typeof payment.description === "string" ? payment.description : "",
        finn_price: payment.finn_price && typeof payment.finn_price === "number" ? payment.finn_price : 0,
        finn_service_fee: payment.finn_service_fee && typeof payment.finn_service_fee === "number" ? payment.finn_service_fee : 0,
        finn_value: payment.finn_value && typeof payment.finn_value === "number" ? payment.finn_value : 0,
        guid: payment.guid && typeof payment.guid === "string" ? payment.guid : "",
        payment_id: payment.payment_id && typeof payment.payment_id === "string" ? payment.payment_id : "",
        payment_method,
        payment_method_id: payment.payment_method_id && typeof payment.payment_method_id === "string" ? payment.payment_method_id : "",
        statii: payment.statii && typeof payment.payment_method_id === "object" ? payment.statii : [],
        status: payment.status && typeof payment.status === "string" ? payment.status : "unknown"
      };
      payments.push(this.payment_map[payment.guid]);
    });
    return payments;
  }
}
__publicField(PaymentsParser, "payment_map", {});
__publicField(PaymentsParser, "payment_method_map", {});
class TicketsParser {
  /**
   * Normalizes tickets and adds them to the ticket map
   * @param apiTickets
   * @private
   */
  static normalizeTickets(apiTickets) {
    const tickets = [];
    apiTickets.forEach((ticket) => {
      if (!ticket.guid) {
        console.warn(new MissingGuidError({ elementName: "ticket", receivedData: ticket }));
        return;
      }
      const ticket_products = ProductsParser.normalizeProducts(ticket.products ? ticket.products : []);
      if (ticket.ticket && ticket.ticket.event && ticket.ticket.event.payout_profile) {
        const { payout_profile } = ticket.ticket.event;
        this.payout_profile_map[payout_profile.guid] = {
          guid: payout_profile.guid && typeof payout_profile.guid === "string" ? payout_profile.guid : "",
          refund_donate_enabled: toBoolean(payout_profile.refund_donate_enabled, false),
          refund_donate_options: payout_profile.refund_donate_options && typeof payout_profile.refund_donate_options === "string" ? payout_profile.refund_donate_options : "",
          refund_fees: toBoolean(payout_profile.refund_fees, false),
          refund_message: payout_profile.refund_message && typeof payout_profile.refund_message === "string" ? payout_profile.refund_message : "",
          refund_transaction_fees: toBoolean(payout_profile.refund_transaction_fees, false),
          refundable_by_payment: toBoolean(payout_profile.refundable_by_payment, false),
          refundable_by_voucher: toBoolean(payout_profile.refundable_by_voucher, false),
          refundable_default: payout_profile.refundable_default && typeof payout_profile.refundable_default === "string" ? payout_profile.refundable_default : "payment",
          status_refundable_before: payout_profile.status_refundable_before && typeof payout_profile.status_refundable_before === "string" ? payout_profile.status_refundable_before : null,
          status_until: payout_profile.status_until && typeof payout_profile.status_until === "string" ? payout_profile.status_until : null,
          voucher_multiplier: payout_profile.voucher_multiplier && typeof payout_profile.voucher_multiplier === "number" ? payout_profile.voucher_multiplier : 0
        };
      }
      if (ticket.ticket && ticket.ticket.event && ticket.ticket.event.refund_setting) {
        const { refund_setting } = ticket.ticket.event;
        this.refund_setting_map[refund_setting.guid] = {
          guid: refund_setting.guid && typeof refund_setting.guid === "string" ? refund_setting.guid : "",
          refund_donate_enabled: toBoolean(refund_setting.refund_donate_enabled, false),
          refund_donate_options: refund_setting.refund_donate_options && typeof refund_setting.refund_donate_options === "string" ? refund_setting.refund_donate_options : "",
          refund_fees: toBoolean(refund_setting.refund_fees, false),
          refund_message: refund_setting.refund_message && typeof refund_setting.refund_message === "string" ? refund_setting.refund_message : "",
          refund_transaction_fees: toBoolean(refund_setting.refund_transaction_fees, false),
          refundable_by_payment: toBoolean(refund_setting.refundable_by_payment, false),
          refundable_by_voucher: toBoolean(refund_setting.refundable_by_voucher, false),
          refundable_default: refund_setting.refundable_default && typeof refund_setting.refundable_default === "string" ? refund_setting.refundable_default : "payment",
          status_refundable_before: refund_setting.status_refundable_before && typeof refund_setting.status_refundable_before === "string" ? refund_setting.status_refundable_before : null,
          status_until: refund_setting.status_until && typeof refund_setting.status_until === "string" ? refund_setting.status_until : null,
          voucher_multiplier: refund_setting.voucher_multiplier && typeof refund_setting.voucher_multiplier === "number" ? refund_setting.voucher_multiplier : 0
        };
      }
      const ticket_metadata = MetaDataParser.normalizeMetaData(ticket.metadata ? ticket.metadata : []);
      this.ticket_map[ticket.guid] = {
        computed_download_ready: false,
        created_at: ticket.created_at && typeof ticket.created_at === "string" ? ticket.created_at : "",
        download_link: ticket.download_link && typeof ticket.download_link === "string" ? ticket.download_link : "",
        finn_inner_value: ticket.finn_inner_value && typeof ticket.finn_inner_value === "number" ? ticket.finn_inner_value : 0,
        finn_original_price: ticket.finn_original_price && typeof ticket.finn_original_price === "number" ? ticket.finn_original_price : 0,
        finn_price: ticket.finn_price && typeof ticket.finn_price === "number" ? ticket.finn_price : 0,
        finn_service_fee: ticket.finn_service_fee && typeof ticket.finn_service_fee === "number" ? ticket.finn_service_fee : 0,
        finn_value: ticket.finn_value && typeof ticket.finn_value === "number" ? ticket.finn_value : 0,
        guid: ticket.guid && typeof ticket.guid === "string" ? ticket.guid : "",
        invalidated_reason: ticket.invalidated_reason && typeof ticket.invalidated_reason === "string" ? ticket.invalidated_reason : null,
        invalidated_since: ticket.invalidated_since && typeof ticket.invalidated_since === "string" ? ticket.invalidated_since : null,
        is_complete: toBoolean(ticket.is_complete),
        metadata: ticket_metadata,
        products: ticket_products,
        retrievable_after: ticket.retrievable_after && typeof ticket.retrievable_after === "number" ? ticket.retrievable_after : null,
        ticket: {
          availability_margin: ticket.ticket && ticket.ticket.availability_margin && typeof ticket.ticket.availability_margin === "number" ? ticket.ticket.availability_margin : 0,
          available_from: ticket.ticket && ticket.ticket.available_from && typeof ticket.ticket.available_from === "string" ? ticket.ticket.available_from : "",
          available_in_cashr: !!ticket.ticket && toBoolean(ticket.ticket.available_in_cashr, false),
          available_until: ticket.ticket && ticket.ticket.available_until && typeof ticket.ticket.available_until === "string" ? ticket.ticket.available_until : "",
          combines_products: !!ticket.ticket && toBoolean(ticket.ticket.combines_products, false),
          company_id: ticket.ticket && ticket.ticket.company_id && typeof ticket.ticket.company_id === "string" ? ticket.ticket.company_id : "",
          deleted_at: ticket.ticket && ticket.ticket.deleted_at && typeof ticket.ticket.deleted_at === "string" ? ticket.ticket.deleted_at : "",
          description: ticket.ticket && ticket.ticket.description && typeof ticket.ticket.description === "string" ? ticket.ticket.description : "",
          event: EventsParser.normalizeEvent(ticket.ticket && ticket.ticket.event ? ticket.ticket.event : {}),
          event_id: ticket.ticket && ticket.ticket.event_id && typeof ticket.ticket.event_id === "string" ? ticket.ticket.event_id : "",
          guid: ticket.ticket && ticket.ticket.guid && typeof ticket.ticket.guid === "string" ? ticket.ticket.guid : "",
          hide_without_coupon: !!ticket.ticket && toBoolean(ticket.ticket.hide_without_coupon, false),
          include_service_cost_in_price: !!ticket.ticket && toBoolean(ticket.ticket.include_service_cost_in_price, false),
          increment: ticket.ticket && ticket.ticket.increment && typeof ticket.ticket.increment === "number" ? ticket.ticket.increment : 0,
          late_personalization: !!ticket.ticket && toBoolean(ticket.ticket.late_personalization, false),
          max_orderable_amount_per_order: ticket.ticket && ticket.ticket.max_orderable_amount_per_order && typeof ticket.ticket.max_orderable_amount_per_order === "number" ? ticket.ticket.max_orderable_amount_per_order : 0,
          min_orderable_amount_per_order: ticket.ticket && ticket.ticket.min_orderable_amount_per_order && typeof ticket.ticket.min_orderable_amount_per_order === "number" ? ticket.ticket.min_orderable_amount_per_order : 0,
          min_price: ticket.ticket && ticket.ticket.min_price && typeof ticket.ticket.min_price === "number" ? ticket.ticket.min_price : null,
          name: ticket.ticket && ticket.ticket.name && typeof ticket.ticket.name === "string" ? ticket.ticket.name : "",
          seated: !!ticket.ticket && toBoolean(ticket.ticket.seated, false),
          seats_category_key: ticket.ticket && ticket.ticket.seats_category_key && typeof ticket.ticket.seats_category_key === "string" ? ticket.ticket.seats_category_key : "",
          status: ticket.ticket && ticket.ticket.status && typeof ticket.ticket.status === "string" ? ticket.ticket.status : "available",
          status_overrule: ticket.ticket && ticket.ticket.status_overrule && typeof ticket.ticket.status_overrule === "string" ? ticket.ticket.status_overrule : "auto",
          swappable: !!ticket.ticket && toBoolean(ticket.ticket.swappable, false),
          vat_percentage: ticket.ticket && ticket.ticket.vat_percentage && typeof ticket.ticket.vat_percentage === "number" ? ticket.ticket.vat_percentage : 0
        },
        ticket_number: ticket.ticket_number && typeof ticket.ticket_number === "string" ? ticket.ticket_number : ""
      };
      tickets.push(this.ticket_map[ticket.guid]);
    });
    return tickets;
  }
}
__publicField(TicketsParser, "ticket_map", {});
__publicField(TicketsParser, "payout_profile_map", {});
__publicField(TicketsParser, "refund_setting_map", {});
class OrderParser {
  /**
   * Parses the data from the API to be usable in the frontend
   */
  static parse(data) {
    return this._normalizeOrder(data);
  }
  /**
   * Normalizes the order and creates the maps
   */
  static _normalizeOrder(data) {
    if (!data.guid) {
      throw new Error("Missing order guid.");
    }
    const order_shop = ShopParser.normalizeShop(data.shop ? data.shop : {});
    const order_products = ProductsParser.normalizeGlobalProducts(data.products ? data.products : []);
    const order_payments = PaymentsParser.normalizePayments(data.payments ? data.payments : []);
    const order_tickets = TicketsParser.normalizeTickets(data.tickets ? data.tickets : []);
    const order_metadata = MetaDataParser.normalizeMetaData(data.metadata ? data.metadata : []);
    const order_events = this._buildEventRelations();
    return {
      amount: data.amount && typeof data.amount === "number" ? data.amount : 0,
      conversions: data.conversions ? data.conversions : {
        currency: "",
        total: 0,
        events: {}
      },
      created_at: data.created_at && typeof data.created_at === "string" ? data.created_at : "",
      download_link: data.download_link ? data.download_link : null,
      download_ready: data.download_ready && typeof data.download_ready === "boolean" ? data.download_ready : false,
      email: data.email && typeof data.email === "string" ? data.email : "",
      event_date_map: EventsParser.event_date_map,
      event_map: EventsParser.event_map,
      events: order_events,
      finn_original_price: data.finn_original_price && typeof data.finn_original_price === "number" ? data.finn_original_price : 0,
      finn_price: data.finn_price && typeof data.finn_price === "number" ? data.finn_price : 0,
      finn_service_fee: data.finn_service_fee && typeof data.finn_service_fee === "number" ? data.finn_service_fee : 0,
      finn_value: data.finn_value && typeof data.finn_value === "number" ? data.finn_value : 0,
      firstName: data.firstName && typeof data.firstName === "string" ? data.firstName : "",
      fullname: data.fullname && typeof data.fullname === "string" ? data.fullname : "",
      global_product_map: ProductsParser.global_product_map,
      global_products: order_products,
      guid: data.guid,
      has_receipt: data.has_receipt === "1" || data.has_receipt === true || data.has_receipt === 1,
      invalidated_reason: data.invalidated_reason && typeof data.invalidated_reason === "string" ? data.invalidated_reason : "",
      invalidated_since: data.invalidated_since && typeof data.invalidated_since === "string" ? data.invalidated_since : "",
      is_complete: data.is_complete === "1" || data.is_complete === true || data.is_complete === 1,
      is_seated: data.is_seated === "1" || data.is_seated === true || data.is_seated === 1,
      lastName: data.lastName && typeof data.lastName === "string" ? data.lastName : "",
      locale: data.locale && typeof data.locale === "string" ? data.locale : "",
      location_map: EventsParser.location_map,
      metadata: order_metadata,
      metadata_map: MetaDataParser.metadata_map,
      payment_map: PaymentsParser.payment_map,
      payment_method_map: PaymentsParser.payment_method_map,
      payments: order_payments,
      payout_profile_map: TicketsParser.payout_profile_map,
      pdf_rendered: data.pdf_rendered === "1" || data.pdf_rendered === true || data.pdf_rendered === 1,
      product_map: ProductsParser.product_map,
      purchase_channel: data.purchase_channel && typeof data.purchase_channel === "string" ? data.purchase_channel : null,
      receipt_link: data.receipt_link && typeof data.receipt_link === "string" ? data.receipt_link : "",
      refund_setting_map: TicketsParser.refund_setting_map,
      send_email: !!data.send_email,
      shop: order_shop,
      shop_id: data.shop_id && typeof data.shop_id === "string" ? data.shop_id : "",
      shop_map: ShopParser.shop_map,
      status: data.status && typeof data.status === "string" ? data.status : "cancelled",
      ticket_map: TicketsParser.ticket_map,
      tickets: order_tickets
    };
  }
  /**
   * Gets the ticket and product map and parses it into the event relation
   */
  static _buildEventRelations() {
    for (const item of Object.values(TicketsParser.ticket_map)) {
      const { event_id } = item.ticket;
      if (event_id && EventsParser.event_map[event_id]) {
        if (!EventsParser.event_map[event_id].tickets) {
          EventsParser.event_map[event_id].tickets = [item];
        } else {
          EventsParser.event_map[event_id].tickets.push(item);
        }
      }
    }
    for (const item of Object.values(ProductsParser.product_map)) {
      const { event_id } = item.product;
      if (event_id && EventsParser.event_map[event_id]) {
        if (!EventsParser.event_map[event_id].products) {
          EventsParser.event_map[event_id].products = [item];
        } else {
          EventsParser.event_map[event_id].products.push(item);
        }
      }
    }
    return Object.values(EventsParser.event_map);
  }
}
let random = (bytes) => crypto.getRandomValues(new Uint8Array(bytes));
let customRandom = (alphabet, defaultSize, getRandom) => {
  let mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
  let step = -~(1.6 * mask * defaultSize / alphabet.length);
  return (size = defaultSize) => {
    let id = "";
    while (true) {
      let bytes = getRandom(step);
      let j = step;
      while (j--) {
        id += alphabet[bytes[j] & mask] || "";
        if (id.length === size)
          return id;
      }
    }
  };
};
let customAlphabet = (alphabet, size = 21) => customRandom(alphabet, size, random);
const sessionIdGenerator = customAlphabet("346789ABCDEFGHJKLMNPQRTUVWXY", 12);
function parsePricing(price) {
  const cents = typeof price === "string" ? parseFloat(price) : price;
  return `${(cents / 100).toFixed(2)}`;
}
class OrderTracking {
  constructor() {
    __publicField(this, "_sessionId");
    __publicField(this, "_containers", {});
    this._sessionId = sessionIdGenerator();
    window.dataLayer = window.dataLayer || [];
    this._push("consent", "default", {
      ad_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
      analytics_storage: "denied"
    });
  }
  /**
   *  The legacy order status page has two entry points for the order.
   *  - A return from payment page
   *  - A linked download page (i.e.: from email)
   *  The payment page is the only page that should trigger the conversion events.
   *  However the download page from the email should still trigger a page view event.
   */
  sendLegacyEventsWithoutConversion() {
    this._contentView();
  }
  sendLegacyEvents(data, order) {
    this._interaction({
      action: "Complete order",
      category: "OrderProcess",
      label: `Payment: ${order.status}`,
      value: parsePricing(order.finn_price)
    });
    for (const event of order.events) {
      const rawPrice = order.conversions.events[event.guid].total;
      this._interaction({
        action: "Completed order for event",
        category: "EventConversion",
        label: `${event.guid}|-|${event.name}`,
        value: parsePricing(rawPrice)
      });
      const { location } = event;
      const dateArr = [];
      try {
        if (event.start) {
          const { start } = event;
          if (typeof start === "string") {
            dateArr.push(start.slice(0, 10));
          } else if (typeof start === "object" && start instanceof Date) {
            dateArr.push(start.toISOString().slice(0, 10));
          }
          if (event.end) {
            const { end } = event;
            if (typeof end === "string") {
              dateArr.push(end.slice(0, 10));
            } else if (typeof end === "object" && end instanceof Date) {
              dateArr.push(end.toISOString().slice(0, 10));
            }
          }
        }
      } catch (e) {
        console.error("[sendLegacyEvents] Failed to parse dates", { e, event });
      }
      let coords = "";
      if (location.latitude) {
        coords += location.latitude;
        if (location.longitude) {
          coords += `,${location.longitude}`;
        }
      }
      this._interaction({
        category: "LocationAttend",
        action: coords,
        label: `${location.address || ""}`,
        value: `${dateArr.join("_")}`
      });
    }
    try {
      this._send({
        event: "event_data",
        events: order.events.map((event) => ({
          guid: event.guid,
          name: event.name,
          currency: event.currency,
          locale: event.locale
        }))
      });
    } catch (e) {
      console.error("[sendLegacyEvents] Failed to send event date", { e });
    }
    this._orderData(data);
    this._purchase(order);
    this._contentView();
  }
  _interaction(event) {
    this._send({
      ...event,
      event: "interaction"
    });
  }
  _contentView() {
    this._send({
      event: "content-view"
    });
  }
  _orderData(data) {
    this._send({
      event: "order_data",
      order: data,
      orderConverions: data.conversions,
      // Typo intended due to legacy code.
      orderId: data.guid,
      shopGuid: data.shop.guid,
      shopName: data.shop.name
    });
  }
  _purchase(order) {
    let eventGuidName = "|-|";
    if (order.events.length) {
      const lastEvent = order.events[order.events.length - 1];
      eventGuidName = lastEvent ? `${lastEvent.guid}|-|${lastEvent.name}` : "|-|";
    }
    const payment = Object.values(order.payment_map)[0];
    if (!payment) {
      return;
    }
    const event = {
      event: "purchase",
      ecommerce: {
        purchase: {
          actionField: {
            id: order.shop.guid,
            affiliation: order.shop.name,
            revenue: parsePricing(order.finn_price),
            action: "purchase",
            step: 2
          },
          products: Object.values(order.ticket_map).map((orderTicket) => {
            let coupon = "";
            for (const product of orderTicket.products) {
              if (product.coupon_code) {
                coupon = product.coupon_code.code;
              }
            }
            return {
              coupon,
              id: orderTicket.ticket.guid,
              name: orderTicket.ticket.name,
              price: parsePricing(orderTicket.finn_price - orderTicket.finn_service_fee),
              quantity: 1
            };
          })
        }
      },
      label: eventGuidName,
      // Added due to overwritten values and legacy GTM containers.
      value: parsePricing(payment.finn_value)
    };
    this._send(event);
  }
  addGTM(code) {
    if (this._containers[code]) {
      return;
    }
    this._containers[code] = code;
    const w = window;
    const d = document;
    const s = "script";
    const l = "dataLayer";
    w[l].push({
      "gtm.start": (/* @__PURE__ */ new Date()).getTime(),
      event: "gtm.js"
    });
    const f = d.getElementsByTagName(s)[0];
    const j = d.createElement(s);
    const dl = "";
    j.async = true;
    j.src = `https://www.googletagmanager.com/gtm.js?id=${code}${dl}`;
    if (f.parentNode) {
      f.parentNode.insertBefore(j, f);
    } else {
      d.head.appendChild(j);
    }
    const noscript = document.createElement("noscript");
    const iframe = document.createElement("iframe");
    iframe.onerror = () => {
      delete this._containers[code];
    };
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${code}`;
    iframe.height = "0";
    iframe.width = "0";
    iframe.style = "display:none;visibility:hidden";
    noscript.appendChild(iframe);
    const { body } = document;
    body.insertBefore(noscript, body.firstChild);
  }
  updateConsent(settings) {
    const { baseAds, personalisedAds } = settings;
    setTimeout(() => {
      const consent = {};
      if (personalisedAds === false) {
        consent.ad_user_data = "denied";
        consent.ad_personalization = "denied";
      }
      if (baseAds === true) {
        consent.ad_storage = "granted";
        consent.analytics_storage = "granted";
        if (personalisedAds === true) {
          consent.ad_user_data = "granted";
          consent.ad_personalization = "granted";
        }
      } else if (baseAds === false) {
        consent.ad_storage = "denied";
        consent.analytics_storage = "denied";
        consent.ad_user_data = "denied";
        consent.ad_personalization = "denied";
      }
      this._push("consent", "update", consent);
    }, 0);
  }
  revokeConsent() {
    setTimeout(() => {
      this._push("consent", "update", {
        ad_storage: "denied",
        ad_user_data: "denied",
        ad_personalization: "denied",
        analytics_storage: "denied"
      });
    }, 0);
  }
  _send(event) {
    if (!window.dataLayer) {
      window.dataLayer = [];
    }
    window.dataLayer.push({
      ...event,
      userId: this._sessionId,
      "content-name": window.location.pathname
    });
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _push(..._) {
    window.dataLayer.push(arguments);
  }
}
const POLL_DELAY = 1e4;
const POLL_TIME = 10 * 60 * 1e3;
const CANCELLED_STATUSES = ["cancelled", "refunded", "expired", "failed"];
const PENDING_STATUSES = ["pending", "verify", "paid decide", "refunding"];
const MAX_TICKETS_ALLOWED_FOR_POLLING = 10;
function isNoLongerRefundableEvent(event) {
  let statusUntil = null;
  if (event.status_until) {
    statusUntil = event.status_until;
  } else if (event.refund_setting && event.refund_setting.status_until) {
    statusUntil = event.refund_setting.status_until;
  }
  if (!statusUntil) {
    console.warn("event has no time limit on refund requests");
    return false;
  }
  if (new Date(statusUntil) < /* @__PURE__ */ new Date()) {
    console.warn("event refund status passed", statusUntil, new Date(statusUntil) < /* @__PURE__ */ new Date(), new Date(statusUntil));
    return true;
  }
  return false;
}
function isRefundableEvent(event) {
  if (!["refunding", "moving"].includes(event.status)) {
    console.warn("not refunding/moving");
    return false;
  }
  let statusUntil = null;
  if (event.status_until) {
    statusUntil = event.status_until;
  } else if (event.refund_setting && event.refund_setting.status_until) {
    statusUntil = event.refund_setting.status_until;
  }
  if (!statusUntil) {
    console.warn("event has no time limit on refund requests");
    return false;
  }
  if (new Date(statusUntil) < /* @__PURE__ */ new Date()) {
    console.warn("event refund status passed", statusUntil, new Date(statusUntil) < /* @__PURE__ */ new Date(), new Date(statusUntil));
    return false;
  }
  return true;
}
function isRefundableProduct(event, orderProduct) {
  if (orderProduct.product.event_id !== event.guid) {
    console.warn("invalid event_id");
    return false;
  }
  return !orderProduct.invalidated_since;
}
function isRefundableTicket(event, orderTicket) {
  if (orderTicket.ticket.event_id !== event.guid) {
    console.warn("invalid event_id");
    return false;
  }
  return !orderTicket.invalidated_since;
}
function orderItemBlocksPaymentReturn(returnItems, item, type) {
  if (item.invalidated_since) {
    return false;
  }
  if (returnItems.find((returnItem) => returnItem.type === type && returnItem.guid === item.guid)) {
    return false;
  }
  return true;
}
class OrderClient {
  constructor(config) {
    __publicField(this, "initialized", false);
    __publicField(this, "data");
    __publicField(this, "validator");
    __publicField(this, "tracking");
    __publicField(this, "logger");
    __publicField(this, "_rawData");
    __publicField(this, "_config");
    __publicField(this, "_http");
    __publicField(this, "_initAt");
    __publicField(this, "_urlUid", 0);
    __publicField(this, "isPolling", false);
    this._http = axios.create();
    this._initAt = /* @__PURE__ */ new Date();
    this.validator = new Validator(config.validatorFn);
    this.tracking = new OrderTracking();
    this.logger = new helpersExports.Logger("order", config);
  }
  async init(config) {
    try {
      if (config.loggingUrl) {
        const output = this.logger.addOutput(helpersExports.ServiceOutput, {
          baseUrl: config.loggingUrl
        });
        if (config.loggingLevel !== void 0) {
          output.setLevel(config.loggingLevel);
        }
      } else {
        this.logger.log(new OrderError("order.errors.init.no_logging_url_provided", "No loggingUrl provided for external logging"));
      }
      this._config = config;
      this._http.defaults.baseURL = urlJoin(this._config.baseUrl, "order");
      const response = await this._http.get(`${this._config.orderGuid}?conversions=1`);
      this._rawData = JSON.parse(JSON.stringify(response.data));
      this.data = OrderParser.parse(response.data);
      this.initialized = true;
      if (config.gtmCode) {
        this.tracking.addGTM(config.gtmCode);
      }
      if (this.data.download_ready) {
        for (const ticket of this.data.tickets) {
          if (!ticket.computed_download_ready) {
            ticket.computed_download_ready = true;
          }
        }
      }
      void this._startPolling(POLL_DELAY);
    } catch (e) {
      this.logger.throw(new OrderError("order.errors.init.failed", `Failed to initialize OrderClient: ${e}`));
    }
  }
  startPolling() {
    void this._startPolling();
  }
  async _startPolling(initialDelay) {
    if (CANCELLED_STATUSES.includes(this.data.status)) {
      return;
    }
    this.isPolling = true;
    if (initialDelay) {
      await new Promise((resolve) => {
        setTimeout(() => {
          resolve();
        }, initialDelay);
      });
    }
    let iterations = Math.ceil(POLL_TIME / POLL_DELAY);
    let shouldPollOrder = this._shouldPollOrder();
    let pollableTickets = this._pollableTickets();
    while (iterations && (shouldPollOrder || pollableTickets.length)) {
      const response = await this._http.get(this._config.orderGuid);
      const order = OrderParser.parse(response.data);
      if (shouldPollOrder) {
        this._updateOrder(order);
        shouldPollOrder = this._shouldPollOrder();
      }
      if (!PENDING_STATUSES.includes(this.data.status)) {
        const promises = pollableTickets.map((ticketGuid) => {
          const newTicket = order.ticket_map[ticketGuid];
          return this._updateTicket(newTicket);
        });
        await Promise.all(promises);
        pollableTickets = this._pollableTickets();
      }
      await new Promise((resolve) => {
        setTimeout(() => {
          resolve();
        }, POLL_DELAY);
      });
      iterations--;
    }
    this.isPolling = false;
  }
  _shouldPollOrder() {
    if (this.data.status === "paid") {
      return !this.data.download_link || !this.data.download_ready;
    }
    return !CANCELLED_STATUSES.includes(this.data.status);
  }
  _pollableTickets() {
    return Object.values(this.data.ticket_map).filter((ticket) => {
      if (ticket.invalidated_since || ticket.retrievable_after) {
        return false;
      }
      return !ticket.is_complete || !ticket.download_link || !ticket.computed_download_ready;
    }).map((ticket) => ticket.guid);
  }
  _updateOrder(order) {
    this.data.status = order.status;
    this.data.download_link = order.download_link;
    if (!this.data.download_ready && order.download_ready) {
      for (const ticket of this.data.tickets) {
        if (!ticket.computed_download_ready) {
          ticket.computed_download_ready = true;
        }
      }
    }
    this.data.download_ready = order.download_ready;
  }
  async _updateTicket(newTicket) {
    const ticket = this.data.ticket_map[newTicket.guid];
    ticket.download_link = newTicket.download_link;
    ticket.is_complete = newTicket.is_complete;
    if (!ticket.is_complete || !ticket.download_link || ticket.computed_download_ready) {
      return;
    }
    if (this.data.tickets.length > MAX_TICKETS_ALLOWED_FOR_POLLING) {
      return;
    }
    try {
      await this._http.head(`${ticket.download_link}`);
      ticket.computed_download_ready = true;
    } catch (e) {
    }
  }
  /**
   *  Compute the payment method info.
   *
   *  For now, only orders with 1 payment can be refunded through the sdk.
   */
  getPaymentMethodInfo() {
    const payments = Object.values(this.data.payment_map);
    if (!payments.length) {
      this.logger.throw(new OrderError(
        "order.errors.refund.without_payment",
        "Cannot refund order without payment"
      ));
    } else if (payments.length !== 1) {
      this.logger.throw(new OrderError(
        "order.errors.refund.with_multiple_payments",
        "Cannot refund order with multiple payments"
      ));
    }
    return {
      currency: payments[0].currency,
      guid: payments[0].payment_method_id
    };
  }
  /**
   *  Compute a set of return items for the given event and list of tickets.
   *
   *  This will check if the event is refundable and
   *  if all tickets and its children (i.e.: products) in the list are refundable.
   */
  getReturnItems(event, tickets, refundSetting) {
    if (!isRefundableEvent(event)) {
      return [];
    }
    const returnItems = [];
    for (const orderTicket of tickets) {
      if (!isRefundableTicket(event, orderTicket)) {
        this.logger.log(new OrderRefundItemError({
          guid: orderTicket.ticket.guid,
          message: `Not refundable ${orderTicket.ticket.name}`,
          name: orderTicket.ticket.name,
          slug: "order.errors.refund.not_refundable",
          type: "ticket"
        }));
        continue;
      }
      for (const orderProduct of orderTicket.products) {
        if (!isRefundableProduct(event, orderProduct)) {
          this.logger.log(new OrderRefundItemError({
            guid: orderProduct.product.guid,
            message: `Not refundable ${orderProduct.product.name}`,
            name: orderProduct.product.name,
            slug: "order.errors.refund.not_refundable",
            type: "product"
          }));
          continue;
        }
        returnItems.push({ guid: orderProduct.guid, type: "product" });
      }
      returnItems.push({ guid: orderTicket.guid, type: "ticket" });
    }
    if (refundSetting.refund_transaction_fees && this.shouldReturnPayments(returnItems)) {
      returnItems.push(...Object.values(this.data.payment_map).map((payment) => ({
        guid: payment.guid,
        type: "payment"
      })));
    }
    return returnItems;
  }
  /**
   *  Request a refund
   *
   *  This requires a set of items to be returned and a linked payout profile.
   */
  async requestRefund(refundSetting, items, toVoucher = false, donatePercentage = 0) {
    const logData = {
      donatePercentage,
      items,
      refundSetting,
      toVoucher
    };
    this.logger.log(new OrderRefundMessage("order.refund.about_to_request", logData));
    const orderBuilderOptions = {
      booker: {
        email: this.data.email,
        firstname: this.data.firstName,
        lastname: this.data.lastName,
        locale: this.data.locale
      },
      items,
      includesFees: refundSetting.refund_fees,
      initAt: this._initAt,
      paymentMethod: this.getPaymentMethodInfo(),
      orderId: this.data.guid,
      toVoucher,
      reason: "return by visitor"
    };
    if (!refundSetting.refundable_by_voucher) {
      orderBuilderOptions.toVoucher = false;
    } else if (!refundSetting.refundable_by_payment) {
      orderBuilderOptions.toVoucher = true;
    }
    if (refundSetting.refund_donate_enabled && donatePercentage) {
      orderBuilderOptions.donatePercentage = donatePercentage;
    }
    try {
      const response = await handleRefund({
        baseUrl: this._config.baseUrl,
        getNoCacheUrl: (url) => this._getNoCacheUrl(url),
        httpClient: this._http,
        shopId: this.data.shop_id
      }, orderBuilderOptions);
      logData.refundAmount = response.amount;
      logData.refundOrderId = response.order_id;
      logData.refundRedirectUrl = response.redirectUrl;
      this.logger.log(new OrderRefundMessage("order.refund.success", logData));
      return response;
    } catch (e) {
      if (OrderRefundError.is(e)) {
        this.logger.throw(e);
      }
      this.logger.throw(new UnknownOrderError("order.errors.refund.unknown", "Refund handling failed", e));
    }
    return Promise.reject();
  }
  /**
   *  Determine if the payment should also be returned.
   *
   *  This is the case iff all tickets (including its products) and global products
   *  are already invalidated or are currently being returned.
   */
  shouldReturnPayments(items) {
    for (const orderTicketId in this.data.ticket_map) {
      if (!Object.prototype.hasOwnProperty.call(this.data.ticket_map, orderTicketId)) {
        continue;
      }
      const orderTicket = this.data.ticket_map[orderTicketId];
      if (orderItemBlocksPaymentReturn(items, orderTicket, "ticket")) {
        return false;
      }
      for (const orderProduct of orderTicket.products) {
        if (orderItemBlocksPaymentReturn(items, orderProduct, "product")) {
          return false;
        }
      }
    }
    for (const globalProduct of this.data.global_products) {
      if (orderItemBlocksPaymentReturn(items, globalProduct, "product")) {
        return false;
      }
    }
    return true;
  }
  async saveTicketMetadata(ticket) {
    const metadata = Array.from(ticket.metadata);
    for (const product of ticket.products) {
      metadata.push(...product.metadata);
    }
    const response = await this._saveMetadata(metadata, ticket.guid, "ticket");
    if (response.order) {
      const updatedTicket = response.order.tickets.find((t) => t.guid === ticket.guid);
      if (updatedTicket) {
        ticket.is_complete = !!updatedTicket.is_complete;
        ticket.download_link = updatedTicket.download_link ? updatedTicket.download_link : null;
      }
    }
    return response.personalize;
  }
  async _saveMetadata(metadata, guid, type) {
    this.validateMetadata(metadata);
    function isEmptyArray(value) {
      return !!value && Array.isArray(value) && !value.length;
    }
    const data = {
      // TODO: Invites are not supported for now, this will be implemented separately
      //  Note invites are currently getting a small change in API (2021-06-21)
      send_email: false,
      values: metadata.filter((m) => m.is_required || m.value !== null && m.value !== "" && !isEmptyArray(m.value)).map((m) => ({
        metadata_id: m.item.guid,
        order_metadata_id: m.guid,
        value: m.value
      }))
    };
    const personalizeResponse = (await this._http.put(`${this._config.baseUrl}/personalize/${type}/${guid}`, data)).data;
    if (personalizeResponse.errors.length) {
      return { personalize: personalizeResponse };
    }
    const orderResponse = (await this._http.get(`${this._config.orderGuid}`)).data;
    if (orderResponse.is_complete) {
      this.data.is_complete = true;
      this.data.download_link = orderResponse.download_link ? orderResponse.download_link : null;
      this.data.download_ready = orderResponse.download_ready;
    }
    return {
      order: orderResponse,
      personalize: personalizeResponse
    };
  }
  /**
   * Throws a FormValidationError if the metadata is considered incorrect by the validator.
   * @param metadata
   * @throws FormValidationError
   */
  validateMetadata(metadata) {
    const errors = {};
    for (const meta of metadata) {
      const validation = this.validator.metadata(meta, true);
      if (!validation.valid) {
        errors[meta.item.name] = validation.message;
      }
    }
    if (Object.keys(errors).length) {
      this.logger.throw(new helpersExports.FormValidationError({
        slug: "order.errors.metadata.validation.failed",
        messages: errors
      }));
    }
  }
  // eslint-disable-next-line @typescript-eslint/require-await
  async sendInvite() {
    throw new Error("Invites currently disabled");
  }
  sendLegacyEvents() {
    if (!this.initialized) {
      this.logger.throw(new OrderError("order.errors.tracking.conversion.initialized", "Failed to send legacy tracking events. Cannot track anything before order client initialization."));
    }
    try {
      this.tracking.sendLegacyEvents(this._rawData, this.data);
    } catch (e) {
      this.logger.throw(new OrderError("order.errors.tracking.conversion.failed", "Failed to send legacy tracking events"));
    }
  }
  sendLegacyEventsWithoutConversion() {
    if (!this.initialized) {
      this.logger.throw(new OrderError("order.errors.tracking.noconversion.initialized", "Failed to send legacy tracking events without conversion. Cannot track anything before order client initialization."));
    }
    try {
      this.tracking.sendLegacyEventsWithoutConversion();
    } catch (e) {
      this.logger.throw(new OrderError("order.errors.tracking.noconversion.failed", "Failed to send legacy tracking events without conversion"));
    }
  }
  _getNoCacheUrl(url) {
    const noCacheNonce = `?${(/* @__PURE__ */ new Date()).getTime()}-${++this._urlUid}-${Math.floor(Math.random() * 1e9)}`;
    return urlJoin(url, noCacheNonce);
  }
}
export {
  OrderClient,
  isNoLongerRefundableEvent,
  isRefundableEvent,
  isRefundableProduct,
  isRefundableTicket
};
//# sourceMappingURL=ot-order.js.map
